import * as d from "react";
import C, { useEffect as B, useRef as We, useMemo as ce, useCallback as $, useState as Ce, Suspense as Gi } from "react";
import { A as Ki, C as Yi, D as Qi, E as Yn, G as Xi, I as $e, T as Ji, J as eo, K as to, L as no, n as H, O as hn, P as u2, s as Ne, Q as Y, R as i1, U as ro, W as ao, X as io, Y as oo, Z as so, _ as lo, $ as co, a0 as ye, a1 as je } from "./index-iS6jagGA.mjs";
import { a as ue, f as X } from "./variables-Dk8C4tiG.mjs";
import { u as q, s as uo, c as fo, P as ae } from "./contexts-mE7hZUKx.mjs";
import { Popover as po, CircularProgress as mo, IconButton as Cn, Drawer as go, Popper as ho, Tooltip as Co, tooltipClasses as Qn, ClickAwayListener as vo, Fade as yo, ThemeProvider as bo } from "@mui/material";
import { t as F } from "./breakpoints-DvaoDEis.mjs";
import { u as Ie } from "./hooks-BC9ZhfBc.mjs";
import vn from "axios";
import { g as f1 } from "./environment-CzIowm8J.mjs";
import { u as wo, s as ko, r as yn, a as d2, b as f2, c as p2, d as m2, e as bn, f as p1, h as Ge, j as wn, k as xo, l as Eo, n as kn, o as g2, p as h2, q as Se, t as _o, v as C2, w as Ho, x as xn, y as m1, z as So, B as To, C as Ao, D as Po, M as Lo } from "./component-Cu96A-VJ.mjs";
import { readInlineData as o1, useRelayEnvironment as v2, fetchQuery as y2, useLazyLoadQuery as Vo } from "react-relay";
import { getRequest as Mo, createOperationDescriptor as Ro } from "relay-runtime";
import { e as Te, c as ie, f as Oo, b as qo, d as Io } from "./tracking-impression-event-CyOrEGg0.mjs";
import { v as W, w as te, x as Do, y as Bo, z as b2, A as Fo, B as $o, n as Uo, f as zo, k as g1, u as Xn } from "./index-ByKJWKwE.mjs";
import { e as Zo, f as Wo, u as w2 } from "./index-BqI2IZQT.mjs";
import { u as Ke } from "./index-DH8aHDrB.mjs";
import { Z as h1, t as k2 } from "./z-index-BZHKPrxU.mjs";
import { i as No } from "./const-BlLLRlwg.mjs";
import jo from "@emotion/styled";
import { css as De } from "@emotion/react";
import Go, { bindTrigger as Ko, bindPopover as Yo } from "material-ui-popup-state";
import { WhatsappShareButton as Qo, TwitterShareButton as Xo, TelegramShareButton as Jo, FacebookShareButton as e6, EmailShareButton as t6 } from "react-share";
import { useCopyToClipboard as n6 } from "react-use";
import * as r6 from "react-dom";
function a6(e, t, n = Zo, r = B, ...a) {
  const i = We(void 0);
  (i.current === void 0 || No && !n(i.current, t)) && (i.current = t), r(e, i.current, ...a);
}
function x2(e, t, n = B, ...r) {
  a6(e, t, Ki, n, ...r);
}
const _1 = Map.prototype;
function i6(e) {
  const t = We(void 0), n = wo();
  if (!t.current) {
    const r = new Map(e);
    t.current = r, r.set = (...a) => (_1.set.apply(r, a), n(), r), r.clear = (...a) => {
      _1.clear.apply(r, a), n();
    }, r.delete = (...a) => {
      const i = _1.delete.apply(r, a);
      return n(), i;
    };
  }
  return t.current;
}
let o6 = {};
function C1() {
  return o6;
}
function Ue(e, t) {
  var s, l, c, u;
  const n = C1(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = W(e, t == null ? void 0 : t.in), i = a.getDay(), o = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function s1(e, t) {
  return Ue(e, { ...t, weekStartsOn: 1 });
}
function E2(e, t) {
  const n = W(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = te(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = s1(a), o = te(n, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const s = s1(o);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function Jn(e) {
  const t = W(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function _2(e, ...t) {
  const n = te.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function l1(e, t) {
  const n = W(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function s6(e, t, n) {
  const [r, a] = _2(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = l1(r), o = l1(a), s = +i - Jn(i), l = +o - Jn(o);
  return Math.round((s - l) / Do);
}
function l6(e, t) {
  const n = E2(e, t), r = te(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), s1(r);
}
function H2(e) {
  return te(e, Date.now());
}
function S2(e, t, n) {
  const [r, a] = _2(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +l1(r) == +l1(a);
}
function c6(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function u6(e, t) {
  return +W(e) - +W(t);
}
function d6(e, t, n) {
  const r = u6(e, t) / Bo;
  return c6(n == null ? void 0 : n.roundingMethod)(r);
}
function f6(e, t) {
  const n = W(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const p6 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, m6 = (e, t, n) => {
  let r;
  const a = p6[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function H1(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const g6 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, h6 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, C6 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, v6 = {
  date: H1({
    formats: g6,
    defaultWidth: "full"
  }),
  time: H1({
    formats: h6,
    defaultWidth: "full"
  }),
  dateTime: H1({
    formats: C6,
    defaultWidth: "full"
  })
}, y6 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, b6 = (e, t, n, r) => y6[e];
function Le(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const w6 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, k6 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, x6 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, E6 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, _6 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, H6 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, S6 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, T6 = {
  ordinalNumber: S6,
  era: Le({
    values: w6,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: k6,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Le({
    values: x6,
    defaultWidth: "wide"
  }),
  day: Le({
    values: E6,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: _6,
    defaultWidth: "wide",
    formattingValues: H6,
    defaultFormattingWidth: "wide"
  })
};
function Ve(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? P6(s, (f) => f.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      A6(s, (f) => f.test(o))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(o.length);
    return { value: c, rest: u };
  };
}
function A6(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function P6(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function L6(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
const V6 = /^(\d+)(th|st|nd|rd)?/i, M6 = /\d+/i, R6 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, O6 = {
  any: [/^b/i, /^(a|c)/i]
}, q6 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, I6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, D6 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, B6 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, F6 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $6 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, U6 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, z6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Z6 = {
  ordinalNumber: L6({
    matchPattern: V6,
    parsePattern: M6,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ve({
    matchPatterns: R6,
    defaultMatchWidth: "wide",
    parsePatterns: O6,
    defaultParseWidth: "any"
  }),
  quarter: Ve({
    matchPatterns: q6,
    defaultMatchWidth: "wide",
    parsePatterns: I6,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ve({
    matchPatterns: D6,
    defaultMatchWidth: "wide",
    parsePatterns: B6,
    defaultParseWidth: "any"
  }),
  day: Ve({
    matchPatterns: F6,
    defaultMatchWidth: "wide",
    parsePatterns: $6,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ve({
    matchPatterns: U6,
    defaultMatchWidth: "any",
    parsePatterns: z6,
    defaultParseWidth: "any"
  })
}, W6 = {
  code: "en-US",
  formatDistance: m6,
  formatLong: v6,
  formatRelative: b6,
  localize: T6,
  match: Z6,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function N6(e, t) {
  const n = W(e, t == null ? void 0 : t.in);
  return s6(n, f6(n)) + 1;
}
function j6(e, t) {
  const n = W(e, t == null ? void 0 : t.in), r = +s1(n) - +l6(n);
  return Math.round(r / b2) + 1;
}
function T2(e, t) {
  var u, f, g, p;
  const n = W(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = C1(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (g = a.locale) == null ? void 0 : g.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = te((t == null ? void 0 : t.in) || e, 0);
  o.setFullYear(r + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Ue(o, t), l = te((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Ue(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function G6(e, t) {
  var s, l, c, u;
  const n = C1(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = T2(e, t), i = te((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), Ue(i, t);
}
function K6(e, t) {
  const n = W(e, t == null ? void 0 : t.in), r = +Ue(n, t) - +G6(n, t);
  return Math.round(r / b2) + 1;
}
function O(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const le = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return O(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : O(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return O(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return O(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return O(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return O(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return O(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return O(a, t.length);
  }
}, we = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, er = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return le.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = T2(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return O(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : O(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = E2(e);
    return O(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return O(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return O(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return O(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return le.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return O(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = K6(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : O(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = j6(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : O(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : le.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = N6(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : O(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return O(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return O(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return O(a, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = we.noon : r === 0 ? a = we.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = we.evening : r >= 12 ? a = we.afternoon : r >= 4 ? a = we.morning : a = we.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return le.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : le.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : O(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : O(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : le.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : le.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return le.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return nr(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ge(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ge(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return nr(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ge(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ge(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + tr(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ge(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + tr(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ge(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return O(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return O(+e, t.length);
  }
};
function tr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + t + O(i, 2);
}
function nr(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + O(Math.abs(e) / 60, 2) : ge(e, t);
}
function ge(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = O(Math.trunc(r / 60), 2), i = O(r % 60, 2);
  return n + a + t + i;
}
const rr = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, A2 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Y6 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return rr(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", rr(r, t)).replace("{{time}}", A2(a, t));
}, Q6 = {
  p: A2,
  P: Y6
}, X6 = /^D+$/, J6 = /^Y+$/, es = ["D", "DD", "YY", "YYYY"];
function ts(e) {
  return X6.test(e);
}
function ns(e) {
  return J6.test(e);
}
function rs(e, t, n) {
  const r = as(e, t, n);
  if (console.warn(r), es.includes(e)) throw new RangeError(r);
}
function as(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const is = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, os = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ss = /^'([^]*?)'?$/, ls = /''/g, cs = /[a-zA-Z]/;
function P2(e, t, n) {
  var u, f, g, p;
  const r = C1(), a = r.locale ?? W6, i = r.firstWeekContainsDate ?? ((f = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, o = r.weekStartsOn ?? ((p = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : p.weekStartsOn) ?? 0, s = W(e, n == null ? void 0 : n.in);
  if (!Fo(s))
    throw new RangeError("Invalid time value");
  let l = t.match(os).map((v) => {
    const m = v[0];
    if (m === "p" || m === "P") {
      const h = Q6[m];
      return h(v, a.formatLong);
    }
    return v;
  }).join("").match(is).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const m = v[0];
    if (m === "'")
      return { isToken: !1, value: us(v) };
    if (er[m])
      return { isToken: !0, value: v };
    if (m.match(cs))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + m + "`"
      );
    return { isToken: !1, value: v };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return l.map((v) => {
    if (!v.isToken) return v.value;
    const m = v.value;
    (ns(m) || ts(m)) && rs(m, t, String(e));
    const h = er[m[0]];
    return h(s, m, a.localize, c);
  }).join("");
}
function us(e) {
  const t = e.match(ss);
  return t ? t[1].replace(ls, "'") : e;
}
function an(e) {
  return Math.trunc(+W(e) / 1e3);
}
function ds(e, t) {
  return S2(
    te(e, e),
    H2(e)
  );
}
function fs(e, t, n) {
  return $o(e, -1, n);
}
function ps(e, t) {
  return S2(
    te(e, e),
    fs(H2(e))
  );
}
function ms(e, t) {
  return jo(e, t);
}
function gs(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const ar = [];
function ir(e) {
  return ar[0] = e, Yi(ar);
}
const or = (e) => e, hs = () => {
  let e = or;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = or;
    }
  };
}, Cs = hs();
function L2(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = L2(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function on() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = L2(e)) && (r && (r += " "), r += t);
  return r;
}
const V2 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function M2(e, t, n = "Mui") {
  const r = V2[t];
  return r ? `${n}-${r}` : `${Cs.generate(e)}-${t}`;
}
function vs(e, t, n = "Mui") {
  const r = {};
  return t.forEach((a) => {
    r[a] = M2(e, a, n);
  }), r;
}
function R2(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: ir(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((a) => {
    typeof a.style != "function" && (a.style = ir(a.style));
  }), r;
}
const ys = Qi();
function S1(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function bs(e) {
  return e ? (t, n) => n[e] : null;
}
function ws(e, t, n) {
  e.theme = Es(e.theme) ? n : e.theme[t] || e.theme;
}
function r1(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => r1(e, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: a,
        ...i
      } = n;
      r = i;
    }
    return O2(e, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function O2(e, t, n = []) {
  var a;
  let r;
  e: for (let i = 0; i < t.length; i += 1) {
    const o = t[i];
    if (typeof o.props == "function") {
      if (r ?? (r = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !o.props(r))
        continue;
    } else
      for (const s in o.props)
        if (e[s] !== o.props[s] && ((a = e.ownerState) == null ? void 0 : a[s]) !== o.props[s])
          continue e;
    typeof o.style == "function" ? (r ?? (r = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(o.style(r))) : n.push(o.style);
  }
  return n;
}
function ks(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = ys,
    rootShouldForwardProp: r = S1,
    slotShouldForwardProp: a = S1
  } = e;
  function i(s) {
    ws(s, t, n);
  }
  return (s, l = {}) => {
    gs(s, (k) => k.filter((x) => x !== Yn));
    const {
      name: c,
      slot: u,
      skipVariantsResolver: f,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: p = bs(Hs(u)),
      ...v
    } = l, m = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      u && u !== "Root" && u !== "root" || !1
    ), h = g || !1;
    let b = S1;
    u === "Root" || u === "root" ? b = r : u ? b = a : _s(s) && (b = void 0);
    const w = ms(s, {
      shouldForwardProp: b,
      label: xs(),
      ...v
    }), E = (k) => {
      if (k.__emotion_real === k)
        return k;
      if (typeof k == "function")
        return function(_) {
          return r1(_, k);
        };
      if (Xi(k)) {
        const x = R2(k);
        return x.variants ? function(P) {
          return r1(P, x);
        } : x.style;
      }
      return k;
    }, y = (...k) => {
      const x = [], _ = k.map(E), P = [];
      if (x.push(i), c && p && P.push(function(V) {
        var M, D;
        const R = (D = (M = V.theme.components) == null ? void 0 : M[c]) == null ? void 0 : D.styleOverrides;
        if (!R)
          return null;
        const I = {};
        for (const Z in R)
          I[Z] = r1(V, R[Z]);
        return p(V, I);
      }), c && !m && P.push(function(V) {
        var I, M;
        const T = V.theme, R = (M = (I = T == null ? void 0 : T.components) == null ? void 0 : I[c]) == null ? void 0 : M.variants;
        return R ? O2(V, R) : null;
      }), h || P.push(Yn), Array.isArray(_[0])) {
        const S = _.shift(), V = new Array(x.length).fill(""), T = new Array(P.length).fill("");
        let R;
        R = [...V, ...S, ...T], R.raw = [...V, ...S.raw, ...T], x.unshift(R);
      }
      const A = [...x, ..._, ...P], L = w(...A);
      return s.muiName && (L.muiName = s.muiName), L;
    };
    return w.withConfig && (y.withConfig = w.withConfig), y;
  };
}
function xs(e, t) {
  return void 0;
}
function Es(e) {
  for (const t in e)
    return !1;
  return !0;
}
function _s(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Hs(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function sn(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const a = r;
      if (a === "components" || a === "slots")
        n[a] = {
          ...e[a],
          ...n[a]
        };
      else if (a === "componentsProps" || a === "slotProps") {
        const i = e[a], o = t[a];
        if (!o)
          n[a] = i || {};
        else if (!i)
          n[a] = o;
        else {
          n[a] = {
            ...o
          };
          for (const s in i)
            if (Object.prototype.hasOwnProperty.call(i, s)) {
              const l = s;
              n[a][l] = sn(i[l], o[l]);
            }
        }
      } else n[a] === void 0 && (n[a] = e[a]);
    }
  return n;
}
const c1 = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
function sr(e) {
  return e && e.ownerDocument || document;
}
function lr(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Ss({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: a
  } = d.useRef(e !== void 0), [i, o] = d.useState(t), s = a ? e : i, l = d.useCallback((c) => {
    a || o(c);
  }, []);
  return [s, l];
}
function cr(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return !1;
}
function En(e, t, n = void 0) {
  const r = {};
  for (const a in e) {
    const i = e[a];
    let o = "", s = !0;
    for (let l = 0; l < i.length; l += 1) {
      const c = i[l];
      c && (o += (s === !0 ? "" : " ") + t(c), s = !1, n && n[c] && (o += " " + n[c]));
    }
    r[a] = o;
  }
  return r;
}
function Ts(e) {
  return typeof e == "string";
}
function As(e, t, n) {
  return e === void 0 || Ts(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function Ps(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function ur(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function Ls(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: a,
    className: i
  } = e;
  if (!t) {
    const p = on(n == null ? void 0 : n.className, i, a == null ? void 0 : a.className, r == null ? void 0 : r.className), v = {
      ...n == null ? void 0 : n.style,
      ...a == null ? void 0 : a.style,
      ...r == null ? void 0 : r.style
    }, m = {
      ...n,
      ...a,
      ...r
    };
    return p.length > 0 && (m.className = p), Object.keys(v).length > 0 && (m.style = v), {
      props: m,
      internalRef: void 0
    };
  }
  const o = Ps({
    ...a,
    ...r
  }), s = ur(r), l = ur(a), c = t(o), u = on(c == null ? void 0 : c.className, n == null ? void 0 : n.className, i, a == null ? void 0 : a.className, r == null ? void 0 : r.className), f = {
    ...c == null ? void 0 : c.style,
    ...n == null ? void 0 : n.style,
    ...a == null ? void 0 : a.style,
    ...r == null ? void 0 : r.style
  }, g = {
    ...c,
    ...n,
    ...l,
    ...s
  };
  return u.length > 0 && (g.className = u), Object.keys(f).length > 0 && (g.style = f), {
    props: g,
    internalRef: c.ref
  };
}
function Vs(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Re(e) {
  var f;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: a = !1,
    ...i
  } = e, o = a ? {} : Vs(n, r), {
    props: s,
    internalRef: l
  } = Ls({
    ...i,
    externalSlotProps: o
  }), c = $e(l, o == null ? void 0 : o.ref, (f = e.additionalProps) == null ? void 0 : f.ref);
  return As(t, {
    ...s,
    ref: c
  }, r);
}
const Ms = /* @__PURE__ */ d.createContext(void 0);
function Rs(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const a = t.components[n];
  return a.defaultProps ? sn(a.defaultProps, r) : !a.styleOverrides && !a.variants ? sn(a, r) : r;
}
function Os({
  props: e,
  name: t
}) {
  const n = d.useContext(Ms);
  return Rs({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const dr = {
  theme: void 0
};
function qs(e) {
  let t, n;
  return function(a) {
    let i = t;
    return (i === void 0 || a.theme !== n) && (dr.theme = a.theme, i = R2(e(dr)), t = i, n = a.theme), i;
  };
}
function Is(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Ds = (e) => Is(e) && e !== "classes", Bs = ks({
  themeId: Ji,
  defaultTheme: eo,
  rootShouldForwardProp: Ds
}), Fs = () => /* @__PURE__ */ C.createElement(to, {
  "data-qa": "article-20-theme-sign-up-button-display"
}, /* @__PURE__ */ C.createElement(no, null), "GET OUR NEWSLETTER");
Fs.displayName = "Article20ThemeSignUpButtonDisplay";
const $s = /* @__PURE__ */ H("span", {
  target: "erbhhn31"
})("color:#4585ff;font-weight:700;font-size:12px;font-family:", ue, ';text-transform:uppercase;&:after{content:"|";margin-inline:6px;color:#000000;}'), Us = /* @__PURE__ */ H("span", {
  target: "erbhhn30"
})("color:#000000;font-weight:700;font-size:12px;font-family:", ue, ";text-transform:uppercase;"), zs = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = hn();
  return /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement($s, null, "NEWSLETTER"), /* @__PURE__ */ C.createElement(Us, null, t == null || (e = t.summary) === null || e === void 0 ? void 0 : e.text));
};
zs.displayName = "Article20ThemeSummary";
const Zs = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 60, height: 51, viewBox: "0 0 60 51", fill: "none", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_3254_37968)" }, /* @__PURE__ */ d.createElement("rect", { width: 60, height: 51, rx: 6, fill: "url(#paint0_linear_3254_37968)" }), /* @__PURE__ */ d.createElement("path", { d: "M0.276732 19.0391L-1 18.6714V20V51V52H0H60H61V51V20V18.6714L59.7233 19.0391L30 27.5987L0.276732 19.0391Z", fill: "#FFCA05", stroke: "white", strokeWidth: 2 })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_3254_37968", x1: 30, y1: 0, x2: 30, y2: 31.875, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#FFCA05" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "white" })), /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_3254_37968" }, /* @__PURE__ */ d.createElement("rect", { width: 60, height: 51, rx: 8, fill: "white" })))), Ws = (e) => /* @__PURE__ */ d.createElement("svg", { width: 154, height: 24, viewBox: "0 0 154 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1909 3.64817C11.52 4.83676 11.6844 6.3637 11.6844 8.22859H7.07678V6.11617C7.07678 5.55023 6.99861 5.11073 6.84343 4.79998C6.68786 4.48923 6.40891 4.33366 6.00697 4.33366C5.11073 4.33366 4.6628 4.91914 4.6628 6.08896V17.499C4.6628 18.2125 4.75438 18.752 4.93715 19.1179C5.11993 19.4838 5.43987 19.6662 5.897 19.6662C6.35412 19.6662 6.67407 19.4838 6.85722 19.1179C7.03961 18.752 7.13157 18.2125 7.13157 17.499V14.126H5.86979V10.0663H11.6296V23.7807H9.73713L8.94167 21.8059C8.10023 23.2688 6.80243 23.9999 5.04674 23.9999C3.34623 23.9999 2.07985 23.4014 1.24799 22.2036C0.41574 21.0058 0 19.1911 0 16.7591V6.61046C0 4.43482 0.484328 2.78872 1.45375 1.67331C2.42279 0.55828 3.86734 0 5.78741 0C7.34155 0 8.54854 0.311135 9.40799 0.933021C10.2671 1.55452 10.8617 2.45957 11.1909 3.64817ZM13.4941 0.219727H18.2117V19.776H23.0665V23.7805H13.4941V0.219727ZM31.0753 17.5815C31.0753 18.2402 31.0021 18.7521 30.8558 19.118C30.7094 19.4839 30.4259 19.6659 30.0055 19.6659C29.5664 19.6659 29.2648 19.4927 29.1005 19.1452C28.9357 18.798 28.8533 18.2857 28.8533 17.6091V6.11625C28.8533 4.92842 29.2468 4.33374 30.0331 4.33374C30.4534 4.33374 30.732 4.49391 30.8696 4.81385C31.0067 5.13418 31.0753 5.55031 31.0753 6.06222V17.5815ZM30.0054 0C28.1034 0 26.6592 0.51728 25.6714 1.54993C24.6843 2.58295 24.1904 4.1141 24.1904 6.14376V17.3626C24.1904 19.4651 24.6843 21.097 25.6714 22.258C26.6592 23.4198 28.1034 23.9999 30.0054 23.9999C31.9067 23.9999 33.3517 23.424 34.3391 22.2718C35.3265 21.12 35.8204 19.4838 35.8204 17.3626V6.14376C35.8204 4.1141 35.3265 2.58295 34.3391 1.54993C33.3517 0.51728 31.9067 0 30.0054 0ZM42.7868 19.6387C44.0118 19.6387 44.6249 19.054 44.6249 17.8834V14.9484C44.6249 14.2353 44.5195 13.6962 44.3096 13.3302C44.0988 12.9647 43.7287 12.7819 43.1984 12.7819H42.3209V19.6115L42.7868 19.6387ZM43.3079 3.84021H42.3209V9.07892H43.2807C43.6827 9.07892 43.957 8.92795 44.1034 8.62601C44.2498 8.32484 44.323 7.89952 44.323 7.35082V4.99164C44.323 4.22415 43.9842 3.84021 43.3079 3.84021ZM49.0134 6.63766C49.0134 8.88688 48.2083 10.2307 46.5994 10.6698C47.5868 10.9257 48.2819 11.52 48.6842 12.4523C49.0862 13.3853 49.2873 14.6191 49.2873 16.1549C49.2873 18.6604 48.9122 20.5575 48.1627 21.8469C47.4128 23.1355 46.0599 23.7807 44.1034 23.7807H37.7125V0.219556H44.1034C45.8223 0.219556 47.0703 0.64066 47.8474 1.48134C48.6244 2.3224 49.0134 3.69376 49.0134 5.59544V6.63766ZM55.4313 16.2102L56.3092 4.22422H56.5287L57.571 16.2102H55.4313ZM52.4965 0.22002L50.2201 23.7808H54.8009L55.0749 19.9679H57.9276L58.2567 23.7808H62.7276L60.4784 0.22002H52.4965ZM64.1537 0.219727H68.8713V19.776H73.7261V23.7805H64.1537V0.219727ZM78.5473 23.7804H83.1001V0.21958H78.5473V23.7804ZM92.1784 0.21958L94.1532 14.5919L96.1281 0.21958H103.369V23.7804H99.0628V6.80207L96.3476 23.7804H92.1236L89.2437 6.80207V23.7804H84.992V0.21958H92.1784ZM112.133 8.98287C112.051 9.376 111.877 9.67756 111.612 9.88754C111.346 10.0983 110.93 10.2037 110.364 10.2037H110.089V4.49824H110.61C111.269 4.49824 111.708 4.7178 111.927 5.15653C112.146 5.59526 112.256 6.30872 112.256 7.29577C112.256 8.02763 112.215 8.58974 112.133 8.98287ZM115.712 2.04362C114.908 0.827818 113.564 0.219727 111.68 0.219727H105.454V23.7805H110.09V14.4545H112.01C113.856 14.4545 115.136 13.8606 115.85 12.672C116.563 11.4834 116.919 9.71891 116.919 7.37812C116.919 5.03771 116.517 3.25942 115.712 2.04362ZM122.878 4.22422L122 16.2102H124.14L123.098 4.22422H122.878ZM116.788 23.7808L119.066 0.22002H127.047L129.296 23.7808H124.825L124.496 19.9679H121.644L121.37 23.7808H116.788ZM137.415 17.8835C137.415 19.0728 137.049 19.666 136.317 19.666C135.951 19.666 135.677 19.525 135.495 19.2414C135.312 18.9579 135.22 18.5054 135.22 17.8835V6.06191C135.22 5.4952 135.298 5.06566 135.454 4.77292C135.609 4.48056 135.897 4.33381 136.317 4.33381C136.72 4.33381 137.003 4.46217 137.168 4.71813C137.332 4.97447 137.415 5.4404 137.415 6.11632V9.6001H142.105V5.54041C142.105 3.7487 141.574 2.37734 140.514 1.42669C139.454 0.476044 138.055 0.000146484 136.317 0.000146484C134.324 0.000146484 132.861 0.594827 131.929 1.78266C130.997 2.97202 130.53 4.73575 130.53 7.07692V17.9387C130.53 19.8223 131.047 21.3029 132.08 22.3815C133.112 23.4613 134.488 24 136.208 24C140.175 24 142.16 22.0252 142.16 18.0751V13.6322H137.415V17.8835ZM145.753 4.74482H142.955V0.21958H153.268V4.74482H150.47V23.7807H145.753V4.74482Z", fill: "#001246" })), Ns = (e) => /* @__PURE__ */ d.createElement("svg", { width: 108, height: 25, viewBox: "0 0 108 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_40345)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.855469V1.59582H2.9687V23.3497H0V24.0901H2.9687H19.668V19.5134H18.3543V23.3497H9.53687V1.59582H12.5061V0.855469H0Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.3869 23.3492V13.1913C65.3869 7.14114 62.2327 5.97756 58.7445 5.97756C56.4436 5.97756 54.5881 6.52053 52.3986 8.03312V6.21206L44.0229 6.21367V6.95018H45.8309L45.8304 23.3492H43.975V24.0896H45.8304H54.2542V23.3492H52.3986V8.96134C53.9572 7.83658 55.4045 7.2549 56.7405 6.9833C58.8559 7.21597 58.8186 10.3602 58.8186 12.8423V23.3492H56.9631V24.0896H58.8186H65.09H67.2425V23.3492H65.3869ZM40.9727 23.3492V6.21034H40.6757L40.6725 6.21367H34.4821V6.21034H32.5938V6.95029H34.4049L34.4043 21.3386C32.8457 22.4633 31.3985 23.045 30.0626 23.3164C27.9473 23.0839 27.9844 19.9397 27.9844 17.4575V6.21034H27.9784V6.21367H19.6063V6.95029H21.4138L21.416 17.1084C21.416 23.1588 24.5704 24.3225 28.0588 24.3225C30.3593 24.3225 32.2149 23.7793 34.4043 22.2668V24.0896H37.0021H42.8281V23.3492H40.9727ZM78.2677 21.2196C74.3341 22.5771 73.3322 20.5215 73.3322 19.0088C73.3322 15.7123 77.2285 14.2359 78.2677 12.2967V21.2196ZM84.836 23.3493V14.9755C84.836 8.1494 81.6446 6.21027 76.8946 6.21027H75.9669C74.9147 6.2121 74.1451 6.31038 74.1451 6.31038C71.7914 6.59229 70.6794 7.12882 70.2099 7.4417C69.2997 8.00586 68.6892 9.04246 68.6892 10.2285C68.6892 12.0169 70.0763 13.4668 71.7875 13.4668C72.7299 13.4668 73.5734 13.0264 74.1416 12.3326C72.8076 12.1121 71.7875 10.9051 71.7875 9.44888C71.7875 8.00758 72.7871 7.35138 74.1011 7.11333C74.1051 7.11237 74.1086 7.11108 74.1128 7.11032C74.8005 6.99807 75.7037 6.99119 76.527 7.06871C76.5722 7.07291 76.8257 7.10839 76.8625 7.12172C78.2365 7.46256 78.2677 8.63807 78.2677 10.6704C77.7852 15.1693 67.506 13.618 67.506 20.2499C67.506 23.4689 69.8438 24.3223 71.7736 24.3223C74.4455 24.3223 77.1544 22.5771 78.2677 21.7238V24.0895H84.5391H86.6915V23.3493H84.836ZM106.294 7.487C106.294 4.92727 104.661 3.37598 101.915 3.37598C99.6141 3.37598 98.1295 3.91884 95.9402 5.43154V3.60876H95.6435C93.194 6.2459 89.9658 6.51749 87.5165 6.51749V7.25777C88.0732 7.25777 88.704 7.25777 89.3718 7.18024V23.3492H87.5165V24.0896H89.3718H97.7957V23.3492H95.9402V6.35965C96.5919 5.89001 97.1887 5.50627 97.7562 5.20736C97.7625 5.20424 97.769 5.20037 97.7754 5.19726C97.8926 5.13586 98.0085 5.07812 98.1233 5.02404C98.492 4.84158 98.9201 4.63622 99.1368 4.57278C99.1385 4.57235 99.1401 4.57213 99.1418 4.5716C99.4232 4.47182 99.7245 4.41741 100.038 4.41741C101.581 4.41741 102.832 5.18435 102.832 6.79704C102.832 8.16341 101.934 9.31021 100.721 9.62869C101.287 10.4118 102.184 10.9182 103.195 10.9182C104.907 10.9182 106.294 9.46848 106.294 7.6801C106.294 7.65301 106.292 7.62624 106.292 7.59936C106.293 7.56194 106.294 7.52485 106.294 7.487Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.739 19.7826C106.649 21.232 105.435 22.3801 103.949 22.3801C102.405 22.3801 101.153 21.1401 101.153 19.6103C101.153 18.5162 101.791 17.5701 102.72 17.1201C100.962 17.3702 99.6104 18.8811 99.6104 20.7078C99.6104 22.7094 101.233 24.3319 103.234 24.3319C105.236 24.3319 106.859 22.7094 106.859 20.7078C106.859 20.3881 106.817 20.078 106.739 19.7826Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100.744 20.4491C100.744 19.0232 101.621 17.7768 102.875 17.1016C101.042 17.2819 99.6104 18.8277 99.6104 20.708C99.6104 22.7095 101.233 24.332 103.234 24.332C103.522 24.332 103.802 24.2984 104.071 24.235C102.215 23.8412 100.744 22.2957 100.744 20.4491Z", fill: "#00CCCC" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_40345" }, /* @__PURE__ */ d.createElement("rect", { width: 107.478, height: 24, fill: "white", transform: "translate(0 0.855469)" })))), js = (e) => /* @__PURE__ */ d.createElement("svg", { width: 163, height: 24, viewBox: "0 0 163 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_49250)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.71059 10.7704C9.11012 10.8409 9.59435 10.8748 10.1605 10.8748C10.9779 10.8748 11.7558 10.7633 12.4998 10.5431C13.2177 10.3331 13.893 9.99804 14.4946 9.55341C15.0706 9.13034 15.5435 8.58258 15.8781 7.95106C16.2113 7.32141 16.3793 6.60988 16.3793 5.81506C16.3186 4.584 15.9501 3.55906 15.2739 2.73741C14.5833 1.90837 13.6777 1.28559 12.6565 0.937412C11.5511 0.550362 10.3872 0.356936 9.216 0.365647H0V0.592941H2.07529V18.1412H0V18.3685H10.2056V18.1412H7.416V10.3765C7.87765 10.5685 8.30824 10.6998 8.70918 10.7704H8.71059ZM10.7153 1.99906C11.0965 2.93506 11.304 4.16047 11.3336 5.67529C11.3336 6.64094 11.2941 7.45129 11.2122 8.10918C11.1318 8.76706 10.9158 9.34024 10.5656 9.82729C10.2155 10.3158 9.67341 10.5586 8.93929 10.5586C8.81223 10.5586 8.57788 10.5191 8.23906 10.4372C7.95035 10.3751 7.67248 10.2704 7.41459 10.1266V0.592941H8.31529C9.53224 0.592941 10.3341 1.06165 10.7153 1.99906ZM19.5529 6.02824C17.9647 6.69234 16.6953 7.94559 16.0108 9.52518C15.6644 10.3166 15.4819 11.17 15.4744 12.0339C15.4744 13.1972 15.7793 14.2913 16.392 15.3148C16.9853 16.3202 17.8186 17.1628 18.8174 17.7671C19.8254 18.3784 20.8828 18.6847 21.9939 18.6847C23.1233 18.6847 24.1892 18.384 25.1944 17.784C26.1916 17.1919 27.0222 16.3564 27.6085 15.3558C28.2113 14.3393 28.512 13.2452 28.512 12.0776C28.512 11.3322 28.3807 10.5798 28.1167 9.82165C27.8455 9.05274 27.4391 8.33846 26.9167 7.71247C26.3618 7.04768 25.6698 6.5107 24.888 6.13835C24.0692 5.73741 23.1332 5.53129 22.0828 5.52141C21.1948 5.52141 20.3506 5.69082 19.5529 6.02824ZM22.8706 6.21882C23.0527 6.51812 23.1671 6.97129 23.2136 7.57694C23.2602 8.18118 23.2842 9.11435 23.2842 10.3736V12.4179C23.2842 14.4395 23.2645 15.8188 23.2249 16.5572C23.1854 17.2955 23.0781 17.7995 22.9002 18.0692C22.7252 18.3388 22.4089 18.4828 21.9515 18.5012C21.5647 18.5012 21.2753 18.3685 21.0833 18.1031C20.8899 17.8362 20.7628 17.4494 20.7021 16.9412C20.6428 16.4329 20.6132 15.7426 20.6132 14.8673C20.6132 14.6414 20.6174 14.2574 20.6245 13.7153C20.6315 13.1718 20.6358 12.7412 20.6358 12.4193V9.94165C20.6358 8.82212 20.664 7.98212 20.7233 7.42165C20.7798 6.85977 20.9068 6.44471 21.0974 6.17506C21.288 5.90541 21.5873 5.76988 21.9967 5.76988C22.3976 5.76988 22.6885 5.91953 22.8706 6.21882ZM35.3816 6.35435C35.2034 6.5069 35.0589 6.69489 34.9573 6.90635C34.8557 7.11782 34.7992 7.34811 34.7915 7.58259C34.7915 8.12188 34.9807 8.58353 35.3576 8.96612C35.7346 9.34729 36.1906 9.53929 36.7285 9.53929C37.2367 9.53929 37.6616 9.34729 38.0075 8.96188C38.3435 8.60085 38.5288 8.12514 38.5256 7.632C38.4833 6.84988 38.0838 6.27106 37.3256 5.89835C36.5661 5.52424 35.6612 5.33788 34.6122 5.33788C33.6846 5.33281 32.7645 5.50533 31.9016 5.84612C31.0504 6.18494 30.3685 6.67482 29.8546 7.32C29.342 7.9626 29.0698 8.76402 29.0852 9.58588C29.0852 11.2235 30.0452 12.4489 31.9652 13.2621C32.904 13.6532 33.6734 14.0922 34.2706 14.5793C34.8692 15.0649 35.1685 15.6805 35.1685 16.4216C35.1304 17.7529 34.272 18.4193 32.5906 18.4193C31.7901 18.4193 31.1746 18.2979 30.744 18.0579C31.1746 18.0579 31.6758 17.9209 32.2433 17.6485C32.8136 17.3732 33.1256 16.7732 33.1821 15.8499C33.1821 15.2132 32.9788 14.6965 32.5722 14.2984C32.1848 13.9093 31.6627 13.6839 31.1139 13.6687C30.7087 13.6687 30.3304 13.7746 29.976 13.9864C29.6216 14.1995 29.3393 14.4805 29.1261 14.8334C28.9144 15.1835 28.8099 15.5534 28.8099 15.9402C28.8099 16.5656 29.0386 17.0838 29.4974 17.4988C29.9576 17.9125 30.5393 18.2174 31.2438 18.4136C31.9496 18.6085 32.6795 18.7158 33.4362 18.7341C34.1633 18.7341 34.8762 18.6353 35.5736 18.4376C36.2711 18.24 36.9021 17.9435 37.4682 17.5511C38.0329 17.1572 38.4791 16.6744 38.8038 16.0998C39.1285 15.5252 39.2894 14.8744 39.2894 14.1459C39.2753 13.4598 39.1186 12.864 38.8207 12.3614C38.5273 11.864 38.1329 11.4336 37.6631 11.0979C37.0838 10.6961 36.4728 10.342 35.8362 10.0391C35.3677 9.82853 34.9004 9.61535 34.4344 9.39953C33.9662 9.19072 33.5366 8.90434 33.1638 8.55247C32.9984 8.39516 32.8662 8.20629 32.775 7.99703C32.6838 7.78777 32.6355 7.56236 32.6329 7.33412C32.6329 6.80471 32.8885 6.37835 33.4009 6.05365C33.9134 5.72894 34.4852 5.56518 35.1205 5.56518C35.7501 5.56518 36.2739 5.664 36.6904 5.85882C36.2071 5.85208 35.7393 6.02921 35.3816 6.35435ZM40.9101 14.6456C40.9101 15.3911 41.0329 16.0588 41.2772 16.6489C41.5242 17.2376 41.9322 17.7106 42.5054 18.0664C43.0772 18.4235 43.8212 18.6141 44.736 18.6395C45.1228 18.6395 45.5252 18.5534 45.9431 18.3798C46.3624 18.2061 46.7054 17.9605 46.9793 17.64C47.2504 17.3209 47.3873 16.9581 47.3873 16.5515V13.5826H47.2009V16.5064C47.2009 16.7986 47.1304 17.064 46.9849 17.3054C46.8409 17.5454 46.6419 17.664 46.392 17.664C46.1365 17.664 45.9388 17.5412 45.7991 17.2969C45.6579 17.0513 45.5873 16.7887 45.5873 16.5064V6.65647H47.7304V5.76988H45.6325V0.727059C44.9647 1.55435 44.3661 2.14306 43.8367 2.49459C43.3073 2.84612 42.6847 3.02118 41.9675 3.02118C41.6277 3.02194 41.2884 2.99217 40.9539 2.93224V5.72612H39.3191V6.61271H40.9101V14.6456ZM53.0965 0.365647V0.638118H55.8409V18.0974H53.1868V18.3685H58.9948V18.0974H56.16V1.95671L61.2706 18.6395L66.3134 1.752V18.1412H63.8061V18.3685H74.6753V18.1412H71.9308V0.638118H74.5849V0.365647H66.3586L63.9191 8.60753L61.4569 0.367059H53.0965V0.365647ZM76.7689 7.2C76.9341 7.008 77.3068 6.79765 77.8899 6.56894C78.4729 6.33882 79.0899 6.22447 79.7435 6.22447C80.1473 6.22447 80.5129 6.29506 80.8391 6.43765C81.1652 6.58024 81.4249 6.80047 81.6184 7.10118C81.8104 7.39906 81.9078 7.77318 81.9078 8.21929V10.0376C81.9078 10.5784 81.6494 11.0245 81.1341 11.376C80.6188 11.7289 80.0711 11.9633 79.4894 12.0776C78.3656 12.2612 77.64 12.3868 77.3153 12.4489C76.9189 12.5384 76.5349 12.6759 76.1718 12.8584C75.7341 13.0701 75.3784 13.3878 75.1073 13.8127C74.8348 14.2376 74.6922 14.7953 74.6767 15.4871C74.6767 16.0631 74.8151 16.5911 75.0932 17.0711C75.3699 17.5511 75.7609 17.9322 76.2649 18.216C76.7689 18.4984 77.3464 18.6395 77.9944 18.6395C79.0673 18.6395 79.9002 18.3784 80.4988 17.8532C81.0974 17.3294 81.4969 16.7845 81.696 16.2212C81.8979 15.6565 81.9981 15.2753 81.9981 15.0762C81.9981 15.2951 82.0842 15.6847 82.2593 16.248C82.4329 16.8127 82.7901 17.3591 83.3294 17.8899C83.8701 18.4193 84.6381 18.6847 85.6348 18.6847C87.5252 18.6438 88.4697 17.7812 88.4697 16.0955V13.7647H88.2833V16.1478C88.2833 16.5614 88.1788 16.9666 87.9727 17.3633C87.7638 17.7614 87.5379 17.9605 87.2951 17.9605C87.1875 17.9615 87.0811 17.9393 86.9829 17.8955C86.8847 17.8516 86.7971 17.7871 86.7261 17.7064C86.5685 17.5358 86.4839 17.3103 86.4904 17.0781V8.60753C86.4904 7.96941 86.208 7.43859 85.6405 7.01788C85.0758 6.59577 84.3473 6.29082 83.4593 6.10024C82.5482 5.90783 81.6192 5.81224 80.688 5.81506C79.8438 5.81506 79.0433 5.93224 78.2866 6.16659C77.5299 6.40094 76.9115 6.76376 76.4315 7.25647C75.9515 7.74635 75.7115 8.34918 75.7115 9.06353C75.7115 9.72 75.9247 10.2748 76.3525 10.7252C76.7802 11.1769 77.3096 11.4028 77.9435 11.4028C78.3671 11.4028 78.7595 11.2941 79.1224 11.0809C79.477 10.8721 79.774 10.5781 79.9865 10.2256C80.1989 9.87314 80.3202 9.47325 80.3393 9.06212C80.3393 8.64847 80.2362 8.27859 80.0287 7.95106C79.8305 7.63833 79.5566 7.38069 79.2323 7.20201C78.908 7.02334 78.5439 6.92941 78.1737 6.92894C77.4988 6.97976 77.0301 7.07012 76.7689 7.2ZM81.6819 15.3176C81.5601 15.8162 81.361 16.2925 81.0918 16.7294C80.8489 17.1106 80.5976 17.2984 80.3393 17.2984C80.0951 17.28 79.9355 17.1049 79.8593 16.776C79.7817 16.4442 79.7435 15.9925 79.7435 15.4207V14.7388C79.7435 13.9186 79.8 13.2776 79.9144 12.8188C80.0287 12.3572 80.3167 11.9901 80.7769 11.7176C81.0614 11.5534 81.3282 11.3604 81.5732 11.1416C81.6943 11.0325 81.8062 10.9135 81.9078 10.7859V13.7125C81.9078 14.2193 81.8329 14.7544 81.6819 15.3176ZM96.7511 5.27012C96.8668 5.58071 96.9939 5.83906 97.1322 6.04659C97.272 6.25412 97.3567 6.35718 97.3864 6.35718C97.4005 6.35718 97.2536 6.30635 96.9445 6.20188C96.6084 6.09147 96.2662 6.00096 95.9195 5.93082C95.5456 5.85379 95.1648 5.815 94.7831 5.81506C94.0306 5.81506 93.2767 5.952 92.5214 6.22447C91.8068 6.47177 91.1625 6.88833 90.6438 7.43859C90.1482 7.97506 89.8913 8.60612 89.8772 9.33459C89.8772 9.90635 90.0155 10.3976 90.2922 10.8056C90.5704 11.2151 90.8711 11.5285 91.1958 11.7473C91.5219 11.9675 91.7266 12.0776 91.8085 12.0776C91.3638 12.2104 90.8075 12.5167 90.1426 12.9981C89.4762 13.4781 89.1431 14.1854 89.1431 15.12C89.1431 16.0588 89.4537 16.7831 90.0748 17.2941C90.696 17.8024 91.2141 18.1327 91.6278 18.2795C91.1732 18.3459 90.6014 18.5548 89.9167 18.9064C89.232 19.2579 88.8904 19.8508 88.8904 20.6852C88.8904 21.3911 89.1699 21.9939 89.7304 22.4951C90.2908 22.9962 91.0038 23.3704 91.8692 23.6245C92.727 23.874 93.6158 24.0005 94.5092 24C95.7064 24 96.8315 23.8024 97.8889 23.4042C98.9449 23.0075 99.8005 22.4019 100.454 21.5859C101.108 20.7713 101.434 19.7746 101.434 18.5958C101.434 17.6612 101.246 16.8551 100.869 16.176C100.492 15.4984 99.8908 14.9718 99.0621 14.5962C98.2334 14.2221 97.1746 14.0344 95.8857 14.0344C95.6118 14.0344 95.1445 14.0569 94.4852 14.1007C93.8259 14.1459 93.3402 14.1671 93.0297 14.1671C91.6489 14.1671 90.96 13.7986 90.96 13.0588C90.96 12.8442 91.0334 12.6819 91.1816 12.5746C91.4104 12.4197 91.6523 12.2851 91.9045 12.1722C92.0654 12.2795 92.4466 12.4306 93.0452 12.6268C93.6452 12.8216 94.2762 12.9205 94.9398 12.9205C95.7073 12.9113 96.4675 12.7704 97.1873 12.504C97.9264 12.2536 98.5979 11.8362 99.1497 11.2842C99.6762 10.7478 99.9402 10.1195 99.9402 9.39953C99.9402 8.79247 99.8019 8.29835 99.528 7.91294C99.2555 7.52894 98.8433 7.11388 98.2941 6.66777C97.7449 6.22306 97.3454 5.84329 97.0941 5.53129C96.8428 5.21929 96.7172 4.81271 96.7172 4.31435C96.7355 3.81176 96.8668 3.41929 97.1082 3.13553C97.3497 2.85318 97.5501 2.66965 97.7068 2.58494C97.6027 2.77737 97.5071 2.97427 97.4202 3.17506C97.3153 3.38927 97.2557 3.62286 97.2452 3.86118C97.2452 4.36376 97.4344 4.79294 97.8141 5.14588C98.1925 5.49882 98.6329 5.67529 99.1355 5.67529C99.6254 5.67529 100.042 5.50447 100.384 5.16C100.724 4.81553 100.906 4.39765 100.928 3.90494C100.928 3.57176 100.834 3.25835 100.645 2.96471C100.443 2.66498 100.171 2.41973 99.8515 2.25076C99.5323 2.08179 99.1762 1.99436 98.8151 1.99624C98.1882 2.04424 97.6645 2.26165 97.2423 2.65129C96.8216 3.03953 96.5986 3.59435 96.5774 4.31576C96.5774 4.64047 96.6339 4.95953 96.7511 5.27012ZM96.0706 10.1492C96.0706 10.8988 96 11.4904 95.8574 11.9195C95.7148 12.3501 95.4085 12.5788 94.9398 12.6042C94.3892 12.6042 94.0362 12.3035 93.8838 11.7007C93.7285 11.0979 93.6522 10.3242 93.6522 9.37835C93.6522 9.25694 93.6494 9.07059 93.6409 8.81929C93.6345 8.62689 93.6308 8.4344 93.6296 8.24188C93.6296 7.51765 93.7115 6.94729 93.8725 6.52941C94.0334 6.11153 94.3525 5.90259 94.8282 5.90259C95.0424 5.90049 95.2511 5.97006 95.4212 6.10024C95.5962 6.23153 95.7473 6.53788 95.8772 7.02353C96.0057 7.50776 96.0706 8.23059 96.0706 9.19624V10.1492ZM97.2 18.4828C97.6729 18.6169 98.1176 18.864 98.5327 19.2254C98.9492 19.5854 99.1652 20.0866 99.1793 20.7304C99.1793 21.4729 98.9506 22.0673 98.4904 22.5148C98.0043 22.9774 97.4041 23.3024 96.7511 23.4565C96.0173 23.6414 95.263 23.7325 94.5064 23.7275C93.4052 23.7275 92.4932 23.4678 91.7689 22.9468C91.0461 22.4245 90.6833 21.6113 90.6833 20.5031C90.6833 19.608 91.1068 18.8668 91.9496 18.2795H96.1609C96.3812 18.2795 96.7285 18.3473 97.2014 18.4828H97.2ZM103.601 7.2C103.766 7.008 104.14 6.79765 104.723 6.56894C105.313 6.33773 105.942 6.22083 106.576 6.22447C106.981 6.22447 107.346 6.29506 107.672 6.43765C107.997 6.58024 108.257 6.80047 108.45 7.10118C108.644 7.39906 108.74 7.77318 108.74 8.21929V10.0376C108.74 10.5784 108.483 11.0245 107.968 11.376C107.452 11.7289 106.904 11.9633 106.323 12.0776C105.198 12.2612 104.473 12.3868 104.149 12.4489C103.825 12.5125 103.443 12.6494 103.005 12.8584C102.568 13.0701 102.212 13.3878 101.941 13.8127C101.668 14.2376 101.524 14.7953 101.51 15.4871C101.502 16.0431 101.646 16.5908 101.925 17.0715C102.205 17.5523 102.61 17.9479 103.097 18.216C103.602 18.4984 104.178 18.6395 104.826 18.6395C105.899 18.6395 106.734 18.3784 107.332 17.8532C107.929 17.3294 108.329 16.7845 108.529 16.2212C108.73 15.6565 108.83 15.2753 108.83 15.0762C108.83 15.2951 108.918 15.6847 109.091 16.248C109.266 16.8127 109.624 17.3591 110.164 17.8899C110.702 18.4193 111.472 18.6847 112.468 18.6847C114.357 18.6438 115.302 17.7812 115.302 16.0955V13.7647H115.117V16.1478C115.117 16.5614 115.012 16.9666 114.805 17.3633C114.596 17.7614 114.37 17.9605 114.127 17.9605C114.02 17.9613 113.914 17.939 113.816 17.8952C113.718 17.8513 113.63 17.7869 113.56 17.7064C113.401 17.5361 113.316 17.3105 113.322 17.0781V8.60753C113.322 7.96941 113.04 7.43859 112.474 7.01788C111.909 6.59577 111.181 6.29082 110.293 6.10024C109.381 5.90779 108.452 5.8122 107.52 5.81506C106.707 5.81052 105.898 5.92903 105.12 6.16659C104.362 6.40094 103.744 6.76376 103.264 7.25647C103.028 7.49377 102.843 7.77611 102.719 8.08661C102.596 8.39711 102.536 8.72938 102.544 9.06353C102.544 9.72 102.758 10.2748 103.186 10.7252C103.612 11.1769 104.143 11.4028 104.777 11.4028C105.2 11.4028 105.593 11.2941 105.954 11.0809C106.309 10.8721 106.606 10.5781 106.818 10.2256C107.031 9.87314 107.152 9.47325 107.171 9.06212C107.171 8.64847 107.068 8.27859 106.862 7.95106C106.664 7.63814 106.39 7.38036 106.066 7.20166C105.742 7.02296 105.377 6.92915 105.007 6.92894C104.332 6.97976 103.864 7.07012 103.601 7.2ZM108.515 15.3176C108.366 15.8824 108.168 16.3511 107.925 16.7294C107.681 17.1106 107.431 17.2984 107.171 17.2984C106.928 17.28 106.768 17.1049 106.691 16.776C106.614 16.4442 106.576 15.9925 106.576 15.4207V14.7388C106.576 13.9186 106.632 13.2776 106.748 12.8188C106.861 12.3572 107.149 11.9901 107.609 11.7176C107.962 11.5031 108.227 11.3111 108.407 11.1416C108.583 10.9708 108.696 10.8522 108.74 10.7859V13.7125C108.74 14.2193 108.665 14.7544 108.515 15.3176ZM118.9 6.88376C119.372 6.88376 119.771 6.98824 120.097 7.19435C120.422 7.40047 120.822 7.71953 121.295 8.15153C121.768 8.58212 122.197 8.90541 122.582 9.12141C122.968 9.33741 123.439 9.44612 123.994 9.44612C124.801 9.43059 125.445 9.25412 125.922 8.91671C126.4 8.57788 126.726 8.24329 126.899 7.91012C127.073 7.57553 127.177 7.32565 127.21 7.16047C127.117 8.34635 126.815 9.23294 126.299 9.82306C125.787 10.4146 125.183 10.7972 124.488 10.9694C123.792 11.1431 122.921 11.256 121.871 11.3082C121.246 11.3563 120.63 11.4776 120.034 11.6696C119.364 11.8793 118.725 12.1764 118.134 12.5534C117.527 12.9388 117.025 13.4146 116.629 13.9821C116.228 14.5588 116.002 15.2385 115.976 15.9402C115.976 16.3581 116.061 16.7774 116.226 17.1995C116.393 17.6202 116.63 17.9661 116.936 18.2358C117.244 18.5054 117.6 18.6395 118.004 18.6395C118.289 18.6395 118.54 18.5435 118.756 18.3487C118.858 18.2657 118.94 18.1612 118.996 18.0429C119.052 17.9245 119.082 17.7951 119.082 17.664C119.082 17.3026 118.978 17.0259 118.768 16.8367C118.543 16.6405 118.252 16.538 117.954 16.5501C117.64 16.5501 117.39 16.6941 117.202 16.9793C117.014 17.2673 116.921 17.4805 116.921 17.6202C116.921 16.5304 117.435 15.9854 118.464 15.9854C118.986 15.9896 119.438 16.104 119.819 16.3313C120.2 16.5586 120.645 16.8918 121.151 17.3322C121.657 17.7713 122.105 18.1002 122.495 18.3162C122.884 18.5322 123.352 18.6409 123.895 18.6409C124.786 18.6409 125.527 18.3798 126.117 17.8588C126.707 17.3365 127.138 16.6687 127.408 15.8513C127.677 15.0353 127.813 14.1713 127.813 13.2579V11.1967H127.581V12.6042C127.581 13.1478 127.324 13.5784 126.812 13.896C126.302 14.2124 125.713 14.3775 125.113 14.3718C124.749 14.3718 124.422 14.3435 124.132 14.2885C123.74 14.2097 123.351 14.1174 122.965 14.0118C122.478 13.8833 122.072 13.7859 121.748 13.7209C121.386 13.6531 121.018 13.621 120.649 13.6249C119.534 13.6616 118.681 13.9228 118.094 14.4113C117.505 14.8984 117.126 15.4376 116.951 16.0264C116.784 16.5719 116.696 17.1387 116.691 17.7092C116.31 17.0541 116.116 16.4668 116.116 15.9402C116.159 15.1101 116.427 14.4155 116.924 13.8565C117.435 13.2892 118.084 12.8645 118.808 12.624C119.593 12.3552 120.417 12.2174 121.247 12.216C122.411 12.1906 123.453 11.9732 124.372 11.5624C125.29 11.1529 126.007 10.5854 126.525 9.86118C127.042 9.13661 127.33 8.27347 127.351 7.38353C127.358 6.91163 127.221 6.44885 126.959 6.05647C126.697 5.66541 126.352 5.47059 125.927 5.47059C125.64 5.4937 125.372 5.62013 125.171 5.82635C125.07 5.91675 124.989 6.02696 124.933 6.15011C124.877 6.27326 124.846 6.40671 124.844 6.54212C124.845 6.67652 124.873 6.80935 124.926 6.93294C124.978 7.05653 125.055 7.16841 125.152 7.26212C125.243 7.364 125.354 7.44546 125.479 7.50118C125.604 7.55689 125.739 7.5856 125.876 7.58541C126.051 7.58541 126.237 7.50776 126.433 7.35529C126.631 7.20282 126.775 7.07718 126.868 6.97835C126.868 7.14776 126.792 7.35953 126.642 7.61365C126.488 7.86635 126.157 7.99341 125.643 7.99341C125.235 7.99341 124.896 7.90165 124.626 7.72094C124.192 7.40897 123.776 7.07341 123.378 6.71576C122.816 6.22588 122.301 5.85882 121.83 5.61459C121.36 5.37035 120.806 5.24894 120.169 5.24894C119.571 5.25459 118.983 5.41197 118.461 5.70635C117.911 6.00036 117.438 6.42142 117.083 6.93459C116.735 7.42434 116.542 8.00691 116.527 8.60753C116.527 9.28094 116.726 9.87953 117.126 10.4061C117.524 10.9327 118.024 11.1967 118.622 11.1967C118.969 11.1967 119.3 11.1134 119.61 10.9468C119.911 10.7896 120.169 10.5619 120.363 10.2833C120.549 10.0189 120.649 9.70331 120.649 9.37976C120.649 8.89271 120.456 8.46353 120.071 8.09506C119.893 7.91768 119.682 7.7773 119.45 7.68206C119.218 7.58682 118.969 7.53861 118.718 7.54024C118.175 7.54024 117.74 7.73506 117.412 8.12471C117.088 8.50485 116.913 8.99021 116.921 9.48988C116.921 7.75341 117.58 6.88376 118.9 6.88376ZM133.662 4.872C134.058 4.62494 134.356 4.30024 134.555 3.89506C134.753 3.49129 134.853 3.06212 134.853 2.60753C134.853 1.90729 134.623 1.29741 134.164 0.777882C133.704 0.259765 133.059 0 132.226 0C131.397 0 130.749 0.261176 130.28 0.780706C129.812 1.30165 129.577 1.91012 129.577 2.60753C129.577 3.05929 129.68 3.48706 129.884 3.89224C130.087 4.29795 130.401 4.63768 130.79 4.872C131.188 5.12047 131.667 5.24329 132.226 5.24329C132.784 5.24329 133.262 5.12047 133.66 4.872H133.662ZM129.878 6.04235V18.3247H134.555V5.85882H127.897V6.04235H129.877H129.878ZM136.793 6.22447V18.3685H141.466V9.85553C141.466 9.43765 141.522 8.99435 141.641 8.52424C141.757 8.05553 141.919 7.66306 142.127 7.34965C142.334 7.03624 142.566 6.87812 142.821 6.87812C143.421 6.87812 143.72 7.78729 143.72 9.60565C143.72 10.2198 143.685 11.0922 143.613 12.2245C143.543 13.3567 143.5 14.0287 143.49 14.2391C143.49 15.1934 143.651 16.0066 143.973 16.6814C144.296 17.3548 144.74 17.8574 145.303 18.1892C145.868 18.5195 146.507 18.6833 147.223 18.6833C148.36 18.6438 149.129 18.3939 149.538 17.9336C149.944 17.4734 150.147 16.8099 150.147 15.9402V13.8071L149.917 13.7633V15.8965C149.917 17.0965 149.647 17.7318 149.106 17.8024C148.957 17.8108 148.81 17.7687 148.687 17.6829C148.565 17.5971 148.476 17.4725 148.433 17.3294C148.316 17.0132 148.258 16.4598 148.258 15.6692C148.28 14.6628 148.311 13.6567 148.348 12.6508C148.36 12.3868 148.374 11.8715 148.393 11.1021C148.393 7.65741 147.151 5.91106 144.665 5.85882C143.879 5.85882 143.207 6.09035 142.65 6.55482C142.093 7.01788 141.68 7.64188 141.415 8.42541V6.04235H135.572V6.22447H136.792H136.793ZM153.734 6.44047C152.778 7.03202 151.991 7.85947 151.447 8.84329C150.889 9.83133 150.585 10.9429 150.563 12.0776C150.563 13.368 150.857 14.5101 151.441 15.5054C152.006 16.4824 152.83 17.2839 153.823 17.8207C154.825 18.3671 155.927 18.6395 157.127 18.6395C158.651 18.6395 159.802 18.288 160.578 17.5849C161.355 16.8805 161.843 16.1506 162.048 15.3953C162.253 14.6386 162.354 14.0344 162.354 13.5798H162.124C162.124 13.7562 162.085 14.064 162.006 14.5031C161.928 14.9407 161.761 15.4348 161.509 15.9882C161.243 16.5561 160.852 17.0562 160.365 17.4508C159.854 17.8744 159.196 18.1186 158.39 18.1849C157.278 18.1849 156.531 17.6908 156.152 16.7026C155.774 15.7144 155.585 14.6202 155.585 13.4188C155.585 12.9049 155.593 12.6494 155.608 12.6494C156.154 12.8894 156.799 13.0094 157.542 13.0094C158.273 13.0094 158.984 12.8894 159.679 12.6494C160.371 12.4094 160.945 12.0339 161.399 11.5242C161.852 11.0132 162.079 10.3807 162.079 9.62824C162.079 9.04377 161.931 8.50306 161.634 8.00612C161.326 7.49627 160.919 7.05286 160.437 6.70165C159.927 6.32449 159.361 6.03049 158.759 5.83059C158.166 5.62771 157.544 5.52281 156.918 5.52C155.792 5.52515 154.69 5.8439 153.736 6.44047H153.734ZM155.855 6.23012C156.049 5.83059 156.344 5.63153 156.737 5.63153C157.262 5.63153 157.604 5.87576 157.763 6.36282C157.923 6.85129 158.003 7.51624 158.003 8.35906V8.96894C158.003 10.0871 157.919 10.9878 157.746 11.6696C157.577 12.3515 157.163 12.6932 156.507 12.6932C156.266 12.6751 156.03 12.6119 155.812 12.5068C155.646 12.4165 155.562 12.2287 155.562 11.9449V7.632C155.562 7.09553 155.661 6.62965 155.855 6.23012Z", fill: "black" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_49250" }, /* @__PURE__ */ d.createElement("rect", { width: 162.353, height: 24, fill: "white" })))), Gs = (e) => /* @__PURE__ */ d.createElement("svg", { width: 187, height: 16, viewBox: "0 0 187 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.841 14.4763L154.423 16H151.014L150.026 13.1692H144.076L143.064 16H139.654L145.746 0H148.309L153.515 13.6197L155.306 11.9335C156.364 12.928 157.797 13.2591 159.346 13.2591C161.272 13.2591 162.306 12.5748 162.306 11.3145C162.306 10.7618 162.141 10.2978 161.789 9.98892C161.459 9.70216 161.084 9.54585 160.31 9.43631L158.289 9.17169C156.858 8.97231 155.799 8.55262 155.047 7.86708C154.25 7.11631 153.851 6.09969 153.851 4.77415C153.851 1.968 156.058 0 159.675 0C161.976 0 163.645 0.530462 165.078 1.83385L163.01 3.75754C161.953 2.80615 160.685 2.67446 159.581 2.67446C157.843 2.67446 156.997 3.58031 156.997 4.66338C156.997 5.06092 157.138 5.48062 157.49 5.78954C157.82 6.07754 158.36 6.32 159.041 6.40862L161.014 6.67446C162.54 6.87262 163.504 7.27138 164.208 7.88923C165.101 8.68554 165.5 9.83385 165.5 11.2271C165.5 14.2757 162.8 16 159.299 16C157.089 16 155.341 15.6135 153.841 14.4763ZM70.7308 16V0H81.8077V2.78646H74.0132V6.54031H80.6507V9.32554H74.0132V13.2135H81.8077V16H70.7308ZM63.7388 10.0898L66.2372 0H69.5L65.2021 16H62.5904L59.6428 6.29169L56.6938 16H54.0846L49.8077 0H53.0717L55.5467 10.0898L58.4723 0H60.8132L63.7388 10.0898ZM83.0384 16V0H94.1154V2.78646H86.3209V6.54031H92.9584V9.32554H86.3209V13.2135H94.1154V16H83.0384ZM40.3984 6.67446C41.9246 6.87262 42.8883 7.27138 43.5923 7.88923C44.4858 8.68554 44.8846 9.83385 44.8846 11.2271C44.8846 14.2757 42.1843 16 38.684 16C36.1474 16 34.2212 15.4917 32.5769 13.9225L34.6901 11.9335C35.7486 12.928 37.1812 13.2591 38.7308 13.2591C40.6569 13.2591 41.6908 12.5748 41.6908 11.3145C41.6908 10.7618 41.5258 10.2978 41.1738 9.98892C40.844 9.70216 40.4686 9.54585 39.6944 9.43631L37.6735 9.17169C36.2409 8.97231 35.1837 8.55262 34.4329 7.86708C33.6329 7.11631 33.2341 6.09969 33.2341 4.77415C33.2341 1.968 35.4421 0 39.0594 0C41.3609 0 43.0298 0.530462 44.4624 1.83385L42.3948 3.75754C41.3375 2.80615 40.0698 2.67446 38.9658 2.67446C37.228 2.67446 36.3812 3.58031 36.3812 4.66338C36.3812 5.06092 36.5228 5.48062 36.876 5.78954C37.2034 6.07754 37.7437 6.32 38.4255 6.40862L40.3984 6.67446ZM0.576904 2.78646V0H11.6538V2.78646H7.62183V16H4.6089V2.78646H0.576904ZM21.8963 6.54031V0H25.1923V16H21.8963V9.30462H16.1806V16H12.8846V0H16.1806V6.53908H21.8963V6.54031ZM27.6538 16V0H31.3461V16H27.6538ZM166.731 16V0H170.423V16H166.731ZM176.993 10.5391H181.155L179.109 4.72L176.992 10.5391H176.993ZM180.309 0L186.423 16H183.014L182.026 13.1692H176.076L175.064 16H171.654L177.746 0H180.309ZM144.993 10.5391H149.155L147.109 4.72L144.993 10.5391ZM115.038 16V0H118.731V16H115.038ZM109.715 0L104.168 6.35939L110.115 16H106.307L102.006 8.71877L99.8446 11.1914V16H96.5769V0H99.8446V6.96615L105.742 0H109.715ZM130.362 9.79692V0H133.5V16H130.7L124.331 6.17846V16H121.192V0H123.992L130.362 9.79692Z", fill: "black" })), Ks = /* @__PURE__ */ H("div", {
  target: "e90s7e13"
})('display:grid;grid-template:"Title Image" min-content "Description Image" min-content/auto 60px;gap:4px 12px;align-items:center;color:#000000;font-family:', ue, ";"), Ys = /* @__PURE__ */ H("div", {
  target: "e90s7e12"
})("grid-area:Title;color:#000000;font-weight:700;font-size:18px;font-family:", ue, ";line-height:25.2px;"), Qs = /* @__PURE__ */ H("div", {
  target: "e90s7e11"
})("grid-area:Description;font-weight:400;font-size:12px;font-family:", X, ";line-height:14px;"), Xs = /* @__PURE__ */ H("div", {
  target: "e90s7e10"
})({
  name: "g893ev",
  styles: "grid-area:Image"
}), Js = () => {
  var e, t;
  const {
    config: n
  } = q(), {
    newsletterItemForDisplay: r
  } = hn(), a = {
    [n.newsletter.globalImpact]: /* @__PURE__ */ C.createElement(Ws, null),
    [n.newsletter.lunar]: /* @__PURE__ */ C.createElement(Ns, null),
    [n.newsletter.postMag]: /* @__PURE__ */ C.createElement(js, null),
    [n.newsletter.thisWeekInAsia]: /* @__PURE__ */ C.createElement(Gs, null)
  }, i = u2(r), o = (e = r == null ? void 0 : r.entityId) !== null && e !== void 0 ? e : "", s = () => o in a ? a[o] : i;
  return /* @__PURE__ */ C.createElement(Ks, {
    "data-qa": "article-20-theme-title"
  }, /* @__PURE__ */ C.createElement(Ys, null, s()), /* @__PURE__ */ C.createElement(Qs, null, r == null || (t = r.description) === null || t === void 0 ? void 0 : t.text), /* @__PURE__ */ C.createElement(Xs, null, /* @__PURE__ */ C.createElement(Zs, null)));
};
Js.displayName = "Article20ThemeTitle";
const e0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), t0 = /* @__PURE__ */ H("div", {
  target: "e1ylzbp51"
})("font-size:14px;font-family:", X, ";"), n0 = /* @__PURE__ */ H(e0, {
  target: "e1ylzbp50"
})({
  name: "1o82tng",
  styles: "margin-inline-end:12px"
}), r0 = () => /* @__PURE__ */ C.createElement(t0, {
  "data-qa": "article-theme-sign-up-button-display"
}, /* @__PURE__ */ C.createElement(n0, null), "GET OUR NEWSLETTER");
r0.displayName = "ArticleThemeSignUpButtonDisplay";
const a0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 154, height: 24, viewBox: "0 0 154 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1909 3.64817C11.52 4.83676 11.6844 6.3637 11.6844 8.22859H7.07678V6.11617C7.07678 5.55023 6.99861 5.11073 6.84343 4.79998C6.68786 4.48923 6.40891 4.33366 6.00697 4.33366C5.11073 4.33366 4.6628 4.91914 4.6628 6.08896V17.499C4.6628 18.2125 4.75438 18.752 4.93715 19.1179C5.11993 19.4838 5.43987 19.6662 5.897 19.6662C6.35412 19.6662 6.67407 19.4838 6.85722 19.1179C7.03961 18.752 7.13157 18.2125 7.13157 17.499V14.126H5.86979V10.0663H11.6296V23.7807H9.73713L8.94167 21.8059C8.10023 23.2688 6.80243 23.9999 5.04674 23.9999C3.34623 23.9999 2.07985 23.4014 1.24799 22.2036C0.41574 21.0058 0 19.1911 0 16.7591V6.61046C0 4.43482 0.484328 2.78872 1.45375 1.67331C2.42279 0.55828 3.86734 0 5.78741 0C7.34155 0 8.54854 0.311135 9.40799 0.933021C10.2671 1.55452 10.8617 2.45957 11.1909 3.64817ZM13.4941 0.219727H18.2117V19.776H23.0665V23.7805H13.4941V0.219727ZM31.0753 17.5815C31.0753 18.2402 31.0021 18.7521 30.8558 19.118C30.7094 19.4839 30.4259 19.6659 30.0055 19.6659C29.5664 19.6659 29.2648 19.4927 29.1005 19.1452C28.9357 18.798 28.8533 18.2857 28.8533 17.6091V6.11625C28.8533 4.92842 29.2468 4.33374 30.0331 4.33374C30.4534 4.33374 30.732 4.49391 30.8696 4.81385C31.0067 5.13418 31.0753 5.55031 31.0753 6.06222V17.5815ZM30.0054 0C28.1034 0 26.6592 0.51728 25.6714 1.54993C24.6843 2.58295 24.1904 4.1141 24.1904 6.14376V17.3626C24.1904 19.4651 24.6843 21.097 25.6714 22.258C26.6592 23.4198 28.1034 23.9999 30.0054 23.9999C31.9067 23.9999 33.3517 23.424 34.3391 22.2718C35.3265 21.12 35.8204 19.4838 35.8204 17.3626V6.14376C35.8204 4.1141 35.3265 2.58295 34.3391 1.54993C33.3517 0.51728 31.9067 0 30.0054 0ZM42.7868 19.6387C44.0118 19.6387 44.6249 19.054 44.6249 17.8834V14.9484C44.6249 14.2353 44.5195 13.6962 44.3096 13.3302C44.0988 12.9647 43.7287 12.7819 43.1984 12.7819H42.3209V19.6115L42.7868 19.6387ZM43.3079 3.84021H42.3209V9.07892H43.2807C43.6827 9.07892 43.957 8.92795 44.1034 8.62601C44.2498 8.32484 44.323 7.89952 44.323 7.35082V4.99164C44.323 4.22415 43.9842 3.84021 43.3079 3.84021ZM49.0134 6.63766C49.0134 8.88688 48.2083 10.2307 46.5994 10.6698C47.5868 10.9257 48.2819 11.52 48.6842 12.4523C49.0862 13.3853 49.2873 14.6191 49.2873 16.1549C49.2873 18.6604 48.9122 20.5575 48.1627 21.8469C47.4128 23.1355 46.0599 23.7807 44.1034 23.7807H37.7125V0.219556H44.1034C45.8223 0.219556 47.0703 0.64066 47.8474 1.48134C48.6244 2.3224 49.0134 3.69376 49.0134 5.59544V6.63766ZM55.4313 16.2102L56.3092 4.22422H56.5287L57.571 16.2102H55.4313ZM52.4965 0.22002L50.2201 23.7808H54.8009L55.0749 19.9679H57.9276L58.2567 23.7808H62.7276L60.4784 0.22002H52.4965ZM64.1537 0.219727H68.8713V19.776H73.7261V23.7805H64.1537V0.219727ZM78.5473 23.7804H83.1001V0.21958H78.5473V23.7804ZM92.1784 0.21958L94.1532 14.5919L96.1281 0.21958H103.369V23.7804H99.0628V6.80207L96.3476 23.7804H92.1236L89.2437 6.80207V23.7804H84.992V0.21958H92.1784ZM112.133 8.98287C112.051 9.376 111.877 9.67756 111.612 9.88754C111.346 10.0983 110.93 10.2037 110.364 10.2037H110.089V4.49824H110.61C111.269 4.49824 111.708 4.7178 111.927 5.15653C112.146 5.59526 112.256 6.30872 112.256 7.29577C112.256 8.02763 112.215 8.58974 112.133 8.98287ZM115.712 2.04362C114.908 0.827818 113.564 0.219727 111.68 0.219727H105.454V23.7805H110.09V14.4545H112.01C113.856 14.4545 115.136 13.8606 115.85 12.672C116.563 11.4834 116.919 9.71891 116.919 7.37812C116.919 5.03771 116.517 3.25942 115.712 2.04362ZM122.878 4.22422L122 16.2102H124.14L123.098 4.22422H122.878ZM116.788 23.7808L119.066 0.22002H127.047L129.296 23.7808H124.825L124.496 19.9679H121.644L121.37 23.7808H116.788ZM137.415 17.8835C137.415 19.0728 137.049 19.666 136.317 19.666C135.951 19.666 135.677 19.525 135.495 19.2414C135.312 18.9579 135.22 18.5054 135.22 17.8835V6.06191C135.22 5.4952 135.298 5.06566 135.454 4.77292C135.609 4.48056 135.897 4.33381 136.317 4.33381C136.72 4.33381 137.003 4.46217 137.168 4.71813C137.332 4.97447 137.415 5.4404 137.415 6.11632V9.6001H142.105V5.54041C142.105 3.7487 141.574 2.37734 140.514 1.42669C139.454 0.476044 138.055 0.000146484 136.317 0.000146484C134.324 0.000146484 132.861 0.594827 131.929 1.78266C130.997 2.97202 130.53 4.73575 130.53 7.07692V17.9387C130.53 19.8223 131.047 21.3029 132.08 22.3815C133.112 23.4613 134.488 24 136.208 24C140.175 24 142.16 22.0252 142.16 18.0751V13.6322H137.415V17.8835ZM145.753 4.74482H142.955V0.21958H153.268V4.74482H150.47V23.7807H145.753V4.74482Z", fill: "#001246" })), i0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 108, height: 25, viewBox: "0 0 108 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_40345)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.855469V1.59582H2.9687V23.3497H0V24.0901H2.9687H19.668V19.5134H18.3543V23.3497H9.53687V1.59582H12.5061V0.855469H0Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.3869 23.3492V13.1913C65.3869 7.14114 62.2327 5.97756 58.7445 5.97756C56.4436 5.97756 54.5881 6.52053 52.3986 8.03312V6.21206L44.0229 6.21367V6.95018H45.8309L45.8304 23.3492H43.975V24.0896H45.8304H54.2542V23.3492H52.3986V8.96134C53.9572 7.83658 55.4045 7.2549 56.7405 6.9833C58.8559 7.21597 58.8186 10.3602 58.8186 12.8423V23.3492H56.9631V24.0896H58.8186H65.09H67.2425V23.3492H65.3869ZM40.9727 23.3492V6.21034H40.6757L40.6725 6.21367H34.4821V6.21034H32.5938V6.95029H34.4049L34.4043 21.3386C32.8457 22.4633 31.3985 23.045 30.0626 23.3164C27.9473 23.0839 27.9844 19.9397 27.9844 17.4575V6.21034H27.9784V6.21367H19.6063V6.95029H21.4138L21.416 17.1084C21.416 23.1588 24.5704 24.3225 28.0588 24.3225C30.3593 24.3225 32.2149 23.7793 34.4043 22.2668V24.0896H37.0021H42.8281V23.3492H40.9727ZM78.2677 21.2196C74.3341 22.5771 73.3322 20.5215 73.3322 19.0088C73.3322 15.7123 77.2285 14.2359 78.2677 12.2967V21.2196ZM84.836 23.3493V14.9755C84.836 8.1494 81.6446 6.21027 76.8946 6.21027H75.9669C74.9147 6.2121 74.1451 6.31038 74.1451 6.31038C71.7914 6.59229 70.6794 7.12882 70.2099 7.4417C69.2997 8.00586 68.6892 9.04246 68.6892 10.2285C68.6892 12.0169 70.0763 13.4668 71.7875 13.4668C72.7299 13.4668 73.5734 13.0264 74.1416 12.3326C72.8076 12.1121 71.7875 10.9051 71.7875 9.44888C71.7875 8.00758 72.7871 7.35138 74.1011 7.11333C74.1051 7.11237 74.1086 7.11108 74.1128 7.11032C74.8005 6.99807 75.7037 6.99119 76.527 7.06871C76.5722 7.07291 76.8257 7.10839 76.8625 7.12172C78.2365 7.46256 78.2677 8.63807 78.2677 10.6704C77.7852 15.1693 67.506 13.618 67.506 20.2499C67.506 23.4689 69.8438 24.3223 71.7736 24.3223C74.4455 24.3223 77.1544 22.5771 78.2677 21.7238V24.0895H84.5391H86.6915V23.3493H84.836ZM106.294 7.487C106.294 4.92727 104.661 3.37598 101.915 3.37598C99.6141 3.37598 98.1295 3.91884 95.9402 5.43154V3.60876H95.6435C93.194 6.2459 89.9658 6.51749 87.5165 6.51749V7.25777C88.0732 7.25777 88.704 7.25777 89.3718 7.18024V23.3492H87.5165V24.0896H89.3718H97.7957V23.3492H95.9402V6.35965C96.5919 5.89001 97.1887 5.50627 97.7562 5.20736C97.7625 5.20424 97.769 5.20037 97.7754 5.19726C97.8926 5.13586 98.0085 5.07812 98.1233 5.02404C98.492 4.84158 98.9201 4.63622 99.1368 4.57278C99.1385 4.57235 99.1401 4.57213 99.1418 4.5716C99.4232 4.47182 99.7245 4.41741 100.038 4.41741C101.581 4.41741 102.832 5.18435 102.832 6.79704C102.832 8.16341 101.934 9.31021 100.721 9.62869C101.287 10.4118 102.184 10.9182 103.195 10.9182C104.907 10.9182 106.294 9.46848 106.294 7.6801C106.294 7.65301 106.292 7.62624 106.292 7.59936C106.293 7.56194 106.294 7.52485 106.294 7.487Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.739 19.7826C106.649 21.232 105.435 22.3801 103.949 22.3801C102.405 22.3801 101.153 21.1401 101.153 19.6103C101.153 18.5162 101.791 17.5701 102.72 17.1201C100.962 17.3702 99.6104 18.8811 99.6104 20.7078C99.6104 22.7094 101.233 24.3319 103.234 24.3319C105.236 24.3319 106.859 22.7094 106.859 20.7078C106.859 20.3881 106.817 20.078 106.739 19.7826Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100.744 20.4491C100.744 19.0232 101.621 17.7768 102.875 17.1016C101.042 17.2819 99.6104 18.8277 99.6104 20.708C99.6104 22.7095 101.233 24.332 103.234 24.332C103.522 24.332 103.802 24.2984 104.071 24.235C102.215 23.8412 100.744 22.2957 100.744 20.4491Z", fill: "#00CCCC" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_40345" }, /* @__PURE__ */ d.createElement("rect", { width: 107.478, height: 24, fill: "white", transform: "translate(0 0.855469)" })))), o0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 163, height: 24, viewBox: "0 0 163 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_49250)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.71059 10.7704C9.11012 10.8409 9.59435 10.8748 10.1605 10.8748C10.9779 10.8748 11.7558 10.7633 12.4998 10.5431C13.2177 10.3331 13.893 9.99804 14.4946 9.55341C15.0706 9.13034 15.5435 8.58258 15.8781 7.95106C16.2113 7.32141 16.3793 6.60988 16.3793 5.81506C16.3186 4.584 15.9501 3.55906 15.2739 2.73741C14.5833 1.90837 13.6777 1.28559 12.6565 0.937412C11.5511 0.550362 10.3872 0.356936 9.216 0.365647H0V0.592941H2.07529V18.1412H0V18.3685H10.2056V18.1412H7.416V10.3765C7.87765 10.5685 8.30824 10.6998 8.70918 10.7704H8.71059ZM10.7153 1.99906C11.0965 2.93506 11.304 4.16047 11.3336 5.67529C11.3336 6.64094 11.2941 7.45129 11.2122 8.10918C11.1318 8.76706 10.9158 9.34024 10.5656 9.82729C10.2155 10.3158 9.67341 10.5586 8.93929 10.5586C8.81223 10.5586 8.57788 10.5191 8.23906 10.4372C7.95035 10.3751 7.67248 10.2704 7.41459 10.1266V0.592941H8.31529C9.53224 0.592941 10.3341 1.06165 10.7153 1.99906ZM19.5529 6.02824C17.9647 6.69234 16.6953 7.94559 16.0108 9.52518C15.6644 10.3166 15.4819 11.17 15.4744 12.0339C15.4744 13.1972 15.7793 14.2913 16.392 15.3148C16.9853 16.3202 17.8186 17.1628 18.8174 17.7671C19.8254 18.3784 20.8828 18.6847 21.9939 18.6847C23.1233 18.6847 24.1892 18.384 25.1944 17.784C26.1916 17.1919 27.0222 16.3564 27.6085 15.3558C28.2113 14.3393 28.512 13.2452 28.512 12.0776C28.512 11.3322 28.3807 10.5798 28.1167 9.82165C27.8455 9.05274 27.4391 8.33846 26.9167 7.71247C26.3618 7.04768 25.6698 6.5107 24.888 6.13835C24.0692 5.73741 23.1332 5.53129 22.0828 5.52141C21.1948 5.52141 20.3506 5.69082 19.5529 6.02824ZM22.8706 6.21882C23.0527 6.51812 23.1671 6.97129 23.2136 7.57694C23.2602 8.18118 23.2842 9.11435 23.2842 10.3736V12.4179C23.2842 14.4395 23.2645 15.8188 23.2249 16.5572C23.1854 17.2955 23.0781 17.7995 22.9002 18.0692C22.7252 18.3388 22.4089 18.4828 21.9515 18.5012C21.5647 18.5012 21.2753 18.3685 21.0833 18.1031C20.8899 17.8362 20.7628 17.4494 20.7021 16.9412C20.6428 16.4329 20.6132 15.7426 20.6132 14.8673C20.6132 14.6414 20.6174 14.2574 20.6245 13.7153C20.6315 13.1718 20.6358 12.7412 20.6358 12.4193V9.94165C20.6358 8.82212 20.664 7.98212 20.7233 7.42165C20.7798 6.85977 20.9068 6.44471 21.0974 6.17506C21.288 5.90541 21.5873 5.76988 21.9967 5.76988C22.3976 5.76988 22.6885 5.91953 22.8706 6.21882ZM35.3816 6.35435C35.2034 6.5069 35.0589 6.69489 34.9573 6.90635C34.8557 7.11782 34.7992 7.34811 34.7915 7.58259C34.7915 8.12188 34.9807 8.58353 35.3576 8.96612C35.7346 9.34729 36.1906 9.53929 36.7285 9.53929C37.2367 9.53929 37.6616 9.34729 38.0075 8.96188C38.3435 8.60085 38.5288 8.12514 38.5256 7.632C38.4833 6.84988 38.0838 6.27106 37.3256 5.89835C36.5661 5.52424 35.6612 5.33788 34.6122 5.33788C33.6846 5.33281 32.7645 5.50533 31.9016 5.84612C31.0504 6.18494 30.3685 6.67482 29.8546 7.32C29.342 7.9626 29.0698 8.76402 29.0852 9.58588C29.0852 11.2235 30.0452 12.4489 31.9652 13.2621C32.904 13.6532 33.6734 14.0922 34.2706 14.5793C34.8692 15.0649 35.1685 15.6805 35.1685 16.4216C35.1304 17.7529 34.272 18.4193 32.5906 18.4193C31.7901 18.4193 31.1746 18.2979 30.744 18.0579C31.1746 18.0579 31.6758 17.9209 32.2433 17.6485C32.8136 17.3732 33.1256 16.7732 33.1821 15.8499C33.1821 15.2132 32.9788 14.6965 32.5722 14.2984C32.1848 13.9093 31.6627 13.6839 31.1139 13.6687C30.7087 13.6687 30.3304 13.7746 29.976 13.9864C29.6216 14.1995 29.3393 14.4805 29.1261 14.8334C28.9144 15.1835 28.8099 15.5534 28.8099 15.9402C28.8099 16.5656 29.0386 17.0838 29.4974 17.4988C29.9576 17.9125 30.5393 18.2174 31.2438 18.4136C31.9496 18.6085 32.6795 18.7158 33.4362 18.7341C34.1633 18.7341 34.8762 18.6353 35.5736 18.4376C36.2711 18.24 36.9021 17.9435 37.4682 17.5511C38.0329 17.1572 38.4791 16.6744 38.8038 16.0998C39.1285 15.5252 39.2894 14.8744 39.2894 14.1459C39.2753 13.4598 39.1186 12.864 38.8207 12.3614C38.5273 11.864 38.1329 11.4336 37.6631 11.0979C37.0838 10.6961 36.4728 10.342 35.8362 10.0391C35.3677 9.82853 34.9004 9.61535 34.4344 9.39953C33.9662 9.19072 33.5366 8.90434 33.1638 8.55247C32.9984 8.39516 32.8662 8.20629 32.775 7.99703C32.6838 7.78777 32.6355 7.56236 32.6329 7.33412C32.6329 6.80471 32.8885 6.37835 33.4009 6.05365C33.9134 5.72894 34.4852 5.56518 35.1205 5.56518C35.7501 5.56518 36.2739 5.664 36.6904 5.85882C36.2071 5.85208 35.7393 6.02921 35.3816 6.35435ZM40.9101 14.6456C40.9101 15.3911 41.0329 16.0588 41.2772 16.6489C41.5242 17.2376 41.9322 17.7106 42.5054 18.0664C43.0772 18.4235 43.8212 18.6141 44.736 18.6395C45.1228 18.6395 45.5252 18.5534 45.9431 18.3798C46.3624 18.2061 46.7054 17.9605 46.9793 17.64C47.2504 17.3209 47.3873 16.9581 47.3873 16.5515V13.5826H47.2009V16.5064C47.2009 16.7986 47.1304 17.064 46.9849 17.3054C46.8409 17.5454 46.6419 17.664 46.392 17.664C46.1365 17.664 45.9388 17.5412 45.7991 17.2969C45.6579 17.0513 45.5873 16.7887 45.5873 16.5064V6.65647H47.7304V5.76988H45.6325V0.727059C44.9647 1.55435 44.3661 2.14306 43.8367 2.49459C43.3073 2.84612 42.6847 3.02118 41.9675 3.02118C41.6277 3.02194 41.2884 2.99217 40.9539 2.93224V5.72612H39.3191V6.61271H40.9101V14.6456ZM53.0965 0.365647V0.638118H55.8409V18.0974H53.1868V18.3685H58.9948V18.0974H56.16V1.95671L61.2706 18.6395L66.3134 1.752V18.1412H63.8061V18.3685H74.6753V18.1412H71.9308V0.638118H74.5849V0.365647H66.3586L63.9191 8.60753L61.4569 0.367059H53.0965V0.365647ZM76.7689 7.2C76.9341 7.008 77.3068 6.79765 77.8899 6.56894C78.4729 6.33882 79.0899 6.22447 79.7435 6.22447C80.1473 6.22447 80.5129 6.29506 80.8391 6.43765C81.1652 6.58024 81.4249 6.80047 81.6184 7.10118C81.8104 7.39906 81.9078 7.77318 81.9078 8.21929V10.0376C81.9078 10.5784 81.6494 11.0245 81.1341 11.376C80.6188 11.7289 80.0711 11.9633 79.4894 12.0776C78.3656 12.2612 77.64 12.3868 77.3153 12.4489C76.9189 12.5384 76.5349 12.6759 76.1718 12.8584C75.7341 13.0701 75.3784 13.3878 75.1073 13.8127C74.8348 14.2376 74.6922 14.7953 74.6767 15.4871C74.6767 16.0631 74.8151 16.5911 75.0932 17.0711C75.3699 17.5511 75.7609 17.9322 76.2649 18.216C76.7689 18.4984 77.3464 18.6395 77.9944 18.6395C79.0673 18.6395 79.9002 18.3784 80.4988 17.8532C81.0974 17.3294 81.4969 16.7845 81.696 16.2212C81.8979 15.6565 81.9981 15.2753 81.9981 15.0762C81.9981 15.2951 82.0842 15.6847 82.2593 16.248C82.4329 16.8127 82.7901 17.3591 83.3294 17.8899C83.8701 18.4193 84.6381 18.6847 85.6348 18.6847C87.5252 18.6438 88.4697 17.7812 88.4697 16.0955V13.7647H88.2833V16.1478C88.2833 16.5614 88.1788 16.9666 87.9727 17.3633C87.7638 17.7614 87.5379 17.9605 87.2951 17.9605C87.1875 17.9615 87.0811 17.9393 86.9829 17.8955C86.8847 17.8516 86.7971 17.7871 86.7261 17.7064C86.5685 17.5358 86.4839 17.3103 86.4904 17.0781V8.60753C86.4904 7.96941 86.208 7.43859 85.6405 7.01788C85.0758 6.59577 84.3473 6.29082 83.4593 6.10024C82.5482 5.90783 81.6192 5.81224 80.688 5.81506C79.8438 5.81506 79.0433 5.93224 78.2866 6.16659C77.5299 6.40094 76.9115 6.76376 76.4315 7.25647C75.9515 7.74635 75.7115 8.34918 75.7115 9.06353C75.7115 9.72 75.9247 10.2748 76.3525 10.7252C76.7802 11.1769 77.3096 11.4028 77.9435 11.4028C78.3671 11.4028 78.7595 11.2941 79.1224 11.0809C79.477 10.8721 79.774 10.5781 79.9865 10.2256C80.1989 9.87314 80.3202 9.47325 80.3393 9.06212C80.3393 8.64847 80.2362 8.27859 80.0287 7.95106C79.8305 7.63833 79.5566 7.38069 79.2323 7.20201C78.908 7.02334 78.5439 6.92941 78.1737 6.92894C77.4988 6.97976 77.0301 7.07012 76.7689 7.2ZM81.6819 15.3176C81.5601 15.8162 81.361 16.2925 81.0918 16.7294C80.8489 17.1106 80.5976 17.2984 80.3393 17.2984C80.0951 17.28 79.9355 17.1049 79.8593 16.776C79.7817 16.4442 79.7435 15.9925 79.7435 15.4207V14.7388C79.7435 13.9186 79.8 13.2776 79.9144 12.8188C80.0287 12.3572 80.3167 11.9901 80.7769 11.7176C81.0614 11.5534 81.3282 11.3604 81.5732 11.1416C81.6943 11.0325 81.8062 10.9135 81.9078 10.7859V13.7125C81.9078 14.2193 81.8329 14.7544 81.6819 15.3176ZM96.7511 5.27012C96.8668 5.58071 96.9939 5.83906 97.1322 6.04659C97.272 6.25412 97.3567 6.35718 97.3864 6.35718C97.4005 6.35718 97.2536 6.30635 96.9445 6.20188C96.6084 6.09147 96.2662 6.00096 95.9195 5.93082C95.5456 5.85379 95.1648 5.815 94.7831 5.81506C94.0306 5.81506 93.2767 5.952 92.5214 6.22447C91.8068 6.47177 91.1625 6.88833 90.6438 7.43859C90.1482 7.97506 89.8913 8.60612 89.8772 9.33459C89.8772 9.90635 90.0155 10.3976 90.2922 10.8056C90.5704 11.2151 90.8711 11.5285 91.1958 11.7473C91.5219 11.9675 91.7266 12.0776 91.8085 12.0776C91.3638 12.2104 90.8075 12.5167 90.1426 12.9981C89.4762 13.4781 89.1431 14.1854 89.1431 15.12C89.1431 16.0588 89.4537 16.7831 90.0748 17.2941C90.696 17.8024 91.2141 18.1327 91.6278 18.2795C91.1732 18.3459 90.6014 18.5548 89.9167 18.9064C89.232 19.2579 88.8904 19.8508 88.8904 20.6852C88.8904 21.3911 89.1699 21.9939 89.7304 22.4951C90.2908 22.9962 91.0038 23.3704 91.8692 23.6245C92.727 23.874 93.6158 24.0005 94.5092 24C95.7064 24 96.8315 23.8024 97.8889 23.4042C98.9449 23.0075 99.8005 22.4019 100.454 21.5859C101.108 20.7713 101.434 19.7746 101.434 18.5958C101.434 17.6612 101.246 16.8551 100.869 16.176C100.492 15.4984 99.8908 14.9718 99.0621 14.5962C98.2334 14.2221 97.1746 14.0344 95.8857 14.0344C95.6118 14.0344 95.1445 14.0569 94.4852 14.1007C93.8259 14.1459 93.3402 14.1671 93.0297 14.1671C91.6489 14.1671 90.96 13.7986 90.96 13.0588C90.96 12.8442 91.0334 12.6819 91.1816 12.5746C91.4104 12.4197 91.6523 12.2851 91.9045 12.1722C92.0654 12.2795 92.4466 12.4306 93.0452 12.6268C93.6452 12.8216 94.2762 12.9205 94.9398 12.9205C95.7073 12.9113 96.4675 12.7704 97.1873 12.504C97.9264 12.2536 98.5979 11.8362 99.1497 11.2842C99.6762 10.7478 99.9402 10.1195 99.9402 9.39953C99.9402 8.79247 99.8019 8.29835 99.528 7.91294C99.2555 7.52894 98.8433 7.11388 98.2941 6.66777C97.7449 6.22306 97.3454 5.84329 97.0941 5.53129C96.8428 5.21929 96.7172 4.81271 96.7172 4.31435C96.7355 3.81176 96.8668 3.41929 97.1082 3.13553C97.3497 2.85318 97.5501 2.66965 97.7068 2.58494C97.6027 2.77737 97.5071 2.97427 97.4202 3.17506C97.3153 3.38927 97.2557 3.62286 97.2452 3.86118C97.2452 4.36376 97.4344 4.79294 97.8141 5.14588C98.1925 5.49882 98.6329 5.67529 99.1355 5.67529C99.6254 5.67529 100.042 5.50447 100.384 5.16C100.724 4.81553 100.906 4.39765 100.928 3.90494C100.928 3.57176 100.834 3.25835 100.645 2.96471C100.443 2.66498 100.171 2.41973 99.8515 2.25076C99.5323 2.08179 99.1762 1.99436 98.8151 1.99624C98.1882 2.04424 97.6645 2.26165 97.2423 2.65129C96.8216 3.03953 96.5986 3.59435 96.5774 4.31576C96.5774 4.64047 96.6339 4.95953 96.7511 5.27012ZM96.0706 10.1492C96.0706 10.8988 96 11.4904 95.8574 11.9195C95.7148 12.3501 95.4085 12.5788 94.9398 12.6042C94.3892 12.6042 94.0362 12.3035 93.8838 11.7007C93.7285 11.0979 93.6522 10.3242 93.6522 9.37835C93.6522 9.25694 93.6494 9.07059 93.6409 8.81929C93.6345 8.62689 93.6308 8.4344 93.6296 8.24188C93.6296 7.51765 93.7115 6.94729 93.8725 6.52941C94.0334 6.11153 94.3525 5.90259 94.8282 5.90259C95.0424 5.90049 95.2511 5.97006 95.4212 6.10024C95.5962 6.23153 95.7473 6.53788 95.8772 7.02353C96.0057 7.50776 96.0706 8.23059 96.0706 9.19624V10.1492ZM97.2 18.4828C97.6729 18.6169 98.1176 18.864 98.5327 19.2254C98.9492 19.5854 99.1652 20.0866 99.1793 20.7304C99.1793 21.4729 98.9506 22.0673 98.4904 22.5148C98.0043 22.9774 97.4041 23.3024 96.7511 23.4565C96.0173 23.6414 95.263 23.7325 94.5064 23.7275C93.4052 23.7275 92.4932 23.4678 91.7689 22.9468C91.0461 22.4245 90.6833 21.6113 90.6833 20.5031C90.6833 19.608 91.1068 18.8668 91.9496 18.2795H96.1609C96.3812 18.2795 96.7285 18.3473 97.2014 18.4828H97.2ZM103.601 7.2C103.766 7.008 104.14 6.79765 104.723 6.56894C105.313 6.33773 105.942 6.22083 106.576 6.22447C106.981 6.22447 107.346 6.29506 107.672 6.43765C107.997 6.58024 108.257 6.80047 108.45 7.10118C108.644 7.39906 108.74 7.77318 108.74 8.21929V10.0376C108.74 10.5784 108.483 11.0245 107.968 11.376C107.452 11.7289 106.904 11.9633 106.323 12.0776C105.198 12.2612 104.473 12.3868 104.149 12.4489C103.825 12.5125 103.443 12.6494 103.005 12.8584C102.568 13.0701 102.212 13.3878 101.941 13.8127C101.668 14.2376 101.524 14.7953 101.51 15.4871C101.502 16.0431 101.646 16.5908 101.925 17.0715C102.205 17.5523 102.61 17.9479 103.097 18.216C103.602 18.4984 104.178 18.6395 104.826 18.6395C105.899 18.6395 106.734 18.3784 107.332 17.8532C107.929 17.3294 108.329 16.7845 108.529 16.2212C108.73 15.6565 108.83 15.2753 108.83 15.0762C108.83 15.2951 108.918 15.6847 109.091 16.248C109.266 16.8127 109.624 17.3591 110.164 17.8899C110.702 18.4193 111.472 18.6847 112.468 18.6847C114.357 18.6438 115.302 17.7812 115.302 16.0955V13.7647H115.117V16.1478C115.117 16.5614 115.012 16.9666 114.805 17.3633C114.596 17.7614 114.37 17.9605 114.127 17.9605C114.02 17.9613 113.914 17.939 113.816 17.8952C113.718 17.8513 113.63 17.7869 113.56 17.7064C113.401 17.5361 113.316 17.3105 113.322 17.0781V8.60753C113.322 7.96941 113.04 7.43859 112.474 7.01788C111.909 6.59577 111.181 6.29082 110.293 6.10024C109.381 5.90779 108.452 5.8122 107.52 5.81506C106.707 5.81052 105.898 5.92903 105.12 6.16659C104.362 6.40094 103.744 6.76376 103.264 7.25647C103.028 7.49377 102.843 7.77611 102.719 8.08661C102.596 8.39711 102.536 8.72938 102.544 9.06353C102.544 9.72 102.758 10.2748 103.186 10.7252C103.612 11.1769 104.143 11.4028 104.777 11.4028C105.2 11.4028 105.593 11.2941 105.954 11.0809C106.309 10.8721 106.606 10.5781 106.818 10.2256C107.031 9.87314 107.152 9.47325 107.171 9.06212C107.171 8.64847 107.068 8.27859 106.862 7.95106C106.664 7.63814 106.39 7.38036 106.066 7.20166C105.742 7.02296 105.377 6.92915 105.007 6.92894C104.332 6.97976 103.864 7.07012 103.601 7.2ZM108.515 15.3176C108.366 15.8824 108.168 16.3511 107.925 16.7294C107.681 17.1106 107.431 17.2984 107.171 17.2984C106.928 17.28 106.768 17.1049 106.691 16.776C106.614 16.4442 106.576 15.9925 106.576 15.4207V14.7388C106.576 13.9186 106.632 13.2776 106.748 12.8188C106.861 12.3572 107.149 11.9901 107.609 11.7176C107.962 11.5031 108.227 11.3111 108.407 11.1416C108.583 10.9708 108.696 10.8522 108.74 10.7859V13.7125C108.74 14.2193 108.665 14.7544 108.515 15.3176ZM118.9 6.88376C119.372 6.88376 119.771 6.98824 120.097 7.19435C120.422 7.40047 120.822 7.71953 121.295 8.15153C121.768 8.58212 122.197 8.90541 122.582 9.12141C122.968 9.33741 123.439 9.44612 123.994 9.44612C124.801 9.43059 125.445 9.25412 125.922 8.91671C126.4 8.57788 126.726 8.24329 126.899 7.91012C127.073 7.57553 127.177 7.32565 127.21 7.16047C127.117 8.34635 126.815 9.23294 126.299 9.82306C125.787 10.4146 125.183 10.7972 124.488 10.9694C123.792 11.1431 122.921 11.256 121.871 11.3082C121.246 11.3563 120.63 11.4776 120.034 11.6696C119.364 11.8793 118.725 12.1764 118.134 12.5534C117.527 12.9388 117.025 13.4146 116.629 13.9821C116.228 14.5588 116.002 15.2385 115.976 15.9402C115.976 16.3581 116.061 16.7774 116.226 17.1995C116.393 17.6202 116.63 17.9661 116.936 18.2358C117.244 18.5054 117.6 18.6395 118.004 18.6395C118.289 18.6395 118.54 18.5435 118.756 18.3487C118.858 18.2657 118.94 18.1612 118.996 18.0429C119.052 17.9245 119.082 17.7951 119.082 17.664C119.082 17.3026 118.978 17.0259 118.768 16.8367C118.543 16.6405 118.252 16.538 117.954 16.5501C117.64 16.5501 117.39 16.6941 117.202 16.9793C117.014 17.2673 116.921 17.4805 116.921 17.6202C116.921 16.5304 117.435 15.9854 118.464 15.9854C118.986 15.9896 119.438 16.104 119.819 16.3313C120.2 16.5586 120.645 16.8918 121.151 17.3322C121.657 17.7713 122.105 18.1002 122.495 18.3162C122.884 18.5322 123.352 18.6409 123.895 18.6409C124.786 18.6409 125.527 18.3798 126.117 17.8588C126.707 17.3365 127.138 16.6687 127.408 15.8513C127.677 15.0353 127.813 14.1713 127.813 13.2579V11.1967H127.581V12.6042C127.581 13.1478 127.324 13.5784 126.812 13.896C126.302 14.2124 125.713 14.3775 125.113 14.3718C124.749 14.3718 124.422 14.3435 124.132 14.2885C123.74 14.2097 123.351 14.1174 122.965 14.0118C122.478 13.8833 122.072 13.7859 121.748 13.7209C121.386 13.6531 121.018 13.621 120.649 13.6249C119.534 13.6616 118.681 13.9228 118.094 14.4113C117.505 14.8984 117.126 15.4376 116.951 16.0264C116.784 16.5719 116.696 17.1387 116.691 17.7092C116.31 17.0541 116.116 16.4668 116.116 15.9402C116.159 15.1101 116.427 14.4155 116.924 13.8565C117.435 13.2892 118.084 12.8645 118.808 12.624C119.593 12.3552 120.417 12.2174 121.247 12.216C122.411 12.1906 123.453 11.9732 124.372 11.5624C125.29 11.1529 126.007 10.5854 126.525 9.86118C127.042 9.13661 127.33 8.27347 127.351 7.38353C127.358 6.91163 127.221 6.44885 126.959 6.05647C126.697 5.66541 126.352 5.47059 125.927 5.47059C125.64 5.4937 125.372 5.62013 125.171 5.82635C125.07 5.91675 124.989 6.02696 124.933 6.15011C124.877 6.27326 124.846 6.40671 124.844 6.54212C124.845 6.67652 124.873 6.80935 124.926 6.93294C124.978 7.05653 125.055 7.16841 125.152 7.26212C125.243 7.364 125.354 7.44546 125.479 7.50118C125.604 7.55689 125.739 7.5856 125.876 7.58541C126.051 7.58541 126.237 7.50776 126.433 7.35529C126.631 7.20282 126.775 7.07718 126.868 6.97835C126.868 7.14776 126.792 7.35953 126.642 7.61365C126.488 7.86635 126.157 7.99341 125.643 7.99341C125.235 7.99341 124.896 7.90165 124.626 7.72094C124.192 7.40897 123.776 7.07341 123.378 6.71576C122.816 6.22588 122.301 5.85882 121.83 5.61459C121.36 5.37035 120.806 5.24894 120.169 5.24894C119.571 5.25459 118.983 5.41197 118.461 5.70635C117.911 6.00036 117.438 6.42142 117.083 6.93459C116.735 7.42434 116.542 8.00691 116.527 8.60753C116.527 9.28094 116.726 9.87953 117.126 10.4061C117.524 10.9327 118.024 11.1967 118.622 11.1967C118.969 11.1967 119.3 11.1134 119.61 10.9468C119.911 10.7896 120.169 10.5619 120.363 10.2833C120.549 10.0189 120.649 9.70331 120.649 9.37976C120.649 8.89271 120.456 8.46353 120.071 8.09506C119.893 7.91768 119.682 7.7773 119.45 7.68206C119.218 7.58682 118.969 7.53861 118.718 7.54024C118.175 7.54024 117.74 7.73506 117.412 8.12471C117.088 8.50485 116.913 8.99021 116.921 9.48988C116.921 7.75341 117.58 6.88376 118.9 6.88376ZM133.662 4.872C134.058 4.62494 134.356 4.30024 134.555 3.89506C134.753 3.49129 134.853 3.06212 134.853 2.60753C134.853 1.90729 134.623 1.29741 134.164 0.777882C133.704 0.259765 133.059 0 132.226 0C131.397 0 130.749 0.261176 130.28 0.780706C129.812 1.30165 129.577 1.91012 129.577 2.60753C129.577 3.05929 129.68 3.48706 129.884 3.89224C130.087 4.29795 130.401 4.63768 130.79 4.872C131.188 5.12047 131.667 5.24329 132.226 5.24329C132.784 5.24329 133.262 5.12047 133.66 4.872H133.662ZM129.878 6.04235V18.3247H134.555V5.85882H127.897V6.04235H129.877H129.878ZM136.793 6.22447V18.3685H141.466V9.85553C141.466 9.43765 141.522 8.99435 141.641 8.52424C141.757 8.05553 141.919 7.66306 142.127 7.34965C142.334 7.03624 142.566 6.87812 142.821 6.87812C143.421 6.87812 143.72 7.78729 143.72 9.60565C143.72 10.2198 143.685 11.0922 143.613 12.2245C143.543 13.3567 143.5 14.0287 143.49 14.2391C143.49 15.1934 143.651 16.0066 143.973 16.6814C144.296 17.3548 144.74 17.8574 145.303 18.1892C145.868 18.5195 146.507 18.6833 147.223 18.6833C148.36 18.6438 149.129 18.3939 149.538 17.9336C149.944 17.4734 150.147 16.8099 150.147 15.9402V13.8071L149.917 13.7633V15.8965C149.917 17.0965 149.647 17.7318 149.106 17.8024C148.957 17.8108 148.81 17.7687 148.687 17.6829C148.565 17.5971 148.476 17.4725 148.433 17.3294C148.316 17.0132 148.258 16.4598 148.258 15.6692C148.28 14.6628 148.311 13.6567 148.348 12.6508C148.36 12.3868 148.374 11.8715 148.393 11.1021C148.393 7.65741 147.151 5.91106 144.665 5.85882C143.879 5.85882 143.207 6.09035 142.65 6.55482C142.093 7.01788 141.68 7.64188 141.415 8.42541V6.04235H135.572V6.22447H136.792H136.793ZM153.734 6.44047C152.778 7.03202 151.991 7.85947 151.447 8.84329C150.889 9.83133 150.585 10.9429 150.563 12.0776C150.563 13.368 150.857 14.5101 151.441 15.5054C152.006 16.4824 152.83 17.2839 153.823 17.8207C154.825 18.3671 155.927 18.6395 157.127 18.6395C158.651 18.6395 159.802 18.288 160.578 17.5849C161.355 16.8805 161.843 16.1506 162.048 15.3953C162.253 14.6386 162.354 14.0344 162.354 13.5798H162.124C162.124 13.7562 162.085 14.064 162.006 14.5031C161.928 14.9407 161.761 15.4348 161.509 15.9882C161.243 16.5561 160.852 17.0562 160.365 17.4508C159.854 17.8744 159.196 18.1186 158.39 18.1849C157.278 18.1849 156.531 17.6908 156.152 16.7026C155.774 15.7144 155.585 14.6202 155.585 13.4188C155.585 12.9049 155.593 12.6494 155.608 12.6494C156.154 12.8894 156.799 13.0094 157.542 13.0094C158.273 13.0094 158.984 12.8894 159.679 12.6494C160.371 12.4094 160.945 12.0339 161.399 11.5242C161.852 11.0132 162.079 10.3807 162.079 9.62824C162.079 9.04377 161.931 8.50306 161.634 8.00612C161.326 7.49627 160.919 7.05286 160.437 6.70165C159.927 6.32449 159.361 6.03049 158.759 5.83059C158.166 5.62771 157.544 5.52281 156.918 5.52C155.792 5.52515 154.69 5.8439 153.736 6.44047H153.734ZM155.855 6.23012C156.049 5.83059 156.344 5.63153 156.737 5.63153C157.262 5.63153 157.604 5.87576 157.763 6.36282C157.923 6.85129 158.003 7.51624 158.003 8.35906V8.96894C158.003 10.0871 157.919 10.9878 157.746 11.6696C157.577 12.3515 157.163 12.6932 156.507 12.6932C156.266 12.6751 156.03 12.6119 155.812 12.5068C155.646 12.4165 155.562 12.2287 155.562 11.9449V7.632C155.562 7.09553 155.661 6.62965 155.855 6.23012Z", fill: "black" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_49250" }, /* @__PURE__ */ d.createElement("rect", { width: 162.353, height: 24, fill: "white" })))), s0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 187, height: 16, viewBox: "0 0 187 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.841 14.4763L154.423 16H151.014L150.026 13.1692H144.076L143.064 16H139.654L145.746 0H148.309L153.515 13.6197L155.306 11.9335C156.364 12.928 157.797 13.2591 159.346 13.2591C161.272 13.2591 162.306 12.5748 162.306 11.3145C162.306 10.7618 162.141 10.2978 161.789 9.98892C161.459 9.70216 161.084 9.54585 160.31 9.43631L158.289 9.17169C156.858 8.97231 155.799 8.55262 155.047 7.86708C154.25 7.11631 153.851 6.09969 153.851 4.77415C153.851 1.968 156.058 0 159.675 0C161.976 0 163.645 0.530462 165.078 1.83385L163.01 3.75754C161.953 2.80615 160.685 2.67446 159.581 2.67446C157.843 2.67446 156.997 3.58031 156.997 4.66338C156.997 5.06092 157.138 5.48062 157.49 5.78954C157.82 6.07754 158.36 6.32 159.041 6.40862L161.014 6.67446C162.54 6.87262 163.504 7.27138 164.208 7.88923C165.101 8.68554 165.5 9.83385 165.5 11.2271C165.5 14.2757 162.8 16 159.299 16C157.089 16 155.341 15.6135 153.841 14.4763ZM70.7308 16V0H81.8077V2.78646H74.0132V6.54031H80.6507V9.32554H74.0132V13.2135H81.8077V16H70.7308ZM63.7388 10.0898L66.2372 0H69.5L65.2021 16H62.5904L59.6428 6.29169L56.6938 16H54.0846L49.8077 0H53.0717L55.5467 10.0898L58.4723 0H60.8132L63.7388 10.0898ZM83.0384 16V0H94.1154V2.78646H86.3209V6.54031H92.9584V9.32554H86.3209V13.2135H94.1154V16H83.0384ZM40.3984 6.67446C41.9246 6.87262 42.8883 7.27138 43.5923 7.88923C44.4858 8.68554 44.8846 9.83385 44.8846 11.2271C44.8846 14.2757 42.1843 16 38.684 16C36.1474 16 34.2212 15.4917 32.5769 13.9225L34.6901 11.9335C35.7486 12.928 37.1812 13.2591 38.7308 13.2591C40.6569 13.2591 41.6908 12.5748 41.6908 11.3145C41.6908 10.7618 41.5258 10.2978 41.1738 9.98892C40.844 9.70216 40.4686 9.54585 39.6944 9.43631L37.6735 9.17169C36.2409 8.97231 35.1837 8.55262 34.4329 7.86708C33.6329 7.11631 33.2341 6.09969 33.2341 4.77415C33.2341 1.968 35.4421 0 39.0594 0C41.3609 0 43.0298 0.530462 44.4624 1.83385L42.3948 3.75754C41.3375 2.80615 40.0698 2.67446 38.9658 2.67446C37.228 2.67446 36.3812 3.58031 36.3812 4.66338C36.3812 5.06092 36.5228 5.48062 36.876 5.78954C37.2034 6.07754 37.7437 6.32 38.4255 6.40862L40.3984 6.67446ZM0.576904 2.78646V0H11.6538V2.78646H7.62183V16H4.6089V2.78646H0.576904ZM21.8963 6.54031V0H25.1923V16H21.8963V9.30462H16.1806V16H12.8846V0H16.1806V6.53908H21.8963V6.54031ZM27.6538 16V0H31.3461V16H27.6538ZM166.731 16V0H170.423V16H166.731ZM176.993 10.5391H181.155L179.109 4.72L176.992 10.5391H176.993ZM180.309 0L186.423 16H183.014L182.026 13.1692H176.076L175.064 16H171.654L177.746 0H180.309ZM144.993 10.5391H149.155L147.109 4.72L144.993 10.5391ZM115.038 16V0H118.731V16H115.038ZM109.715 0L104.168 6.35939L110.115 16H106.307L102.006 8.71877L99.8446 11.1914V16H96.5769V0H99.8446V6.96615L105.742 0H109.715ZM130.362 9.79692V0H133.5V16H130.7L124.331 6.17846V16H121.192V0H123.992L130.362 9.79692Z", fill: "black" })), l0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1567 3.20829L19.7717 4.20332L11.0769 10.0104L2.3814 4.20332L2.95515 3.20829L11.0769 8.5998L19.1567 3.20829ZM20.4279 2.42031C20.4279 2.08813 20.3184 1.80524 20.1002 1.57014C19.8812 1.33503 19.6209 1.21748 19.3209 1.21748H2.83215C2.5314 1.21748 2.27115 1.33503 2.0529 1.57014C1.8339 1.80524 1.72515 2.08813 1.72515 2.42031V15.6507C1.72515 15.9829 1.8339 16.2665 2.0529 16.5009C2.27115 16.7367 2.5314 16.8535 2.83215 16.8535H19.3209C19.6209 16.8535 19.8812 16.7367 20.1002 16.5009C20.3184 16.2665 20.4279 15.9829 20.4279 15.6507V2.42031ZM20.9207 0.719966C21.3579 1.19018 21.5769 1.75671 21.5769 2.42031V15.6097C21.5769 16.2733 21.3579 16.8406 20.9207 17.3101C20.4827 17.7803 19.9494 18.0146 19.3209 18.0146H2.83215C2.20365 18.0146 1.6704 17.7803 1.23315 17.3101C0.795154 16.8406 0.576904 16.2733 0.576904 15.6097V2.42031C0.576904 1.75671 0.795154 1.19018 1.23315 0.719966C1.6704 0.250513 2.20365 0.0146484 2.83215 0.0146484H19.3209C19.9494 0.0146484 20.4827 0.250513 20.9207 0.719966Z", fill: "black" })), c0 = /* @__PURE__ */ H(l0, {
  target: "e5xr1380"
})({
  name: "afd8d5",
  styles: "margin-inline-start:12px"
}), u0 = () => {
  var e;
  const {
    config: t
  } = q(), {
    newsletterItemForDisplay: n
  } = hn(), r = {
    [t.newsletter.globalImpact]: /* @__PURE__ */ C.createElement(a0, null),
    [t.newsletter.lunar]: /* @__PURE__ */ C.createElement(i0, null),
    [t.newsletter.postMag]: /* @__PURE__ */ C.createElement(o0, null),
    [t.newsletter.thisWeekInAsia]: /* @__PURE__ */ C.createElement(s0, null)
  }, a = u2(n), i = (e = n == null ? void 0 : n.entityId) !== null && e !== void 0 ? e : "";
  return i in r ? /* @__PURE__ */ C.createElement(C.Fragment, null, r[i], /* @__PURE__ */ C.createElement(c0, null)) : /* @__PURE__ */ C.createElement(C.Fragment, null, a);
};
u0.displayName = "ArticleThemeTitle";
let fr = /* @__PURE__ */ function(e) {
  return e.Bookmark = "Bookmark", e.UnBookmark = "UnBookmark", e;
}({});
const d0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: "16px", height: "18px", viewBox: "0 0 16 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("filter", { id: "filter-1" }, /* @__PURE__ */ d.createElement("feColorMatrix", { in: "SourceGraphic", type: "matrix", values: "0 0 0 0 0.000000 0 0 0 0 0.070588 0 0 0 0 0.274510 0 0 0 1.000000 0" }))), /* @__PURE__ */ d.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ d.createElement("g", { id: "icon_savearticle", transform: "translate(-306.000000, -22.000000)" }, /* @__PURE__ */ d.createElement("g", { transform: "translate(306.000000, 22.000000)", fill: "#4585FF", id: "Fill-14" }, /* @__PURE__ */ d.createElement("path", { d: "M14.8618719,3.16414286 C14.8618719,2.62542857 14.6777537,2.15678571 14.3101478,1.75757143 C13.9425419,1.35964286 13.5055764,1.16035714 12.9998818,1.16035714 L3.00011823,1.16035714 C2.49442365,1.16035714 2.05682759,1.35964286 1.68922167,1.75757143 C1.32161576,2.15678571 1.13749754,2.62542857 1.13749754,3.16414286 L1.13749754,16.1016429 L8.06904433,11.5662857 L14.8618719,16.0662857 L14.8618719,3.16414286 Z M15.1374187,0.914142857 C15.7124729,1.52357143 16,2.26221429 16,3.12878571 L16,18 L8.06904433,12.7967143 L0,18 L0,3.12878571 C0,2.26221429 0.287527094,1.52357143 0.861950739,0.914142857 C1.43637438,0.305357143 2.12618719,0 2.93075862,0 L13.0686108,0 C13.8738128,0 14.5629951,0.305357143 15.1374187,0.914142857 L15.1374187,0.914142857 Z" }))))), f0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: "25px", height: "28px", viewBox: "0 0 25 28", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ d.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ d.createElement("g", { id: "icons_bookmarks-copy", transform: "translate(-272.000000, -439.000000)" }, /* @__PURE__ */ d.createElement("g", { id: "icon_bookmark_desktop_on", transform: "translate(272.000000, 439.000000)" }, /* @__PURE__ */ d.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z", id: "Path", fill: "#4585FF", opacity: 0.30392674 }), /* @__PURE__ */ d.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z M23.6522167,1.422 C24.5507389,2.37 25,3.519 25,4.867 L25,28 L12.6078818,19.906 L0,28 L0,4.867 C0,3.519 0.449261084,2.37 1.34679803,1.422 C2.24433498,0.475 3.32216749,0 4.57931034,0 L20.4197044,0 C21.6778325,0 22.7546798,0.475 23.6522167,1.422 L23.6522167,1.422 Z", id: "Fill-14", fill: "#4585ff" }))))), p0 = /* @__PURE__ */ H("button", {
  target: "e1wwhs9u2"
})("display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px;padding:7.5px;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer;", Ne, ";"), q2 = {
  name: "16o2qwc",
  styles: "inline-size:100%;block-size:100%"
}, m0 = /* @__PURE__ */ H(d0, {
  target: "e1wwhs9u1"
})(q2, ";"), g0 = /* @__PURE__ */ H(f0, {
  target: "e1wwhs9u0"
})(q2, ";"), I2 = ({
  className: e,
  isBookmarked: t,
  onClick: n
}) => {
  const r = (a) => {
    (async () => (await ko({
      priority: "user-blocking"
    }), n == null || n(t ? fr.UnBookmark : fr.Bookmark, a)))();
  };
  return /* @__PURE__ */ C.createElement(p0, {
    "aria-label": t ? "unbookmark" : "bookmark",
    className: e,
    onClick: r,
    "data-qa": "bookmark-button"
  }, t ? /* @__PURE__ */ C.createElement(g0, null) : /* @__PURE__ */ C.createElement(m0, null));
};
I2.displayName = "BookmarkButton";
const D2 = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "entityUuids"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "first"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "scmpPlusPaywallTypeIds"
  }], t = [{
    fields: [{
      kind: "Variable",
      name: "paywallTypeIds",
      variableName: "scmpPlusPaywallTypeIds"
    }],
    kind: "ObjectValue",
    name: "exclude"
  }, {
    fields: [{
      kind: "Variable",
      name: "entityUuids",
      variableName: "entityUuids"
    }],
    kind: "ObjectValue",
    name: "filter"
  }, {
    kind: "Variable",
    name: "first",
    variableName: "first"
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityUuid",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, a = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "__typename",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "urlAlias",
    storageKey: null
  }, o = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "headline",
    storageKey: null
  }, s = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "socialHeadline",
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [n, r, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryPanelArticle",
              selections: [a, n, r, i, o, s, {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  n
                  /*: any*/
                ],
                storageKey: null
              }],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuBookmarkButtonArticle",
              selections: [
                i,
                r
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuSocialButtonArticle",
              selections: [
                n,
                r,
                i,
                o,
                s
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "hooksRemoveReadingHistoryArticle",
              selections: [
                n,
                r
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              r,
              a,
              i,
              o,
              s,
              {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  n,
                  l
                  /*: any*/
                ],
                storageKey: null
              },
              l
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "09c86431a1ac0204ba9edf1bd9f7cdda",
      id: null,
      metadata: {},
      name: "hooksUseReadingHistoryWithArticleQuery",
      operationKind: "query",
      text: `query hooksUseReadingHistoryWithArticleQuery(
  $entityUuids: [String]!
  $first: Int!
  $scmpPlusPaywallTypeIds: [String]
) {
  articles(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, filter: {entityUuids: $entityUuids}, first: $first) {
    edges {
      node {
        entityUuid
        entityId
        ...readingHistoryPanelArticle
        ...readingHistoryActionMenuBookmarkButtonArticle
        ...readingHistoryActionMenuSocialButtonArticle
        ...hooksRemoveReadingHistoryArticle
        id
      }
    }
  }
}

fragment hooksRemoveReadingHistoryArticle on Article {
  entityUuid
  entityId
}

fragment readingHistoryActionMenuBookmarkButtonArticle on Article {
  urlAlias
  entityId
}

fragment readingHistoryActionMenuSocialButtonArticle on Article {
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
}

fragment readingHistoryPanelArticle on Article {
  __typename
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
  application {
    entityUuid
    id
  }
}
`
    }
  };
}();
D2.hash = "cbde35cb215893f736ea456fd1a2e149";
const B2 = {
  kind: "InlineDataFragment",
  name: "hooksRemoveReadingHistoryArticle"
};
B2.hash = "9cf9cb93788ef385dc0937902f020c9b";
var T1, pr;
function h0() {
  if (pr) return T1;
  pr = 1;
  var e = yn(), t = d2(), n = m2(), r = p2(), a = f2(), i = bn(), o = 200;
  function s(l, c, u, f) {
    var g = -1, p = t, v = !0, m = l.length, h = [], b = c.length;
    if (!m)
      return h;
    u && (c = r(c, a(u))), f ? (p = n, v = !1) : c.length >= o && (p = i, v = !1, c = new e(c));
    e:
      for (; ++g < m; ) {
        var w = l[g], E = u == null ? w : u(w);
        if (w = f || w !== 0 ? w : 0, v && E === E) {
          for (var y = b; y--; )
            if (c[y] === E)
              continue e;
          h.push(w);
        } else p(c, E, f) || h.push(w);
      }
    return h;
  }
  return T1 = s, T1;
}
var A1, mr;
function F2() {
  if (mr) return A1;
  mr = 1;
  function e(t, n) {
    for (var r = -1, a = n.length, i = t.length; ++r < a; )
      t[i + r] = n[r];
    return t;
  }
  return A1 = e, A1;
}
var P1, gr;
function C0() {
  if (gr) return P1;
  gr = 1;
  var e = p1(), t = Ge(), n = "[object Arguments]";
  function r(a) {
    return t(a) && e(a) == n;
  }
  return P1 = r, P1;
}
var L1, hr;
function v1() {
  if (hr) return L1;
  hr = 1;
  var e = C0(), t = Ge(), n = Object.prototype, r = n.hasOwnProperty, a = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(o) {
    return t(o) && r.call(o, "callee") && !a.call(o, "callee");
  };
  return L1 = i, L1;
}
var V1, Cr;
function J() {
  if (Cr) return V1;
  Cr = 1;
  var e = Array.isArray;
  return V1 = e, V1;
}
var M1, vr;
function v0() {
  if (vr) return M1;
  vr = 1;
  var e = wn(), t = v1(), n = J(), r = e ? e.isConcatSpreadable : void 0;
  function a(i) {
    return n(i) || t(i) || !!(r && i && i[r]);
  }
  return M1 = a, M1;
}
var R1, yr;
function y0() {
  if (yr) return R1;
  yr = 1;
  var e = F2(), t = v0();
  function n(r, a, i, o, s) {
    var l = -1, c = r.length;
    for (i || (i = t), s || (s = []); ++l < c; ) {
      var u = r[l];
      a > 0 && i(u) ? a > 1 ? n(u, a - 1, i, o, s) : e(s, u) : o || (s[s.length] = u);
    }
    return s;
  }
  return R1 = n, R1;
}
var O1, br;
function b0() {
  if (br) return O1;
  br = 1;
  var e = h0(), t = y0(), n = xo(), r = Eo(), a = n(function(i, o) {
    return r(i) ? e(i, t(o, 1, r, !0)) : [];
  });
  return O1 = a, O1;
}
var w0 = b0();
const k0 = /* @__PURE__ */ f1(w0);
var q1, wr;
function x0() {
  if (wr) return q1;
  wr = 1;
  var e = kn();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return q1 = t, q1;
}
var I1, kr;
function E0() {
  if (kr) return I1;
  kr = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return I1 = e, I1;
}
var D1, xr;
function _0() {
  if (xr) return D1;
  xr = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return D1 = e, D1;
}
var B1, Er;
function H0() {
  if (Er) return B1;
  Er = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return B1 = e, B1;
}
var F1, _r;
function S0() {
  if (_r) return F1;
  _r = 1;
  var e = kn(), t = g2(), n = h2(), r = 200;
  function a(i, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, o]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, o), this.size = s.size, this;
  }
  return F1 = a, F1;
}
var $1, Hr;
function $2() {
  if (Hr) return $1;
  Hr = 1;
  var e = kn(), t = x0(), n = E0(), r = _0(), a = H0(), i = S0();
  function o(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return o.prototype.clear = t, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = a, o.prototype.set = i, $1 = o, $1;
}
var U1, Sr;
function T0() {
  if (Sr) return U1;
  Sr = 1;
  function e(t, n) {
    for (var r = -1, a = t == null ? 0 : t.length; ++r < a; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return U1 = e, U1;
}
var z1, Tr;
function U2() {
  if (Tr) return z1;
  Tr = 1;
  var e = yn(), t = T0(), n = bn(), r = 1, a = 2;
  function i(o, s, l, c, u, f) {
    var g = l & r, p = o.length, v = s.length;
    if (p != v && !(g && v > p))
      return !1;
    var m = f.get(o), h = f.get(s);
    if (m && h)
      return m == s && h == o;
    var b = -1, w = !0, E = l & a ? new e() : void 0;
    for (f.set(o, s), f.set(s, o); ++b < p; ) {
      var y = o[b], k = s[b];
      if (c)
        var x = g ? c(k, y, b, s, o, f) : c(y, k, b, o, s, f);
      if (x !== void 0) {
        if (x)
          continue;
        w = !1;
        break;
      }
      if (E) {
        if (!t(s, function(_, P) {
          if (!n(E, P) && (y === _ || u(y, _, l, c, f)))
            return E.push(P);
        })) {
          w = !1;
          break;
        }
      } else if (!(y === k || u(y, k, l, c, f))) {
        w = !1;
        break;
      }
    }
    return f.delete(o), f.delete(s), w;
  }
  return z1 = i, z1;
}
var Z1, Ar;
function A0() {
  if (Ar) return Z1;
  Ar = 1;
  var e = Se(), t = e.Uint8Array;
  return Z1 = t, Z1;
}
var W1, Pr;
function P0() {
  if (Pr) return W1;
  Pr = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(a, i) {
      r[++n] = [i, a];
    }), r;
  }
  return W1 = e, W1;
}
var N1, Lr;
function _n() {
  if (Lr) return N1;
  Lr = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(a) {
      r[++n] = a;
    }), r;
  }
  return N1 = e, N1;
}
var j1, Vr;
function L0() {
  if (Vr) return j1;
  Vr = 1;
  var e = wn(), t = A0(), n = _o(), r = U2(), a = P0(), i = _n(), o = 1, s = 2, l = "[object Boolean]", c = "[object Date]", u = "[object Error]", f = "[object Map]", g = "[object Number]", p = "[object RegExp]", v = "[object Set]", m = "[object String]", h = "[object Symbol]", b = "[object ArrayBuffer]", w = "[object DataView]", E = e ? e.prototype : void 0, y = E ? E.valueOf : void 0;
  function k(x, _, P, A, L, S, V) {
    switch (P) {
      case w:
        if (x.byteLength != _.byteLength || x.byteOffset != _.byteOffset)
          return !1;
        x = x.buffer, _ = _.buffer;
      case b:
        return !(x.byteLength != _.byteLength || !S(new t(x), new t(_)));
      case l:
      case c:
      case g:
        return n(+x, +_);
      case u:
        return x.name == _.name && x.message == _.message;
      case p:
      case m:
        return x == _ + "";
      case f:
        var T = a;
      case v:
        var R = A & o;
        if (T || (T = i), x.size != _.size && !R)
          return !1;
        var I = V.get(x);
        if (I)
          return I == _;
        A |= s, V.set(x, _);
        var M = r(T(x), T(_), A, L, S, V);
        return V.delete(x), M;
      case h:
        if (y)
          return y.call(x) == y.call(_);
    }
    return !1;
  }
  return j1 = k, j1;
}
var G1, Mr;
function V0() {
  if (Mr) return G1;
  Mr = 1;
  var e = F2(), t = J();
  function n(r, a, i) {
    var o = a(r);
    return t(r) ? o : e(o, i(r));
  }
  return G1 = n, G1;
}
var K1, Rr;
function M0() {
  if (Rr) return K1;
  Rr = 1;
  function e(t, n) {
    for (var r = -1, a = t == null ? 0 : t.length, i = 0, o = []; ++r < a; ) {
      var s = t[r];
      n(s, r, t) && (o[i++] = s);
    }
    return o;
  }
  return K1 = e, K1;
}
var Y1, Or;
function R0() {
  if (Or) return Y1;
  Or = 1;
  function e() {
    return [];
  }
  return Y1 = e, Y1;
}
var Q1, qr;
function O0() {
  if (qr) return Q1;
  qr = 1;
  var e = M0(), t = R0(), n = Object.prototype, r = n.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(o) {
    return o == null ? [] : (o = Object(o), e(a(o), function(s) {
      return r.call(o, s);
    }));
  } : t;
  return Q1 = i, Q1;
}
var X1, Ir;
function q0() {
  if (Ir) return X1;
  Ir = 1;
  function e(t, n) {
    for (var r = -1, a = Array(t); ++r < t; )
      a[r] = n(r);
    return a;
  }
  return X1 = e, X1;
}
var Oe = { exports: {} }, J1, Dr;
function I0() {
  if (Dr) return J1;
  Dr = 1;
  function e() {
    return !1;
  }
  return J1 = e, J1;
}
Oe.exports;
var Br;
function Hn() {
  return Br || (Br = 1, function(e, t) {
    var n = Se(), r = I0(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
    e.exports = c;
  }(Oe, Oe.exports)), Oe.exports;
}
var et, Fr;
function z2() {
  if (Fr) return et;
  Fr = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, a) {
    var i = typeof r;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < a;
  }
  return et = n, et;
}
var tt, $r;
function D0() {
  if ($r) return tt;
  $r = 1;
  var e = p1(), t = C2(), n = Ge(), r = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", o = "[object Date]", s = "[object Error]", l = "[object Function]", c = "[object Map]", u = "[object Number]", f = "[object Object]", g = "[object RegExp]", p = "[object Set]", v = "[object String]", m = "[object WeakMap]", h = "[object ArrayBuffer]", b = "[object DataView]", w = "[object Float32Array]", E = "[object Float64Array]", y = "[object Int8Array]", k = "[object Int16Array]", x = "[object Int32Array]", _ = "[object Uint8Array]", P = "[object Uint8ClampedArray]", A = "[object Uint16Array]", L = "[object Uint32Array]", S = {};
  S[w] = S[E] = S[y] = S[k] = S[x] = S[_] = S[P] = S[A] = S[L] = !0, S[r] = S[a] = S[h] = S[i] = S[b] = S[o] = S[s] = S[l] = S[c] = S[u] = S[f] = S[g] = S[p] = S[v] = S[m] = !1;
  function V(T) {
    return n(T) && t(T.length) && !!S[e(T)];
  }
  return tt = V, tt;
}
var qe = { exports: {} };
qe.exports;
var Ur;
function B0() {
  return Ur || (Ur = 1, function(e, t) {
    var n = Ho(), r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, i = a && a.exports === r, o = i && n.process, s = function() {
      try {
        var l = a && a.require && a.require("util").types;
        return l || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(qe, qe.exports)), qe.exports;
}
var nt, zr;
function Sn() {
  if (zr) return nt;
  zr = 1;
  var e = D0(), t = f2(), n = B0(), r = n && n.isTypedArray, a = r ? t(r) : e;
  return nt = a, nt;
}
var rt, Zr;
function F0() {
  if (Zr) return rt;
  Zr = 1;
  var e = q0(), t = v1(), n = J(), r = Hn(), a = z2(), i = Sn(), o = Object.prototype, s = o.hasOwnProperty;
  function l(c, u) {
    var f = n(c), g = !f && t(c), p = !f && !g && r(c), v = !f && !g && !p && i(c), m = f || g || p || v, h = m ? e(c.length, String) : [], b = h.length;
    for (var w in c)
      (u || s.call(c, w)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (w == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (w == "offset" || w == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      v && (w == "buffer" || w == "byteLength" || w == "byteOffset") || // Skip index properties.
      a(w, b))) && h.push(w);
    return h;
  }
  return rt = l, rt;
}
var at, Wr;
function Z2() {
  if (Wr) return at;
  Wr = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, a = typeof r == "function" && r.prototype || e;
    return n === a;
  }
  return at = t, at;
}
var it, Nr;
function $0() {
  if (Nr) return it;
  Nr = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return it = e, it;
}
var ot, jr;
function U0() {
  if (jr) return ot;
  jr = 1;
  var e = $0(), t = e(Object.keys, Object);
  return ot = t, ot;
}
var st, Gr;
function W2() {
  if (Gr) return st;
  Gr = 1;
  var e = Z2(), t = U0(), n = Object.prototype, r = n.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var o = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && o.push(s);
    return o;
  }
  return st = a, st;
}
var lt, Kr;
function Tn() {
  if (Kr) return lt;
  Kr = 1;
  var e = F0(), t = W2(), n = xn();
  function r(a) {
    return n(a) ? e(a) : t(a);
  }
  return lt = r, lt;
}
var ct, Yr;
function z0() {
  if (Yr) return ct;
  Yr = 1;
  var e = V0(), t = O0(), n = Tn();
  function r(a) {
    return e(a, n, t);
  }
  return ct = r, ct;
}
var ut, Qr;
function Z0() {
  if (Qr) return ut;
  Qr = 1;
  var e = z0(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function a(i, o, s, l, c, u) {
    var f = s & t, g = e(i), p = g.length, v = e(o), m = v.length;
    if (p != m && !f)
      return !1;
    for (var h = p; h--; ) {
      var b = g[h];
      if (!(f ? b in o : r.call(o, b)))
        return !1;
    }
    var w = u.get(i), E = u.get(o);
    if (w && E)
      return w == o && E == i;
    var y = !0;
    u.set(i, o), u.set(o, i);
    for (var k = f; ++h < p; ) {
      b = g[h];
      var x = i[b], _ = o[b];
      if (l)
        var P = f ? l(_, x, b, o, i, u) : l(x, _, b, i, o, u);
      if (!(P === void 0 ? x === _ || c(x, _, s, l, u) : P)) {
        y = !1;
        break;
      }
      k || (k = b == "constructor");
    }
    if (y && !k) {
      var A = i.constructor, L = o.constructor;
      A != L && "constructor" in i && "constructor" in o && !(typeof A == "function" && A instanceof A && typeof L == "function" && L instanceof L) && (y = !1);
    }
    return u.delete(i), u.delete(o), y;
  }
  return ut = a, ut;
}
var dt, Xr;
function W0() {
  if (Xr) return dt;
  Xr = 1;
  var e = m1(), t = Se(), n = e(t, "DataView");
  return dt = n, dt;
}
var ft, Jr;
function N0() {
  if (Jr) return ft;
  Jr = 1;
  var e = m1(), t = Se(), n = e(t, "Promise");
  return ft = n, ft;
}
var pt, ea;
function N2() {
  if (ea) return pt;
  ea = 1;
  var e = m1(), t = Se(), n = e(t, "Set");
  return pt = n, pt;
}
var mt, ta;
function j0() {
  if (ta) return mt;
  ta = 1;
  var e = m1(), t = Se(), n = e(t, "WeakMap");
  return mt = n, mt;
}
var gt, na;
function j2() {
  if (na) return gt;
  na = 1;
  var e = W0(), t = g2(), n = N0(), r = N2(), a = j0(), i = p1(), o = So(), s = "[object Map]", l = "[object Object]", c = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", g = "[object DataView]", p = o(e), v = o(t), m = o(n), h = o(r), b = o(a), w = i;
  return (e && w(new e(new ArrayBuffer(1))) != g || t && w(new t()) != s || n && w(n.resolve()) != c || r && w(new r()) != u || a && w(new a()) != f) && (w = function(E) {
    var y = i(E), k = y == l ? E.constructor : void 0, x = k ? o(k) : "";
    if (x)
      switch (x) {
        case p:
          return g;
        case v:
          return s;
        case m:
          return c;
        case h:
          return u;
        case b:
          return f;
      }
    return y;
  }), gt = w, gt;
}
var ht, ra;
function G0() {
  if (ra) return ht;
  ra = 1;
  var e = $2(), t = U2(), n = L0(), r = Z0(), a = j2(), i = J(), o = Hn(), s = Sn(), l = 1, c = "[object Arguments]", u = "[object Array]", f = "[object Object]", g = Object.prototype, p = g.hasOwnProperty;
  function v(m, h, b, w, E, y) {
    var k = i(m), x = i(h), _ = k ? u : a(m), P = x ? u : a(h);
    _ = _ == c ? f : _, P = P == c ? f : P;
    var A = _ == f, L = P == f, S = _ == P;
    if (S && o(m)) {
      if (!o(h))
        return !1;
      k = !0, A = !1;
    }
    if (S && !A)
      return y || (y = new e()), k || s(m) ? t(m, h, b, w, E, y) : n(m, h, _, b, w, E, y);
    if (!(b & l)) {
      var V = A && p.call(m, "__wrapped__"), T = L && p.call(h, "__wrapped__");
      if (V || T) {
        var R = V ? m.value() : m, I = T ? h.value() : h;
        return y || (y = new e()), E(R, I, b, w, y);
      }
    }
    return S ? (y || (y = new e()), r(m, h, b, w, E, y)) : !1;
  }
  return ht = v, ht;
}
var Ct, aa;
function G2() {
  if (aa) return Ct;
  aa = 1;
  var e = G0(), t = Ge();
  function n(r, a, i, o, s) {
    return r === a ? !0 : r == null || a == null || !t(r) && !t(a) ? r !== r && a !== a : e(r, a, i, o, n, s);
  }
  return Ct = n, Ct;
}
var vt, ia;
function K0() {
  if (ia) return vt;
  ia = 1;
  var e = $2(), t = G2(), n = 1, r = 2;
  function a(i, o, s, l) {
    var c = s.length, u = c, f = !l;
    if (i == null)
      return !u;
    for (i = Object(i); c--; ) {
      var g = s[c];
      if (f && g[2] ? g[1] !== i[g[0]] : !(g[0] in i))
        return !1;
    }
    for (; ++c < u; ) {
      g = s[c];
      var p = g[0], v = i[p], m = g[1];
      if (f && g[2]) {
        if (v === void 0 && !(p in i))
          return !1;
      } else {
        var h = new e();
        if (l)
          var b = l(v, m, p, i, o, h);
        if (!(b === void 0 ? t(m, v, n | r, l, h) : b))
          return !1;
      }
    }
    return !0;
  }
  return vt = a, vt;
}
var yt, oa;
function K2() {
  if (oa) return yt;
  oa = 1;
  var e = To();
  function t(n) {
    return n === n && !e(n);
  }
  return yt = t, yt;
}
var bt, sa;
function Y0() {
  if (sa) return bt;
  sa = 1;
  var e = K2(), t = Tn();
  function n(r) {
    for (var a = t(r), i = a.length; i--; ) {
      var o = a[i], s = r[o];
      a[i] = [o, s, e(s)];
    }
    return a;
  }
  return bt = n, bt;
}
var wt, la;
function Y2() {
  if (la) return wt;
  la = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return wt = e, wt;
}
var kt, ca;
function Q0() {
  if (ca) return kt;
  ca = 1;
  var e = K0(), t = Y0(), n = Y2();
  function r(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(o) {
      return o === a || e(o, a, i);
    };
  }
  return kt = r, kt;
}
var xt, ua;
function An() {
  if (ua) return xt;
  ua = 1;
  var e = p1(), t = Ge(), n = "[object Symbol]";
  function r(a) {
    return typeof a == "symbol" || t(a) && e(a) == n;
  }
  return xt = r, xt;
}
var Et, da;
function Pn() {
  if (da) return Et;
  da = 1;
  var e = J(), t = An(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function a(i, o) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || o != null && i in Object(o);
  }
  return Et = a, Et;
}
var _t, fa;
function X0() {
  if (fa) return _t;
  fa = 1;
  var e = h2(), t = "Expected a function";
  function n(r, a) {
    if (typeof r != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var o = arguments, s = a ? a.apply(this, o) : o[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var c = r.apply(this, o);
      return i.cache = l.set(s, c) || l, c;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, _t = n, _t;
}
var Ht, pa;
function J0() {
  if (pa) return Ht;
  pa = 1;
  var e = X0(), t = 500;
  function n(r) {
    var a = e(r, function(o) {
      return i.size === t && i.clear(), o;
    }), i = a.cache;
    return a;
  }
  return Ht = n, Ht;
}
var St, ma;
function e3() {
  if (ma) return St;
  ma = 1;
  var e = J0(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(o, s, l, c) {
      i.push(l ? c.replace(n, "$1") : s || o);
    }), i;
  });
  return St = r, St;
}
var Tt, ga;
function t3() {
  if (ga) return Tt;
  ga = 1;
  var e = wn(), t = p2(), n = J(), r = An(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, o) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return Tt = o, Tt;
}
var At, ha;
function n3() {
  if (ha) return At;
  ha = 1;
  var e = t3();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return At = t, At;
}
var Pt, Ca;
function Q2() {
  if (Ca) return Pt;
  Ca = 1;
  var e = J(), t = Pn(), n = e3(), r = n3();
  function a(i, o) {
    return e(i) ? i : t(i, o) ? [i] : n(r(i));
  }
  return Pt = a, Pt;
}
var Lt, va;
function y1() {
  if (va) return Lt;
  va = 1;
  var e = An();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return Lt = t, Lt;
}
var Vt, ya;
function X2() {
  if (ya) return Vt;
  ya = 1;
  var e = Q2(), t = y1();
  function n(r, a) {
    a = e(a, r);
    for (var i = 0, o = a.length; r != null && i < o; )
      r = r[t(a[i++])];
    return i && i == o ? r : void 0;
  }
  return Vt = n, Vt;
}
var Mt, ba;
function r3() {
  if (ba) return Mt;
  ba = 1;
  var e = X2();
  function t(n, r, a) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? a : i;
  }
  return Mt = t, Mt;
}
var Rt, wa;
function a3() {
  if (wa) return Rt;
  wa = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return Rt = e, Rt;
}
var Ot, ka;
function i3() {
  if (ka) return Ot;
  ka = 1;
  var e = Q2(), t = v1(), n = J(), r = z2(), a = C2(), i = y1();
  function o(s, l, c) {
    l = e(l, s);
    for (var u = -1, f = l.length, g = !1; ++u < f; ) {
      var p = i(l[u]);
      if (!(g = s != null && c(s, p)))
        break;
      s = s[p];
    }
    return g || ++u != f ? g : (f = s == null ? 0 : s.length, !!f && a(f) && r(p, f) && (n(s) || t(s)));
  }
  return Ot = o, Ot;
}
var qt, xa;
function o3() {
  if (xa) return qt;
  xa = 1;
  var e = a3(), t = i3();
  function n(r, a) {
    return r != null && t(r, a, e);
  }
  return qt = n, qt;
}
var It, Ea;
function s3() {
  if (Ea) return It;
  Ea = 1;
  var e = G2(), t = r3(), n = o3(), r = Pn(), a = K2(), i = Y2(), o = y1(), s = 1, l = 2;
  function c(u, f) {
    return r(u) && a(f) ? i(o(u), f) : function(g) {
      var p = t(g, u);
      return p === void 0 && p === f ? n(g, u) : e(f, p, s | l);
    };
  }
  return It = c, It;
}
var Dt, _a;
function l3() {
  if (_a) return Dt;
  _a = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return Dt = e, Dt;
}
var Bt, Ha;
function c3() {
  if (Ha) return Bt;
  Ha = 1;
  var e = X2();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return Bt = t, Bt;
}
var Ft, Sa;
function u3() {
  if (Sa) return Ft;
  Sa = 1;
  var e = l3(), t = c3(), n = Pn(), r = y1();
  function a(i) {
    return n(i) ? e(r(i)) : t(i);
  }
  return Ft = a, Ft;
}
var $t, Ta;
function J2() {
  if (Ta) return $t;
  Ta = 1;
  var e = Q0(), t = s3(), n = Ao(), r = J(), a = u3();
  function i(o) {
    return typeof o == "function" ? o : o == null ? n : typeof o == "object" ? r(o) ? t(o[0], o[1]) : e(o) : a(o);
  }
  return $t = i, $t;
}
var Ut, Aa;
function d3() {
  if (Aa) return Ut;
  Aa = 1;
  function e() {
  }
  return Ut = e, Ut;
}
var zt, Pa;
function f3() {
  if (Pa) return zt;
  Pa = 1;
  var e = N2(), t = d3(), n = _n(), r = 1 / 0, a = e && 1 / n(new e([, -0]))[1] == r ? function(i) {
    return new e(i);
  } : t;
  return zt = a, zt;
}
var Zt, La;
function p3() {
  if (La) return Zt;
  La = 1;
  var e = yn(), t = d2(), n = m2(), r = bn(), a = f3(), i = _n(), o = 200;
  function s(l, c, u) {
    var f = -1, g = t, p = l.length, v = !0, m = [], h = m;
    if (u)
      v = !1, g = n;
    else if (p >= o) {
      var b = c ? null : a(l);
      if (b)
        return i(b);
      v = !1, g = r, h = new e();
    } else
      h = c ? [] : m;
    e:
      for (; ++f < p; ) {
        var w = l[f], E = c ? c(w) : w;
        if (w = u || w !== 0 ? w : 0, v && E === E) {
          for (var y = h.length; y--; )
            if (h[y] === E)
              continue e;
          c && h.push(E), m.push(w);
        } else g(h, E, u) || (h !== m && h.push(E), m.push(w));
      }
    return m;
  }
  return Zt = s, Zt;
}
var Wt, Va;
function m3() {
  if (Va) return Wt;
  Va = 1;
  var e = J2(), t = p3();
  function n(r, a) {
    return r && r.length ? t(r, e(a, 2)) : [];
  }
  return Wt = n, Wt;
}
var g3 = m3();
const h3 = /* @__PURE__ */ f1(g3), Ma = async (e, t, n, r = 0) => (await e.get(`items/${t}`, {
  params: {
    limit: n,
    offset: r,
    tz: Ln()
  },
  withCredentials: !0
})).data.data || [], C3 = (e, t, n) => e.post("/create", n.map(({
  createdAt: r,
  entityUuid: a,
  expiresAt: i
}) => ({
  createdAt: r,
  entitySubType: "article",
  entityType: "node",
  entityUuid: a,
  expiresAt: i,
  itemType: "log",
  userUuid: t
})), {
  withCredentials: !0
}), v3 = (e, t, n) => e.post("/items/delete", {
  entityUuids: [t]
}, {
  params: {
    day: ei(n),
    tz: Ln()
  },
  withCredentials: !0
}), y3 = (e, t, n) => e.delete(`/items/${n}`, {
  params: {
    day: ei(t),
    tz: Ln()
  },
  withCredentials: !0
}), Ln = () => Intl.DateTimeFormat().resolvedOptions().timeZone, ei = (e) => P2(new Date(e), "yyyy-MM-dd"), Nt = {
  lastSyncedDate: "userArticleReadingHistoryLastUpdate",
  pending: "userNewArticleReadingHistory",
  synced: "userArticleReadingHistory"
}, Ra = 50, ke = (e) => P2(e, "dd MMM yyyy"), b3 = () => {
  const {
    currentArticleUuid: e,
    user: t
  } = q(), {
    createReadingHistory: n,
    fetchReadingHistory: r,
    lastSyncedDate: a,
    resetLocalReadingHistory: i,
    syncReadingHistory: o
  } = Vn();
  Te(async () => {
    await r();
  }), B(() => {
    t || i();
  }, [i, t]), B(() => {
    e && n(e);
  }, [n, e]), Wo(() => {
    d6(/* @__PURE__ */ new Date(), new Date(a ?? 0)) < 1 || o();
  }, [o, e, a]);
}, w3 = () => {
  const {
    user: e
  } = q(), {
    pendingReadingHistory: t,
    syncedReadingHistory: n
  } = ti();
  return {
    readingHistory: ce(() => e ? [...t ?? [], ...n ?? []].sort((i, o) => o.createdAt - i.createdAt) : [], [t, n, e])
  };
}, Vn = () => {
  const {
    config: e,
    handleTrackGA4: t,
    user: n
  } = q(), r = ce(() => vn.create({
    baseURL: e.readingHistory.host,
    headers: {
      apikey: e.readingHistory.apiKey
    }
  }), [e]), {
    lastSyncedDate: a,
    pendingReadingHistory: i,
    setLastSyncedDate: o,
    setPendingReadingHistory: s,
    setSyncedReadingHistory: l
  } = ti(), c = $(async () => {
    if (!n || a) return;
    const m = await Ma(r, n.uuid, Ra);
    l(m.map((h) => ({
      createdAt: new Date(h.createdAt).getTime(),
      entityUuid: h.entityUuid
    }))), o(Date.now());
  }, [r, a, o, l, n]), u = $(async () => {
    if (!n || !i || i.length === 0) return;
    const m = i.map((h) => ({
      createdAt: new Date(h.createdAt),
      entityUuid: h.entityUuid,
      expiresAt: new Date(h.createdAt)
    }));
    await C3(r, n.uuid, m);
    try {
      const h = await Ma(r, n.uuid, Ra);
      l(h.map((b) => ({
        createdAt: new Date(b.createdAt).getTime(),
        entityUuid: b.entityUuid
      }))), o(Date.now());
    } catch {
      l((h) => [...i ?? [], ...h ?? []]);
    } finally {
      s([]);
    }
  }, [r, i, o, s, l, n]), f = $((m) => {
    if (!n) return;
    const h = {
      createdAt: Date.now(),
      entityUuid: m
    };
    s((b) => h3([h, ...b ?? []], (E) => `${E.entityUuid}-${ke(E.createdAt)}`)), l((b) => [...b ?? []].filter((w) => !(w.entityUuid === h.entityUuid && ke(w.createdAt) === ke(h.createdAt))));
  }, [s, l, n]), g = $(async (m) => {
    if (!n) return;
    const h = (b) => [...b ?? []].filter((w) => ke(w.createdAt) !== m);
    s(h), l(h), await y3(r, m, n.uuid), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "clear"
      },
      subcategory: ""
    });
  }, [r, t, s, l, n]), p = $(async (m, h) => {
    if (!n) return;
    const {
      entityId: b,
      entityUuid: w
    } = o1(B2, m), E = (y) => [...y ?? []].filter((k) => !(k.entityUuid === w && k.createdAt === h));
    s(E), l(E), await v3(r, w, ke(h)), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "remove",
        article_id: b ?? ""
      },
      subcategory: ""
    });
  }, [r, t, s, l, n]), v = $(() => {
    s([]), l([]), o(0);
  }, [o, s, l]);
  return {
    clearReadingHistory: g,
    createReadingHistory: f,
    fetchReadingHistory: c,
    lastSyncedDate: a,
    removeReadingHistory: p,
    resetLocalReadingHistory: v,
    syncReadingHistory: u
  };
}, ti = () => {
  const {
    set: e,
    value: t
  } = ie(Nt.pending), {
    set: n,
    value: r
  } = ie(Nt.synced), {
    set: a,
    value: i
  } = ie(Nt.lastSyncedDate);
  return {
    lastSyncedDate: i,
    pendingReadingHistory: t,
    setLastSyncedDate: a,
    setPendingReadingHistory: e,
    setSyncedReadingHistory: n,
    syncedReadingHistory: r
  };
}, k3 = () => {
  const e = v2(), {
    readingHistory: t
  } = w3(), n = i6(), r = We(), [a, i] = Ke(async () => {
    const o = k0(t.map((l) => l.entityUuid), [...n.keys()]);
    if (o.length > 0) {
      const l = D2, c = {
        entityUuids: [...o],
        first: o.length,
        scmpPlusPaywallTypeIds: [uo.article.paywallTypeId]
      }, u = Mo(l), f = Ro(u, c), g = await y2(e, l, c).toPromise();
      r.current = e.retain(f), g == null || g.articles.edges.forEach(({
        node: p
      }) => {
        n.set(p.entityUuid, p);
      });
    }
    return t.map((l) => {
      const c = n.get(l.entityUuid);
      if (c)
        return {
          ...l,
          article: c
        };
    }).filter(Uo);
  }, []);
  return B(() => (i.execute(), () => {
    var o;
    (o = r.current) === null || o === void 0 || o.dispose();
  }), [i, t]), {
    state: a
  };
}, ni = () => {
  const {
    set: e,
    value: t
  } = ie("isFirstTimeVisitSCMPNotificationWidgetVersionTwo", {
    defaultValue: !0
  });
  return {
    isFirstTime: t,
    setIsFirstTime: e
  };
}, x3 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0157 10.0393L20 18.9843L19.0629 20L10 10.9764L1.01571 20L0 18.9843L8.98429 10.0393L0 1.01571L1.01571 0L10 9.02357L19.0629 0L20 1.01571L11.0157 10.0393Z", fill: "#001246" })), E3 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 32, height: 25, viewBox: "0 0 32 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 25H32V0H0V25Z", fill: "#FEFEFE" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.76069 22.2007H14.6138V2.79626H2.76019L2.76069 22.2007Z", fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3866 22.2007H29.2397V2.79626H17.3866V22.2007Z", fill: "#001246" })), _3 = (e) => {
  const [t, n] = Ke(async () => {
    const a = await Promise.allSettled(e.map((i) => i()));
    for (const i of a)
      if (!(i.status === "rejected" || i.value === null))
        return i.value;
  });
  return x2(() => {
    n.execute();
  }, [e]), {
    message: t.status === "success" ? t.result : void 0
  };
}, ri = {
  kind: "InlineDataFragment",
  name: "readingHistoryPanelArticle"
};
ri.hash = "af787a050af248c5e8bd042565039780";
const H3 = qs;
function S3(e) {
  return Os(e);
}
function T3(e) {
  return M2("MuiSvgIcon", e);
}
vs("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const A3 = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, a = {
    root: ["root", t !== "inherit" && `color${i1(t)}`, `fontSize${i1(n)}`]
  };
  return En(a, T3, r);
}, P3 = Bs("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${i1(n.color)}`], t[`fontSize${i1(n.fontSize)}`]];
  }
})(H3(({
  theme: e
}) => {
  var t, n, r, a, i, o, s, l, c, u, f, g, p, v;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (a = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : a.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (m) => !m.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((o = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : o.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((l = (s = e.typography) == null ? void 0 : s.pxToRem) == null ? void 0 : l.call(s, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((u = (c = e.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : u.call(c, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, m]) => m && m.main).map(([m]) => {
        var h, b;
        return {
          props: {
            color: m
          },
          style: {
            color: (b = (h = (e.vars ?? e).palette) == null ? void 0 : h[m]) == null ? void 0 : b.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (g = (f = (e.vars ?? e).palette) == null ? void 0 : f.action) == null ? void 0 : g.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (v = (p = (e.vars ?? e).palette) == null ? void 0 : p.action) == null ? void 0 : v.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), ln = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = S3({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: a,
    className: i,
    color: o = "inherit",
    component: s = "svg",
    fontSize: l = "medium",
    htmlColor: c,
    inheritViewBox: u = !1,
    titleAccess: f,
    viewBox: g = "0 0 24 24",
    ...p
  } = r, v = /* @__PURE__ */ d.isValidElement(a) && a.type === "svg", m = {
    ...r,
    color: o,
    component: s,
    fontSize: l,
    instanceFontSize: t.fontSize,
    inheritViewBox: u,
    viewBox: g,
    hasSvgAsChild: v
  }, h = {};
  u || (h.viewBox = g);
  const b = A3(m);
  return /* @__PURE__ */ Y.jsxs(P3, {
    as: s,
    className: on(b.root, i),
    focusable: "false",
    color: c,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n,
    ...h,
    ...p,
    ...v && a.props,
    ownerState: m,
    children: [v ? a.props.children : a, f ? /* @__PURE__ */ Y.jsx("title", {
      children: f
    }) : null]
  });
});
ln.muiName = "SvgIcon";
function L3(e, t) {
  function n(r, a) {
    return /* @__PURE__ */ Y.jsx(ln, {
      "data-testid": `${t}Icon`,
      ref: a,
      ...r,
      children: e
    });
  }
  return n.muiName = ln.muiName, /* @__PURE__ */ d.memo(/* @__PURE__ */ d.forwardRef(n));
}
const V3 = L3(/* @__PURE__ */ Y.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHoriz");
var jt, Oa;
function M3() {
  if (Oa) return jt;
  Oa = 1;
  var e = Po();
  function t(n, r, a) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : n[r] = a;
  }
  return jt = t, jt;
}
var Gt, qa;
function R3() {
  if (qa) return Gt;
  qa = 1;
  function e(t, n, r, a) {
    for (var i = -1, o = t == null ? 0 : t.length; ++i < o; ) {
      var s = t[i];
      n(a, s, r(s), t);
    }
    return a;
  }
  return Gt = e, Gt;
}
var Kt, Ia;
function O3() {
  if (Ia) return Kt;
  Ia = 1;
  function e(t) {
    return function(n, r, a) {
      for (var i = -1, o = Object(n), s = a(n), l = s.length; l--; ) {
        var c = s[t ? l : ++i];
        if (r(o[c], c, o) === !1)
          break;
      }
      return n;
    };
  }
  return Kt = e, Kt;
}
var Yt, Da;
function q3() {
  if (Da) return Yt;
  Da = 1;
  var e = O3(), t = e();
  return Yt = t, Yt;
}
var Qt, Ba;
function I3() {
  if (Ba) return Qt;
  Ba = 1;
  var e = q3(), t = Tn();
  function n(r, a) {
    return r && e(r, a, t);
  }
  return Qt = n, Qt;
}
var Xt, Fa;
function D3() {
  if (Fa) return Xt;
  Fa = 1;
  var e = xn();
  function t(n, r) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return n(a, i);
      for (var o = a.length, s = r ? o : -1, l = Object(a); (r ? s-- : ++s < o) && i(l[s], s, l) !== !1; )
        ;
      return a;
    };
  }
  return Xt = t, Xt;
}
var Jt, $a;
function B3() {
  if ($a) return Jt;
  $a = 1;
  var e = I3(), t = D3(), n = t(e);
  return Jt = n, Jt;
}
var en, Ua;
function F3() {
  if (Ua) return en;
  Ua = 1;
  var e = B3();
  function t(n, r, a, i) {
    return e(n, function(o, s, l) {
      r(i, o, a(o), l);
    }), i;
  }
  return en = t, en;
}
var tn, za;
function $3() {
  if (za) return tn;
  za = 1;
  var e = R3(), t = F3(), n = J2(), r = J();
  function a(i, o) {
    return function(s, l) {
      var c = r(s) ? e : t, u = o ? o() : {};
      return c(s, i, n(l, 2), u);
    };
  }
  return tn = a, tn;
}
var nn, Za;
function U3() {
  if (Za) return nn;
  Za = 1;
  var e = M3(), t = $3(), n = Object.prototype, r = n.hasOwnProperty, a = t(function(i, o, s) {
    r.call(i, s) ? i[s].push(o) : e(i, s, [o]);
  });
  return nn = a, nn;
}
var z3 = U3();
const Z3 = /* @__PURE__ */ f1(z3), ai = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuBookmarkButtonArticle"
};
ai.hash = "a7c80ae823596510ff3e2edc0684d236";
const ii = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuSocialButtonArticle"
};
ii.hash = "f4c88864c5a03b3f32c07b9080058e99";
const W3 = () => {
  const {
    bookmark: e
  } = q(), t = $(({
    entityId: r
  }) => e.check({
    entityId: r
  }), [e]);
  return {
    bindBookmarkButton: $(({
      entityId: r,
      trackings: a
    }, i) => ({
      isBookmarked: t({
        entityId: r
      }),
      onClick: (l) => {
        e.update({
          action: l,
          entityId: r,
          trackings: a
        }), i == null || i();
      }
    }), [e, t]),
    checkIsBookmarked: t
  };
};
var U = "top", G = "bottom", K = "right", z = "left", Mn = "auto", Ye = [U, G, K, z], xe = "start", ze = "end", N3 = "clippingParents", oi = "viewport", Me = "popper", j3 = "reference", Wa = /* @__PURE__ */ Ye.reduce(function(e, t) {
  return e.concat([t + "-" + xe, t + "-" + ze]);
}, []), si = /* @__PURE__ */ [].concat(Ye, [Mn]).reduce(function(e, t) {
  return e.concat([t, t + "-" + xe, t + "-" + ze]);
}, []), G3 = "beforeRead", K3 = "read", Y3 = "afterRead", Q3 = "beforeMain", X3 = "main", J3 = "afterMain", e4 = "beforeWrite", t4 = "write", n4 = "afterWrite", r4 = [G3, K3, Y3, Q3, X3, J3, e4, t4, n4];
function ne(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function N(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ve(e) {
  var t = N(e).Element;
  return e instanceof t || e instanceof Element;
}
function j(e) {
  var t = N(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Rn(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = N(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function a4(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, i = t.elements[n];
    !j(i) || !ne(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function i4(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], i = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !j(a) || !ne(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const o4 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: a4,
  effect: i4,
  requires: ["computeStyles"]
};
function ee(e) {
  return e.split("-")[0];
}
var he = Math.max, u1 = Math.min, Ee = Math.round;
function cn() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function li() {
  return !/^((?!chrome|android).)*safari/i.test(cn());
}
function _e(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), a = 1, i = 1;
  t && j(e) && (a = e.offsetWidth > 0 && Ee(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Ee(r.height) / e.offsetHeight || 1);
  var o = ve(e) ? N(e) : window, s = o.visualViewport, l = !li() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / a, u = (r.top + (l && s ? s.offsetTop : 0)) / i, f = r.width / a, g = r.height / i;
  return {
    width: f,
    height: g,
    top: u,
    right: c + f,
    bottom: u + g,
    left: c,
    x: c,
    y: u
  };
}
function On(e) {
  var t = _e(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function ci(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Rn(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function oe(e) {
  return N(e).getComputedStyle(e);
}
function s4(e) {
  return ["table", "td", "th"].indexOf(ne(e)) >= 0;
}
function de(e) {
  return ((ve(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function b1(e) {
  return ne(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Rn(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    de(e)
  );
}
function Na(e) {
  return !j(e) || // https://github.com/popperjs/popper-core/issues/837
  oe(e).position === "fixed" ? null : e.offsetParent;
}
function l4(e) {
  var t = /firefox/i.test(cn()), n = /Trident/i.test(cn());
  if (n && j(e)) {
    var r = oe(e);
    if (r.position === "fixed")
      return null;
  }
  var a = b1(e);
  for (Rn(a) && (a = a.host); j(a) && ["html", "body"].indexOf(ne(a)) < 0; ) {
    var i = oe(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Qe(e) {
  for (var t = N(e), n = Na(e); n && s4(n) && oe(n).position === "static"; )
    n = Na(n);
  return n && (ne(n) === "html" || ne(n) === "body" && oe(n).position === "static") ? t : n || l4(e) || t;
}
function qn(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Be(e, t, n) {
  return he(e, u1(t, n));
}
function c4(e, t, n) {
  var r = Be(e, t, n);
  return r > n ? n : r;
}
function ui() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function di(e) {
  return Object.assign({}, ui(), e);
}
function fi(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var u4 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, di(typeof t != "number" ? t : fi(t, Ye));
};
function d4(e) {
  var t, n = e.state, r = e.name, a = e.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = ee(n.placement), l = qn(s), c = [z, K].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!i || !o)) {
    var f = u4(a.padding, n), g = On(i), p = l === "y" ? U : z, v = l === "y" ? G : K, m = n.rects.reference[u] + n.rects.reference[l] - o[l] - n.rects.popper[u], h = o[l] - n.rects.reference[l], b = Qe(i), w = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, E = m / 2 - h / 2, y = f[p], k = w - g[u] - f[v], x = w / 2 - g[u] / 2 + E, _ = Be(y, x, k), P = l;
    n.modifiersData[r] = (t = {}, t[P] = _, t.centerOffset = _ - x, t);
  }
}
function f4(e) {
  var t = e.state, n = e.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || ci(t.elements.popper, a) && (t.elements.arrow = a));
}
const p4 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: d4,
  effect: f4,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function He(e) {
  return e.split("-")[1];
}
var m4 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function g4(e, t) {
  var n = e.x, r = e.y, a = t.devicePixelRatio || 1;
  return {
    x: Ee(n * a) / a || 0,
    y: Ee(r * a) / a || 0
  };
}
function ja(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, f = e.isFixed, g = o.x, p = g === void 0 ? 0 : g, v = o.y, m = v === void 0 ? 0 : v, h = typeof u == "function" ? u({
    x: p,
    y: m
  }) : {
    x: p,
    y: m
  };
  p = h.x, m = h.y;
  var b = o.hasOwnProperty("x"), w = o.hasOwnProperty("y"), E = z, y = U, k = window;
  if (c) {
    var x = Qe(n), _ = "clientHeight", P = "clientWidth";
    if (x === N(n) && (x = de(n), oe(x).position !== "static" && s === "absolute" && (_ = "scrollHeight", P = "scrollWidth")), x = x, a === U || (a === z || a === K) && i === ze) {
      y = G;
      var A = f && x === k && k.visualViewport ? k.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[_]
      );
      m -= A - r.height, m *= l ? 1 : -1;
    }
    if (a === z || (a === U || a === G) && i === ze) {
      E = K;
      var L = f && x === k && k.visualViewport ? k.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[P]
      );
      p -= L - r.width, p *= l ? 1 : -1;
    }
  }
  var S = Object.assign({
    position: s
  }, c && m4), V = u === !0 ? g4({
    x: p,
    y: m
  }, N(n)) : {
    x: p,
    y: m
  };
  if (p = V.x, m = V.y, l) {
    var T;
    return Object.assign({}, S, (T = {}, T[y] = w ? "0" : "", T[E] = b ? "0" : "", T.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + m + "px)" : "translate3d(" + p + "px, " + m + "px, 0)", T));
  }
  return Object.assign({}, S, (t = {}, t[y] = w ? m + "px" : "", t[E] = b ? p + "px" : "", t.transform = "", t));
}
function h4(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: ee(t.placement),
    variation: He(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ja(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ja(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const C4 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: h4,
  data: {}
};
var n1 = {
  passive: !0
};
function v4(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, l = N(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, n1);
  }), s && l.addEventListener("resize", n.update, n1), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, n1);
    }), s && l.removeEventListener("resize", n.update, n1);
  };
}
const y4 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: v4,
  data: {}
};
var b4 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function a1(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return b4[t];
  });
}
var w4 = {
  start: "end",
  end: "start"
};
function Ga(e) {
  return e.replace(/start|end/g, function(t) {
    return w4[t];
  });
}
function In(e) {
  var t = N(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Dn(e) {
  return _e(de(e)).left + In(e).scrollLeft;
}
function k4(e, t) {
  var n = N(e), r = de(e), a = n.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    var c = li();
    (c || !c && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + Dn(e),
    y: l
  };
}
function x4(e) {
  var t, n = de(e), r = In(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = he(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = he(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + Dn(e), l = -r.scrollTop;
  return oe(a || n).direction === "rtl" && (s += he(n.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function Bn(e) {
  var t = oe(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function pi(e) {
  return ["html", "body", "#document"].indexOf(ne(e)) >= 0 ? e.ownerDocument.body : j(e) && Bn(e) ? e : pi(b1(e));
}
function Fe(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = pi(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = N(r), o = a ? [i].concat(i.visualViewport || [], Bn(r) ? r : []) : r, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Fe(b1(o)))
  );
}
function un(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function E4(e, t) {
  var n = _e(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Ka(e, t, n) {
  return t === oi ? un(k4(e, n)) : ve(t) ? E4(t, n) : un(x4(de(e)));
}
function _4(e) {
  var t = Fe(b1(e)), n = ["absolute", "fixed"].indexOf(oe(e).position) >= 0, r = n && j(e) ? Qe(e) : e;
  return ve(r) ? t.filter(function(a) {
    return ve(a) && ci(a, r) && ne(a) !== "body";
  }) : [];
}
function H4(e, t, n, r) {
  var a = t === "clippingParents" ? _4(e) : [].concat(t), i = [].concat(a, [n]), o = i[0], s = i.reduce(function(l, c) {
    var u = Ka(e, c, r);
    return l.top = he(u.top, l.top), l.right = u1(u.right, l.right), l.bottom = u1(u.bottom, l.bottom), l.left = he(u.left, l.left), l;
  }, Ka(e, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function mi(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? ee(r) : null, i = r ? He(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (a) {
    case U:
      l = {
        x: o,
        y: t.y - n.height
      };
      break;
    case G:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case K:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case z:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = a ? qn(a) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case xe:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case ze:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Ze(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, i = n.strategy, o = i === void 0 ? e.strategy : i, s = n.boundary, l = s === void 0 ? N3 : s, c = n.rootBoundary, u = c === void 0 ? oi : c, f = n.elementContext, g = f === void 0 ? Me : f, p = n.altBoundary, v = p === void 0 ? !1 : p, m = n.padding, h = m === void 0 ? 0 : m, b = di(typeof h != "number" ? h : fi(h, Ye)), w = g === Me ? j3 : Me, E = e.rects.popper, y = e.elements[v ? w : g], k = H4(ve(y) ? y : y.contextElement || de(e.elements.popper), l, u, o), x = _e(e.elements.reference), _ = mi({
    reference: x,
    element: E,
    placement: a
  }), P = un(Object.assign({}, E, _)), A = g === Me ? P : x, L = {
    top: k.top - A.top + b.top,
    bottom: A.bottom - k.bottom + b.bottom,
    left: k.left - A.left + b.left,
    right: A.right - k.right + b.right
  }, S = e.modifiersData.offset;
  if (g === Me && S) {
    var V = S[a];
    Object.keys(L).forEach(function(T) {
      var R = [K, G].indexOf(T) >= 0 ? 1 : -1, I = [U, G].indexOf(T) >= 0 ? "y" : "x";
      L[T] += V[I] * R;
    });
  }
  return L;
}
function S4(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? si : l, u = He(r), f = u ? s ? Wa : Wa.filter(function(v) {
    return He(v) === u;
  }) : Ye, g = f.filter(function(v) {
    return c.indexOf(v) >= 0;
  });
  g.length === 0 && (g = f);
  var p = g.reduce(function(v, m) {
    return v[m] = Ze(e, {
      placement: m,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[ee(m)], v;
  }, {});
  return Object.keys(p).sort(function(v, m) {
    return p[v] - p[m];
  });
}
function T4(e) {
  if (ee(e) === Mn)
    return [];
  var t = a1(e);
  return [Ga(e), t, Ga(t)];
}
function A4(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, u = n.boundary, f = n.rootBoundary, g = n.altBoundary, p = n.flipVariations, v = p === void 0 ? !0 : p, m = n.allowedAutoPlacements, h = t.options.placement, b = ee(h), w = b === h, E = l || (w || !v ? [a1(h)] : T4(h)), y = [h].concat(E).reduce(function(be, se) {
      return be.concat(ee(se) === Mn ? S4(t, {
        placement: se,
        boundary: u,
        rootBoundary: f,
        padding: c,
        flipVariations: v,
        allowedAutoPlacements: m
      }) : se);
    }, []), k = t.rects.reference, x = t.rects.popper, _ = /* @__PURE__ */ new Map(), P = !0, A = y[0], L = 0; L < y.length; L++) {
      var S = y[L], V = ee(S), T = He(S) === xe, R = [U, G].indexOf(V) >= 0, I = R ? "width" : "height", M = Ze(t, {
        placement: S,
        boundary: u,
        rootBoundary: f,
        altBoundary: g,
        padding: c
      }), D = R ? T ? K : z : T ? G : U;
      k[I] > x[I] && (D = a1(D));
      var Z = a1(D), fe = [];
      if (i && fe.push(M[V] <= 0), s && fe.push(M[D] <= 0, M[Z] <= 0), fe.every(function(be) {
        return be;
      })) {
        A = S, P = !1;
        break;
      }
      _.set(S, fe);
    }
    if (P)
      for (var Xe = v ? 3 : 1, w1 = function(se) {
        var Pe = y.find(function(e1) {
          var pe = _.get(e1);
          if (pe)
            return pe.slice(0, se).every(function(k1) {
              return k1;
            });
        });
        if (Pe)
          return A = Pe, "break";
      }, Ae = Xe; Ae > 0; Ae--) {
        var Je = w1(Ae);
        if (Je === "break") break;
      }
    t.placement !== A && (t.modifiersData[r]._skip = !0, t.placement = A, t.reset = !0);
  }
}
const P4 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: A4,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ya(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Qa(e) {
  return [U, K, G, z].some(function(t) {
    return e[t] >= 0;
  });
}
function L4(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = Ze(t, {
    elementContext: "reference"
  }), s = Ze(t, {
    altBoundary: !0
  }), l = Ya(o, r), c = Ya(s, a, i), u = Qa(l), f = Qa(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const V4 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: L4
};
function M4(e, t, n) {
  var r = ee(e), a = [z, U].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [z, K].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function R4(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, i = a === void 0 ? [0, 0] : a, o = si.reduce(function(u, f) {
    return u[f] = M4(f, t.rects, i), u;
  }, {}), s = o[t.placement], l = s.x, c = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = o;
}
const O4 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: R4
};
function q4(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = mi({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const I4 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: q4,
  data: {}
};
function D4(e) {
  return e === "x" ? "y" : "x";
}
function B4(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, f = n.padding, g = n.tether, p = g === void 0 ? !0 : g, v = n.tetherOffset, m = v === void 0 ? 0 : v, h = Ze(t, {
    boundary: l,
    rootBoundary: c,
    padding: f,
    altBoundary: u
  }), b = ee(t.placement), w = He(t.placement), E = !w, y = qn(b), k = D4(y), x = t.modifiersData.popperOffsets, _ = t.rects.reference, P = t.rects.popper, A = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, L = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), S = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, V = {
    x: 0,
    y: 0
  };
  if (x) {
    if (i) {
      var T, R = y === "y" ? U : z, I = y === "y" ? G : K, M = y === "y" ? "height" : "width", D = x[y], Z = D + h[R], fe = D - h[I], Xe = p ? -P[M] / 2 : 0, w1 = w === xe ? _[M] : P[M], Ae = w === xe ? -P[M] : -_[M], Je = t.elements.arrow, be = p && Je ? On(Je) : {
        width: 0,
        height: 0
      }, se = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ui(), Pe = se[R], e1 = se[I], pe = Be(0, _[M], be[M]), k1 = E ? _[M] / 2 - Xe - pe - Pe - L.mainAxis : w1 - pe - Pe - L.mainAxis, Ui = E ? -_[M] / 2 + Xe + pe + e1 + L.mainAxis : Ae + pe + e1 + L.mainAxis, x1 = t.elements.arrow && Qe(t.elements.arrow), zi = x1 ? y === "y" ? x1.clientTop || 0 : x1.clientLeft || 0 : 0, $n = (T = S == null ? void 0 : S[y]) != null ? T : 0, Zi = D + k1 - $n - zi, Wi = D + Ui - $n, Un = Be(p ? u1(Z, Zi) : Z, D, p ? he(fe, Wi) : fe);
      x[y] = Un, V[y] = Un - D;
    }
    if (s) {
      var zn, Ni = y === "x" ? U : z, ji = y === "x" ? G : K, me = x[k], t1 = k === "y" ? "height" : "width", Zn = me + h[Ni], Wn = me - h[ji], E1 = [U, z].indexOf(b) !== -1, Nn = (zn = S == null ? void 0 : S[k]) != null ? zn : 0, jn = E1 ? Zn : me - _[t1] - P[t1] - Nn + L.altAxis, Gn = E1 ? me + _[t1] + P[t1] - Nn - L.altAxis : Wn, Kn = p && E1 ? c4(jn, me, Gn) : Be(p ? jn : Zn, me, p ? Gn : Wn);
      x[k] = Kn, V[k] = Kn - me;
    }
    t.modifiersData[r] = V;
  }
}
const F4 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: B4,
  requiresIfExists: ["offset"]
};
function $4(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function U4(e) {
  return e === N(e) || !j(e) ? In(e) : $4(e);
}
function z4(e) {
  var t = e.getBoundingClientRect(), n = Ee(t.width) / e.offsetWidth || 1, r = Ee(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Z4(e, t, n) {
  n === void 0 && (n = !1);
  var r = j(t), a = j(t) && z4(t), i = de(t), o = _e(e, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ne(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Bn(i)) && (s = U4(t)), j(t) ? (l = _e(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = Dn(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function W4(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && a(l);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || a(i);
  }), r;
}
function N4(e) {
  var t = W4(e);
  return r4.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function j4(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function G4(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Xa = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ja() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function K4(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, i = a === void 0 ? Xa : a;
  return function(s, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Xa, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], g = !1, p = {
      state: u,
      setOptions: function(b) {
        var w = typeof b == "function" ? b(u.options) : b;
        m(), u.options = Object.assign({}, i, u.options, w), u.scrollParents = {
          reference: ve(s) ? Fe(s) : s.contextElement ? Fe(s.contextElement) : [],
          popper: Fe(l)
        };
        var E = N4(G4([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = E.filter(function(y) {
          return y.enabled;
        }), v(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var b = u.elements, w = b.reference, E = b.popper;
          if (Ja(w, E)) {
            u.rects = {
              reference: Z4(w, Qe(E), u.options.strategy === "fixed"),
              popper: On(E)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(L) {
              return u.modifiersData[L.name] = Object.assign({}, L.data);
            });
            for (var y = 0; y < u.orderedModifiers.length; y++) {
              if (u.reset === !0) {
                u.reset = !1, y = -1;
                continue;
              }
              var k = u.orderedModifiers[y], x = k.fn, _ = k.options, P = _ === void 0 ? {} : _, A = k.name;
              typeof x == "function" && (u = x({
                state: u,
                options: P,
                name: A,
                instance: p
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: j4(function() {
        return new Promise(function(h) {
          p.forceUpdate(), h(u);
        });
      }),
      destroy: function() {
        m(), g = !0;
      }
    };
    if (!Ja(s, l))
      return p;
    p.setOptions(c).then(function(h) {
      !g && c.onFirstUpdate && c.onFirstUpdate(h);
    });
    function v() {
      u.orderedModifiers.forEach(function(h) {
        var b = h.name, w = h.options, E = w === void 0 ? {} : w, y = h.effect;
        if (typeof y == "function") {
          var k = y({
            state: u,
            name: b,
            instance: p,
            options: E
          }), x = function() {
          };
          f.push(k || x);
        }
      });
    }
    function m() {
      f.forEach(function(h) {
        return h();
      }), f = [];
    }
    return p;
  };
}
var Y4 = [y4, I4, C4, o4, O4, P4, F4, p4, V4], Q4 = /* @__PURE__ */ K4({
  defaultModifiers: Y4
});
function X4(e) {
  return typeof e == "function" ? e() : e;
}
const J4 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    children: r,
    container: a,
    disablePortal: i = !1
  } = t, [o, s] = d.useState(null), l = $e(/* @__PURE__ */ d.isValidElement(r) ? ro(r) : null, n);
  if (c1(() => {
    i || s(X4(a) || document.body);
  }, [a, i]), c1(() => {
    if (o && !i)
      return lr(n, o), () => {
        lr(n, null);
      };
  }, [n, o, i]), i) {
    if (/* @__PURE__ */ d.isValidElement(r)) {
      const c = {
        ref: l
      };
      return /* @__PURE__ */ d.cloneElement(r, c);
    }
    return r;
  }
  return o && /* @__PURE__ */ r6.createPortal(r, o);
}), gi = "base";
function e7(e) {
  return `${gi}--${e}`;
}
function t7(e, t) {
  return `${gi}-${e}-${t}`;
}
function Fn(e, t) {
  const n = V2[t];
  return n ? e7(n) : t7(e, t);
}
function hi(e, t) {
  const n = {};
  return t.forEach((r) => {
    n[r] = Fn(e, r);
  }), n;
}
const Ci = "Popper";
function n7(e) {
  return Fn(Ci, e);
}
hi(Ci, ["root"]);
const r7 = {
  disableDefaultClasses: !1
}, a7 = /* @__PURE__ */ d.createContext(r7);
function vi(e) {
  const {
    disableDefaultClasses: t
  } = d.useContext(a7);
  return (n) => t ? "" : e(n);
}
function i7(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function dn(e) {
  return typeof e == "function" ? e() : e;
}
function o7(e) {
  return e.nodeType !== void 0;
}
const s7 = () => En({
  root: ["root"]
}, vi(n7)), l7 = {}, c7 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: a,
    direction: i,
    disablePortal: o,
    modifiers: s,
    open: l,
    placement: c,
    popperOptions: u,
    popperRef: f,
    slotProps: g = {},
    slots: p = {},
    TransitionProps: v,
    // @ts-ignore internal logic
    ownerState: m,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...h
  } = t, b = d.useRef(null), w = $e(b, n), E = d.useRef(null), y = $e(E, f), k = d.useRef(y);
  c1(() => {
    k.current = y;
  }, [y]), d.useImperativeHandle(f, () => E.current, []);
  const x = i7(c, i), [_, P] = d.useState(x), [A, L] = d.useState(dn(r));
  d.useEffect(() => {
    E.current && E.current.forceUpdate();
  }), d.useEffect(() => {
    r && L(dn(r));
  }, [r]), c1(() => {
    if (!A || !l)
      return;
    const I = (Z) => {
      P(Z.placement);
    };
    let M = [{
      name: "preventOverflow",
      options: {
        altBoundary: o
      }
    }, {
      name: "flip",
      options: {
        altBoundary: o
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: Z
      }) => {
        I(Z);
      }
    }];
    s != null && (M = M.concat(s)), u && u.modifiers != null && (M = M.concat(u.modifiers));
    const D = Q4(A, b.current, {
      placement: x,
      ...u,
      modifiers: M
    });
    return k.current(D), () => {
      D.destroy(), k.current(null);
    };
  }, [A, o, s, l, u, x]);
  const S = {
    placement: _
  };
  v !== null && (S.TransitionProps = v);
  const V = s7(), T = p.root ?? "div", R = Re({
    elementType: T,
    externalSlotProps: g.root,
    externalForwardedProps: h,
    additionalProps: {
      role: "tooltip",
      ref: w
    },
    ownerState: t,
    className: V.root
  });
  return /* @__PURE__ */ Y.jsx(T, {
    ...R,
    children: typeof a == "function" ? a(S) : a
  });
}), u7 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: a,
    container: i,
    direction: o = "ltr",
    disablePortal: s = !1,
    keepMounted: l = !1,
    modifiers: c,
    open: u,
    placement: f = "bottom",
    popperOptions: g = l7,
    popperRef: p,
    style: v,
    transition: m = !1,
    slotProps: h = {},
    slots: b = {},
    ...w
  } = t, [E, y] = d.useState(!0), k = () => {
    y(!1);
  }, x = () => {
    y(!0);
  };
  if (!l && !u && (!m || E))
    return null;
  let _;
  if (i)
    _ = i;
  else if (r) {
    const L = dn(r);
    _ = L && o7(L) ? sr(L).body : sr(null).body;
  }
  const P = !u && l && (!m || E) ? "none" : void 0, A = m ? {
    in: u,
    onEnter: k,
    onExited: x
  } : void 0;
  return /* @__PURE__ */ Y.jsx(J4, {
    disablePortal: s,
    container: _,
    children: /* @__PURE__ */ Y.jsx(c7, {
      anchorEl: r,
      direction: o,
      disablePortal: s,
      modifiers: c,
      ref: n,
      open: m ? !E : u,
      placement: f,
      popperOptions: g,
      popperRef: p,
      slotProps: h,
      slots: b,
      ...w,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: P,
        ...v
      },
      TransitionProps: A,
      children: a
    })
  });
}), d7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { id: "icon_tick1_24x24" }, /* @__PURE__ */ d.createElement("path", { id: "Fill 58", fillRule: "evenodd", clipRule: "evenodd", d: "M6.88586 12.8573L2 7.94102L3.96978 5.98439L6.88586 8.89321L12.4116 3.3335L14.381 5.31554L6.88586 12.8573Z", fill: "white" }))), e2 = /* @__PURE__ */ H(d7, {
  target: "e1qkx15u3"
})(""), f7 = /* @__PURE__ */ H("button", {
  target: "e1qkx15u2"
})("padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer;.copied{display:flex;align-items:center;padding-block:4px;padding-inline:6px;color:#ffffff;font-weight:700;background-color:#000000;}", Ne, ";"), p7 = /* @__PURE__ */ H(u7, {
  target: "e1qkx15u1"
})("z-index:", h1.Tooltip, ";"), m7 = /* @__PURE__ */ H("div", {
  target: "e1qkx15u0"
})("display:flex;gap:4px;justify-content:center;align-items:center;inline-size:114px;block-size:32px;color:#ffffff;font-weight:700;font-size:14px;font-family:", X, ";line-height:16px;text-align:center;background-color:#000000;"), yi = ({
  children: e,
  className: t,
  disablePortal: n = !0,
  LabelComponent: r,
  onClick: a,
  showLabel: i,
  tooltipPlacement: o = "right",
  url: s,
  variant: l
}) => {
  const [c, u] = n6(), [f, g] = Ce(!1), [p, v] = Ce(!1), m = We(null), h = Ie(F.breakpoints.up("tablet")), b = () => {
    u(s);
    const y = () => {
      g(!0), setTimeout(() => {
        g(!1), a == null || a();
      }, 1e3);
    }, k = () => {
      u(s), v(!0), a == null || a();
    };
    switch (l) {
      case "label":
        k();
        break;
      case "responsive":
        h ? y() : k();
        break;
      case "tooltip":
        y();
        break;
    }
  }, w = () => {
    const y = /* @__PURE__ */ C.createElement("span", {
      className: "copy"
    }, "Copy Link"), x = p ? /* @__PURE__ */ C.createElement("span", {
      className: "copied"
    }, "Link Copied ", /* @__PURE__ */ C.createElement(e2, null)) : y;
    switch (l) {
      case "label":
        return x;
      case "responsive":
        return h ? y : x;
      case "tooltip":
        return y;
    }
  }, E = ce(() => [{
    name: "offset",
    options: {
      offset: [0, 12]
    }
  }], []);
  return /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(f7, {
    "aria-label": "copy-link",
    className: t,
    onClick: () => b(),
    ref: m,
    type: "button"
  }, e, i && /* @__PURE__ */ C.createElement(r, null, w())), /* @__PURE__ */ C.createElement(p7, {
    anchorEl: m.current,
    disablePortal: n,
    modifiers: E,
    open: f,
    placement: o
  }, /* @__PURE__ */ C.createElement(m7, null, "Link Copied", /* @__PURE__ */ C.createElement(e2, null))));
};
yi.displayName = "CopyLinkButton";
const g7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 35, height: 35, rx: 17.5, stroke: "black" }), /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_3588_4477)" }, /* @__PURE__ */ d.createElement("path", { d: "M16.4987 18.75C16.8208 19.1806 17.2317 19.5369 17.7036 19.7947C18.1755 20.0525 18.6973 20.2058 19.2337 20.2442C19.7701 20.2826 20.3084 20.2052 20.8122 20.0173C21.316 19.8294 21.7736 19.5353 22.1537 19.155L24.4037 16.905C25.0868 16.1977 25.4648 15.2505 25.4562 14.2672C25.4477 13.284 25.0533 12.3434 24.358 11.6482C23.6628 10.9529 22.7222 10.5585 21.739 10.5499C20.7557 10.5414 19.8085 10.9194 19.1012 11.6025L17.8112 12.885M19.4987 17.25C19.1766 16.8194 18.7657 16.4631 18.2938 16.2053C17.8219 15.9475 17.3001 15.7941 16.7637 15.7557C16.2273 15.7173 15.689 15.7947 15.1852 15.9826C14.6814 16.1706 14.2238 16.4647 13.8437 16.845L11.5937 19.095C10.9106 19.8022 10.5326 20.7495 10.5412 21.7327C10.5497 22.716 10.9441 23.6565 11.6394 24.3518C12.3346 25.0471 13.2752 25.4415 14.2584 25.45C15.2417 25.4586 16.1889 25.0806 16.8962 24.3975L18.1787 23.115", stroke: "black", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_3588_4477" }, /* @__PURE__ */ d.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(9 9)" })))), h7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.3307 13.384V20.1183C23.3307 20.545 23.1673 20.9095 22.8398 21.2124C22.5122 21.5153 22.1195 21.6668 21.6608 21.6668H8.33396C7.87592 21.6668 7.48255 21.5153 7.15503 21.2124C6.82812 20.9095 6.66406 20.545 6.66406 20.1183V13.384L15.0136 16.8183L23.3307 13.384ZM23.3307 12.3404L15.0136 15.8086L6.66406 12.3404V9.88257C6.66406 9.45589 6.82812 9.09079 7.15503 8.78787C7.48255 8.48496 7.87592 8.3335 8.33396 8.3335H21.6608C22.1195 8.3335 22.5122 8.48496 22.8398 8.78787C23.1673 9.09079 23.3307 9.45589 23.3307 9.88257V12.3404Z", fill: "black" })), C7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.909 7.5947V9.99461H17.4374C16.8706 9.99461 16.5106 10.1003 16.3582 10.3105C16.162 10.542 16.064 10.8689 16.064 11.2893V12.9951H18.8109L18.4509 15.6791H16.064V22.5H13.219V15.6791H10.832V12.9951H13.219V11.0369C13.219 9.94206 13.5353 9.06895 14.1673 8.41585C14.843 7.80547 15.7154 7.5 16.7833 7.5C17.6772 7.5 18.3858 7.53176 18.909 7.5947Z", fill: "black" })), v7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "css-e5fmgn e1218mwn1", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 35, height: 35, rx: 17.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M12 15V8H24V15", stroke: "black", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 24H10C9.46957 24 8.96086 23.7893 8.58579 23.4142C8.21071 23.0391 8 22.5304 8 22V17C8 16.4696 8.21071 15.9609 8.58579 15.5858C8.96086 15.2107 9.46957 15 10 15H26C26.5304 15 27.0391 15.2107 27.4142 15.5858C27.7893 15.9609 28 16.4696 28 17V22C28 22.5304 27.7893 23.0391 27.4142 23.4142C27.0391 23.7893 26.5304 24 26 24H24", stroke: "black", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M24 20H12V28H24V20Z", stroke: "black", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), y7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M6.0218 14.6103C6.0218 14.6103 13.3931 11.8663 15.9495 10.9001C16.9296 10.5136 20.253 9.27685 20.253 9.27685C20.253 9.27685 21.7869 8.73581 21.6591 10.0498C21.6165 10.5909 21.2756 12.4846 20.9348 14.533C20.4234 17.4316 19.8695 20.6007 19.8695 20.6007C19.8695 20.6007 19.7843 21.4897 19.06 21.6442C18.3357 21.7988 17.1426 21.1032 16.9296 20.9486C16.7591 20.8327 13.7339 19.0935 12.6261 18.2432C12.3278 18.0113 11.987 17.5476 12.6687 17.0065C14.2026 15.7311 16.0348 14.1465 17.1426 13.1417C17.6539 12.6779 18.1652 11.5958 16.0348 12.9098C13.0096 14.8035 10.027 16.5814 10.027 16.5814C10.027 16.5814 9.34524 16.9678 8.06701 16.62C6.78871 16.2722 5.29742 15.8084 5.29742 15.8084C5.29742 15.8084 4.27487 15.2287 6.0218 14.6103Z", fill: "black" })), b7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M16.2349 13.8515L21.6988 7.5H20.4041L15.6598 13.0149L11.8705 7.5H7.5L13.2301 15.8395L7.5 22.5H8.79485L13.805 16.6761L17.8067 22.5H22.1772L16.2346 13.8515H16.2349ZM14.4615 15.913L13.8809 15.0825L9.2614 8.47476H11.2502L14.9782 13.8075L15.5588 14.6379L20.4047 21.5696H18.4159L14.4615 15.9133V15.913Z", fill: "black" })), w7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5937 16.0043C17.7337 16.0043 18.1237 16.186 18.7662 16.5485C19.4079 16.8835 19.7562 17.0927 19.812 17.1768C19.8404 17.2043 19.8537 17.2602 19.8537 17.3435C19.8537 17.5952 19.7845 17.9018 19.6454 18.2652C19.5054 18.5718 19.2262 18.8368 18.8079 19.0602C18.3887 19.256 17.9845 19.3535 17.5937 19.3535C17.1754 19.3535 16.4079 19.116 15.292 18.6418C14.5499 18.279 13.8713 17.7983 13.2829 17.2185C12.7245 16.6602 12.1387 15.921 11.5245 15.0002C10.9387 14.1627 10.6454 13.396 10.6454 12.6977V12.5727C10.7012 11.8477 10.9945 11.2193 11.5245 10.6893C11.7195 10.5218 11.9295 10.4377 12.152 10.4377H12.362C12.4454 10.466 12.5287 10.4793 12.6129 10.4793C12.7795 10.4793 12.8779 10.5077 12.9062 10.5627C12.962 10.591 13.0312 10.6885 13.1145 10.856C13.1145 10.9118 13.1645 11.0585 13.262 11.296C13.3595 11.5327 13.4362 11.7493 13.492 11.9443C13.687 12.4468 13.7845 12.7402 13.7845 12.8235C13.7845 12.991 13.6595 13.2143 13.4079 13.4935C13.1287 13.7727 12.9895 13.9677 12.9895 14.0793C12.9895 14.1352 13.0037 14.191 13.0312 14.246C13.3221 14.8665 13.7351 15.422 14.2454 15.8793C14.7788 16.3746 15.3861 16.784 16.0454 17.0927C16.212 17.1485 16.3104 17.176 16.3379 17.176C16.4495 17.176 16.6587 16.981 16.9662 16.591C17.3012 16.1993 17.5104 16.0043 17.5937 16.0043ZM15.1662 22.3668C16.1761 22.3658 17.1745 22.152 18.0962 21.7393C18.9907 21.3755 19.8023 20.8343 20.482 20.1485C21.1679 19.4687 21.709 18.6571 22.0729 17.7627C22.4629 16.8977 22.6587 15.921 22.6587 14.8327C22.6587 13.7727 22.4629 12.8093 22.0729 11.9443C21.6812 10.996 21.152 10.186 20.4812 9.51683C19.8679 8.90266 19.0729 8.37266 18.0962 7.926C17.0912 7.536 16.1145 7.34016 15.1662 7.34016C14.217 7.34016 13.2412 7.536 12.2362 7.926C11.2595 8.37266 10.4645 8.90266 9.85036 9.51766C9.18036 10.1868 8.65036 10.996 8.25953 11.9443C7.8687 12.8093 7.6737 13.7727 7.6737 14.8327C7.6737 16.4793 8.1487 17.9443 9.09703 19.2277L8.13453 22.0318L11.022 21.111C12.3337 21.9485 13.7154 22.3668 15.1662 22.3668ZM15.1654 5.8335C16.337 5.8335 17.5095 6.071 18.682 6.54516C19.7472 6.99492 20.714 7.64889 21.5279 8.47016C22.3362 9.25183 22.9779 10.2143 23.4529 11.3585C23.9279 12.3918 24.1645 13.5493 24.1645 14.8335C24.1645 16.1168 23.927 17.2885 23.4529 18.3485C22.9779 19.4652 22.3362 20.4277 21.5279 21.2368C20.7745 21.9902 19.8254 22.6318 18.6812 23.1618C17.5095 23.6368 16.337 23.8735 15.1645 23.8735C13.6399 23.8832 12.1394 23.4936 10.812 22.7435L5.83203 24.3343L7.42286 19.4785C6.58536 18.1118 6.16703 16.5627 6.16703 14.8335C6.16703 13.5502 6.4037 12.3918 6.8787 11.3593C7.35286 10.2152 7.99536 9.25266 8.8037 8.471C9.61773 7.64933 10.5848 6.99507 11.6504 6.54516C12.822 6.07016 13.9945 5.8335 15.1654 5.8335Z", fill: "black" })), k7 = /* @__PURE__ */ H("button", {
  target: "e1uptd6o1"
})({
  name: "pt3bba",
  styles: "position:relative;padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), x7 = /* @__PURE__ */ H("span", {
  target: "e1uptd6o0"
})({
  name: "wrqbg1",
  styles: "position:relative;z-index:2"
}), bi = ({
  children: e,
  className: t,
  onClick: n,
  url: r
}) => {
  const a = () => {
    window.open(`/print${r}`, "_blank"), n == null || n();
  };
  return /* @__PURE__ */ C.createElement(k7, {
    "aria-label": "print",
    className: t,
    onClick: a,
    type: "button",
    "data-qa": "print-button"
  }, /* @__PURE__ */ C.createElement(x7, null, e));
};
bi.displayName = "PrintButton";
const t2 = /* @__PURE__ */ H("span", {
  target: "e136m1kq1"
})("padding-block-start:11px;font-size:14px;font-family:", X, ";line-height:16px;white-space:nowrap;"), E7 = /* @__PURE__ */ H("span", {
  ...k2,
  target: "e136m1kq0"
})("display:flex;inline-size:", (e) => e.$size + e.$mobilePadding * 2, "px;block-size:", (e) => e.$size + e.$mobilePadding * 2, "px;padding:", (e) => e.$mobilePadding, "px;border-radius:200px;background-color:", (e) => e.$backgroundColor, ";", F.breakpoints.up("tablet"), "{inline-size:", (e) => e.$size + e.$padding * 2, "px;block-size:", (e) => e.$size + e.$padding * 2, "px;padding:", (e) => e.$padding, "px;}svg{inline-size:", (e) => e.$size, "px;block-size:", (e) => e.$size, "px;", (e) => e.$iconFillColor && /* @__PURE__ */ De("path{fill:", e.$iconFillColor, ";}", ""), " ", (e) => e.$svgTransform && /* @__PURE__ */ De("transform:", e.$svgTransform, ";", ""), ";}"), wi = ({
  children: e,
  className: t,
  extraProps: n,
  hideIcon: r = !1,
  onClick: a,
  position: i,
  relativeUrl: o,
  shortUrl: s,
  showLabel: l = !1,
  style: c,
  title: u,
  type: f,
  utm: g
}) => {
  var p, v, m, h, b;
  const {
    config: w,
    handleTrackGA4: E
  } = q(), y = new URL(s ?? o, w.siteUrl), k = () => {
    var T, R, I, M;
    if (r) return null;
    const Z = {
      "copy-link": g7,
      email: h7,
      facebook: C7,
      print: v7,
      telegram: y7,
      twitter: b7,
      whatsapp: w7,
      ...n == null ? void 0 : n.overrideIcons
    }[f];
    return /* @__PURE__ */ C.createElement(E7, {
      $backgroundColor: (T = c == null ? void 0 : c.backgroundColor) !== null && T !== void 0 ? T : "transparent",
      $iconFillColor: c == null ? void 0 : c.color,
      $mobilePadding: (R = c == null ? void 0 : c.mobilePadding) !== null && R !== void 0 ? R : 0,
      $padding: (I = c == null ? void 0 : c.padding) !== null && I !== void 0 ? I : 0,
      $size: (M = c == null ? void 0 : c.size) !== null && M !== void 0 ? M : 36,
      $svgTransform: c == null ? void 0 : c.svgTransform,
      "data-qa": "render-icon"
    }, /* @__PURE__ */ C.createElement(Z, null));
  }, x = (T) => l && /* @__PURE__ */ C.createElement(t2, null, T), _ = () => {
    switch (f) {
      case "copy-link":
        return "copy_link";
      default:
        return f;
    }
  }, P = () => {
    const T = _(), R = new URL(o, w.siteUrl).href;
    i && E({
      action: "click",
      category: "share",
      customized_parameters: {
        method: T,
        position: i,
        share_url: R
      },
      subcategory: ""
    });
  }, A = () => {
    P(), a == null || a();
  }, S = (() => {
    if (!(g != null && g.campaign)) return y.href;
    const T = new URL(y);
    return T.searchParams.set("utm_source", f), T.searchParams.set("utm_campaign", g.campaign), g.medium && T.searchParams.set("utm_medium", g.medium), g.content && T.searchParams.set("utm_content", g.content), T.href;
  })(), V = (T) => `Get the latest news, insights and special reports delivered straight to your inbox. Sign up to our newsletters: ${T}`;
  switch (f) {
    case "copy-link":
      return /* @__PURE__ */ C.createElement(yi, {
        className: t,
        disablePortal: n == null || (p = n.copyLink) === null || p === void 0 ? void 0 : p.disablePortal,
        LabelComponent: t2,
        onClick: A,
        showLabel: l,
        tooltipPlacement: (v = n == null || (m = n.copyLink) === null || m === void 0 ? void 0 : m.tooltipPlacement) !== null && v !== void 0 ? v : "bottom-start",
        url: S,
        variant: (h = n == null || (b = n.copyLink) === null || b === void 0 ? void 0 : b.variant) !== null && h !== void 0 ? h : "tooltip"
      }, k(), e);
    case "email": {
      const T = `${u}\r
${S}\r
------------------------------\r
` + V("https://sc.mp/newsletter_email");
      return /* @__PURE__ */ C.createElement(t6, {
        beforeOnClick: A,
        body: T,
        className: t,
        subject: "Shared from South China Morning Post",
        url: ""
      }, k(), x("Email"), e);
    }
    case "facebook":
      return /* @__PURE__ */ C.createElement(e6, {
        className: t,
        onClick: A,
        url: S
      }, k(), x("Facebook"), e);
    case "print":
      return /* @__PURE__ */ C.createElement(bi, {
        className: t,
        onClick: A,
        url: o
      }, k(), x("Print"), e);
    case "telegram": {
      const T = `${u}
${S}
------------------------------
Join SCMP's Channel: t.me/scmp_news - Get Daily News Update
` + V("https://sc.mp/newsletter_telegram");
      return /* @__PURE__ */ C.createElement(Jo, {
        className: t,
        onClick: A,
        title: T,
        url: " "
      }, k(), x("Telegram"), e);
    }
    case "twitter":
      return /* @__PURE__ */ C.createElement(Xo, {
        className: t,
        onClick: A,
        title: `${u}
`,
        url: S,
        via: w.twitter.accountName.toLowerCase()
      }, k(), x("X/Twitter"), e);
    case "whatsapp": {
      const T = `${u}
${S}
------------------------------
` + V("https://sc.mp/newsletter_whatsapp");
      return /* @__PURE__ */ C.createElement(Qo, {
        className: t,
        onClick: A,
        title: T,
        url: " "
      }, k(), x("Whatsapp"), e);
    }
    default:
      return null;
  }
};
wi.displayName = "ShareButton";
const _7 = /* @__PURE__ */ H(po, {
  target: "e109f9ks5"
})("z-index:", h1.Tooltip, ";"), H7 = /* @__PURE__ */ H("div", {
  target: "e109f9ks4"
})({
  name: "12xxavj",
  styles: "display:flex;flex-flow:row nowrap;align-items:center;padding:20px"
}), S7 = /* @__PURE__ */ H(I2, {
  target: "e109f9ks3"
})({
  name: "hnshaw",
  styles: "inline-size:15px;block-size:19px;margin-inline-end:14px;padding:0;& path:last-of-type{fill:#001246;}"
}), T7 = /* @__PURE__ */ H("button", {
  target: "e109f9ks2"
})("margin-inline-start:10px;padding:0;color:#4585ff;font-size:14px;font-family:", X, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), A7 = /* @__PURE__ */ H(wi, {
  target: "e109f9ks1"
})({
  name: "7ug3wf",
  styles: "display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px;rect{display:none;}"
}), n2 = /* @__PURE__ */ H("div", {
  target: "e109f9ks0"
})({
  name: "y1gwey",
  styles: "inline-size:1px;block-size:20px;margin-inline:5px;background:#bbbbbb"
});
function d1() {
  return d1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, d1.apply(null, arguments);
}
const ki = ({
  children: e
}) => {
  const {
    removeReadingHistory: t
  } = Vn(), [n, r] = Ce(), {
    bindBookmarkButton: a
  } = W3();
  return /* @__PURE__ */ C.createElement(Go, {
    popupId: "reading-history-item-popover",
    variant: "popover",
    "data-qa": "reading-history-action-menu"
  }, (i) => {
    const o = Ko(i), s = (v) => {
      const m = {
        ...o
      };
      return m.onClick = (h) => {
        r(v), o.onClick(h);
      }, m;
    }, l = Yo(i), c = () => {
      l.onClose(), setTimeout(() => {
        r(void 0);
      }, 500);
    }, u = () => {
      const v = {
        ...l
      };
      return v.onClose = c, v;
    }, f = (v) => i.isOpen && !!n && n.entityUuid === v.entityUuid && n.createdAt === v.createdAt, g = (v) => {
      const m = o1(ii, v.article);
      return ["facebook", "twitter", "copy-link", "email"].map((b) => /* @__PURE__ */ C.createElement(A7, {
        extraProps: {
          copyLink: {
            disablePortal: !1,
            tooltipPlacement: "top",
            variant: "tooltip"
          }
        },
        key: b,
        onClick: () => {
          c();
        },
        position: "history",
        relativeUrl: m.urlAlias,
        shortUrl: m.urlAlias,
        showLabel: !1,
        style: {
          /* stylelint-disable csstree/validator */
          /* stylelint-disable property-no-unknown */
          backgroundColor: "transparent",
          svgTransform: "scale(0.75)"
        },
        title: zo(m.socialHeadline, m.headline),
        type: b,
        utm: {
          campaign: m.entityId,
          medium: "share_widget"
        }
      }));
    }, p = (v) => {
      const m = o1(ai, v.article);
      return /* @__PURE__ */ C.createElement(S7, d1({}, a({
        entityId: m.entityId,
        trackings: {
          ga4Events: {
            click: {
              action: "click",
              category: "bookmark",
              customized_parameters: {
                action_type: "add",
                article_id: m.entityId,
                trigger_point: "history"
              },
              subcategory: ""
            }
          }
        }
      }, () => {
        setTimeout(c, 500);
      }), {
        "data-qa": "render-bookmark-button"
      }));
    };
    return /* @__PURE__ */ C.createElement(C.Fragment, null, e({
      bindTrigger: s,
      isCurrentItem: f
    }), /* @__PURE__ */ C.createElement(_7, d1({
      anchorOrigin: {
        horizontal: "left",
        vertical: "top"
      },
      elevation: 4,
      transformOrigin: {
        horizontal: "left",
        vertical: "bottom"
      }
    }, u()), n ? /* @__PURE__ */ C.createElement(H7, null, p(n), /* @__PURE__ */ C.createElement(n2, null), g(n), /* @__PURE__ */ C.createElement(n2, null), /* @__PURE__ */ C.createElement(T7, {
      onClick: () => {
        c(), t(n.article, n.createdAt);
      }
    }, "Remove")) : null));
  });
};
ki.displayName = "ReadingHistoryActionMenu";
const P7 = /* @__PURE__ */ H("div", {
  target: "e1h768hc8"
})({
  name: "1ehb0iy",
  styles: "display:flex;flex-flow:column nowrap;border:1px solid #a1a1a1;border-radius:4px;background:#f2f2f2;overflow:hidden"
}), L7 = /* @__PURE__ */ H("div", {
  target: "e1h768hc7"
})({
  name: "6cm4s2",
  styles: "display:flex;flex-flow:column nowrap;gap:20px;padding:20px"
}), V7 = /* @__PURE__ */ H("div", {
  target: "e1h768hc6"
})({
  name: "ege6rc",
  styles: 'display:grid;grid:"greeting link" min-content "message message" min-content/1fr max-content;grid-gap:12px;align-items:baseline;min-inline-size:90px'
}), M7 = /* @__PURE__ */ H("span", {
  target: "e1h768hc5"
})("grid-area:greeting;color:#000000;font-weight:400;font-size:16px;font-family:", ue, ";line-height:21px;", F.breakpoints.up("tablet"), "{font-size:16px;line-height:19px;}"), R7 = /* @__PURE__ */ H("span", {
  target: "e1h768hc4"
})({
  name: "1666q6m",
  styles: "font-weight:700;word-break:break-all"
}), r2 = /* @__PURE__ */ H("a", {
  target: "e1h768hc3"
})("grid-area:link;justify-self:flex-end;color:#4585ff;font-weight:400;font-size:16px;font-family:", X, ";line-height:19px;white-space:nowrap;cursor:pointer;", F.breakpoints.up("tablet"), "{font-size:14px;line-height:16px;}"), O7 = /* @__PURE__ */ H("div", {
  target: "e1h768hc2"
})({
  name: "1k47rlg",
  styles: "grid-area:message"
}), q7 = /* @__PURE__ */ H("div", {
  target: "e1h768hc1"
})({
  name: "1tc6xju",
  styles: "flex:1;overflow:auto"
}), I7 = /* @__PURE__ */ H("div", {
  target: "e1h768hc0"
})({
  name: "w65oug",
  styles: "display:flex;justify-content:center;align-items:center;min-block-size:56px;background:#ededed"
}), D7 = {
  name: "1qpdkzg",
  styles: "scrollbar-width:thin;scrollbar-gutter:stable;&::-webkit-scrollbar{inline-size:6px;background-color:#f5f5f5;}&::-webkit-scrollbar-track{background-color:#f5f5f5;}&::-webkit-scrollbar-thumb{border-radius:20px;background-color:#cccccc;}&::-webkit-scrollbar-thumb:hover{background:#bbbbbb;}"
}, B7 = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 180 203", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 90, cy: 90, r: 90, fill: "#F2F2F2" }), /* @__PURE__ */ d.createElement("circle", { cx: 90, cy: 90, r: 57.012, fill: "white" }), /* @__PURE__ */ d.createElement("path", { d: "M89.9731 63.1076C75.1285 63.1076 63.1076 75.1554 63.1076 90C63.1076 104.845 75.1285 116.892 89.9731 116.892C104.845 116.892 116.892 104.845 116.892 90C116.892 75.1554 104.845 63.1076 89.9731 63.1076ZM98.8476 102.666L87.3108 91.1026V76.5538H92.6892V88.8974L102.666 98.8745L98.8476 102.666Z", fill: "#7E8599" }), /* @__PURE__ */ d.createElement("circle", { cx: 90.3387, cy: 136.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("circle", { cx: 90.3387, cy: 166.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("circle", { cx: 90.3387, cy: 196.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.6517 89.6331C30.6872 84.8257 31.2607 80.0599 32.4238 75.4906C36.2166 60.5304 45.6985 47.4666 59.3946 39.2491C72.9853 31.1369 88.8938 28.8191 104.17 32.6118C119.552 36.4045 132.405 45.9917 140.517 59.5823C148.63 73.1728 151.053 89.0812 147.155 104.357C143.362 119.739 133.775 132.592 120.184 140.704C106.593 148.816 90.6848 151.24 75.4084 147.342C60.0267 143.549 47.1735 133.962 39.0612 120.371L42.6432 118.159C50.1234 130.801 62.1338 139.651 76.3566 143.233C90.5795 146.815 105.329 144.602 117.972 137.122C130.614 129.642 139.464 117.632 143.046 103.409C146.628 89.1865 144.416 74.4371 136.935 61.7947C129.455 49.1523 117.445 40.3026 103.222 36.7206C88.9992 33.1386 74.2495 35.351 61.607 42.8311C44.4532 53.0416 34.3254 71.5644 34.868 91.3985L41.4801 85.5759L44.4408 88.8678L32.8173 99.1825L22.9482 87.1121L26.3476 84.3689L30.6517 89.6331Z", fill: "#DAE3E9" }), /* @__PURE__ */ d.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 132, x2: 139, y2: 132, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 142, x2: 133, y2: 142, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 137, x2: 121, y2: 137, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 126, y1: 137, x2: 145, y2: 137, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ d.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 162, x2: 139, y2: 162, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 172, x2: 139, y2: 172, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 167, x2: 126, y2: 167, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 128, y1: 167, x2: 147, y2: 167, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ d.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 192, x2: 115, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 117, y1: 192, x2: 139, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 202, x2: 149, y2: 202, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 197, x2: 128, y2: 197, stroke: "#7E8599", strokeWidth: 2 }))), F7 = /* @__PURE__ */ H("div", {
  target: "euvv2st11"
})("block-size:100%;padding:20px;background:#ffffff;overflow-y:auto;", D7, ";"), $7 = /* @__PURE__ */ H("div", {
  target: "euvv2st10"
})("color:#000000;font-weight:700;font-size:16px;font-family:", X, ";line-height:19px;"), U7 = /* @__PURE__ */ H("div", {
  target: "euvv2st9"
})(""), z7 = /* @__PURE__ */ H("div", {
  target: "euvv2st8"
})({
  name: "84lqid",
  styles: "display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;padding-block:20px"
}), Z7 = /* @__PURE__ */ H("div", {
  target: "euvv2st7"
})("color:#000000;font-size:14px;font-family:", ue, ";line-height:18px;text-transform:uppercase;"), W7 = /* @__PURE__ */ H("button", {
  target: "euvv2st6"
})("color:#4585ff;font-size:14px;font-family:", X, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), N7 = /* @__PURE__ */ H("div", {
  target: "euvv2st5"
})({
  name: "1tzhvsk",
  styles: 'position:relative;padding-block-end:28px;padding-inline-start:20px;::before{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:2;display:block;inline-size:10px;block-size:10px;border-radius:50%;background:#ffca05;}::after{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:1;display:block;inline-size:10px;block-size:calc(100% + 8px);border-radius:5px 5px 0 0;background:#f2f2f2;}:last-child{::after{block-size:calc(100% - 2px);}}'
}), j7 = /* @__PURE__ */ H("div", {
  target: "euvv2st4"
})("color:#666666;font-size:16px;font-family:", X, ";line-height:22px;cursor:pointer;", F.breakpoints.up("tablet"), "{font-size:14px;line-height:18px;}:hover{color:#4585ff;}"), G7 = /* @__PURE__ */ H(Cn, {
  ...k2,
  target: "euvv2st3"
})("padding-block:4px;padding-inline:0;color:", (e) => e.$isActive ? "#000000" : "#cccccc", ";"), K7 = /* @__PURE__ */ H("div", {
  target: "euvv2st2"
})("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;margin-block-start:16px;color:#666666;font-size:14px;font-family:", X, ";"), Y7 = /* @__PURE__ */ H(B7, {
  target: "euvv2st1"
})("min-inline-size:180px;max-inline-size:250px;margin-block-start:28px;", F.breakpoints.up("tablet"), "{inline-size:180px;}"), a2 = /* @__PURE__ */ H(mo, {
  target: "euvv2st0"
})({
  name: "7rcus4",
  styles: "display:block;margin-block:30px;margin-inline:auto;color:#4585ff"
});
function fn() {
  return fn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fn.apply(null, arguments);
}
const xi = ({
  state: e
}) => {
  const {
    currentPageType: t,
    handleRoutePush: n,
    handleTrackGA4: r,
    user: a
  } = q(), {
    clearReadingHistory: i
  } = Vn(), o = Object.entries(Z3(e.result, (s) => ke(s.createdAt)));
  return Te(() => {
    r({
      action: "imp",
      category: "readinghistory",
      subcategory: ""
    });
  }), /* @__PURE__ */ C.createElement(ki, {
    "data-qa": "reading-history-panel"
  }, ({
    bindTrigger: s,
    isCurrentItem: l
  }) => {
    const c = () => {
      const g = a ? "Your recently viewed stories will appear here. This allows us to give you a more personalised experience." : "By signing up as a registered user, your recently viewed stories will appear here. This allows us to give you a more personalised experience.";
      return /* @__PURE__ */ C.createElement(K7, {
        "data-qa": "render-empty-message"
      }, g, /* @__PURE__ */ C.createElement(Y7, null));
    }, u = () => {
      const g = (v) => {
        const m = new Date(v);
        return ds(m) ? "Today" : ps(m) ? "Yesterday" : v;
      }, p = (v) => {
        var m;
        const h = o1(ri, v.article);
        return /* @__PURE__ */ C.createElement(N7, {
          key: v.entityUuid,
          "data-qa": "render-item"
        }, /* @__PURE__ */ C.createElement(j7, {
          onClick: () => {
            var b;
            r({
              action: "click",
              category: "readinghistory",
              customized_parameters: {
                action_type: "read",
                article_id: h.entityId
              },
              subcategory: ""
            }), n(h.urlAlias, {
              applicationId: (b = h.application) === null || b === void 0 ? void 0 : b.entityUuid,
              entityId: h.entityId,
              entityUuid: h.entityUuid,
              query: {
                campaign: "reading_history",
                module: "my_account_overlay",
                pgtype: t
              },
              type: fo(h.__typename)
            });
          }
        }, (m = h.socialHeadline) !== null && m !== void 0 ? m : h.headline), /* @__PURE__ */ C.createElement(G7, fn({
          "aria-label": "more action",
          disableRipple: !0
        }, s(v), {
          $isActive: l(v)
        }), /* @__PURE__ */ C.createElement(V3, {
          color: "inherit"
        })));
      };
      return o.map(([v, m]) => /* @__PURE__ */ C.createElement(U7, {
        key: v
      }, /* @__PURE__ */ C.createElement(z7, null, /* @__PURE__ */ C.createElement(Z7, null, g(v)), /* @__PURE__ */ C.createElement(W7, {
        onClick: () => void i(v)
      }, "Clear")), m.map((h) => p(h))));
    }, f = () => {
      const g = o.length === 0;
      switch (e.status) {
        case "error":
        case "success":
          return g ? c() : u();
        case "loading":
          return g ? /* @__PURE__ */ C.createElement(a2, {
            color: "inherit"
          }) : void 0;
        case "not-executed":
          return /* @__PURE__ */ C.createElement(a2, {
            color: "inherit"
          });
      }
    };
    return /* @__PURE__ */ C.createElement(F7, null, /* @__PURE__ */ C.createElement($7, null, "Recently Viewed"), f());
  });
};
xi.displayName = "ReadingHistoryPanel";
const Ei = ({
  beforeHeaderSlot: e,
  className: t,
  messageRenders: n
}) => {
  var r;
  const {
    config: a,
    handleOpenLoginDialog: i,
    handleRoutePush: o,
    user: s
  } = q(), l = s != null && s.firstname && s !== null && s !== void 0 && s.lastname ? `${s.firstname} ${s.lastname}` : (r = s == null ? void 0 : s.username) !== null && r !== void 0 ? r : "Guest", c = () => s ? /* @__PURE__ */ C.createElement(r2, {
    onClick: () => {
      const g = new URL(`${a.accounts.host}/settings`);
      g.searchParams.set("destination", globalThis.location.href), o(g.toString());
    },
    "data-qa": "render-account-link"
  }, "My Account") : /* @__PURE__ */ C.createElement(r2, {
    onClick: () => {
      i({
        destination: globalThis.location.href,
        ga4CustomParameter: {
          trigger_point: "header"
        }
      });
    }
  }, "Sign In / Register"), {
    message: u
  } = _3(n), {
    state: f
  } = k3();
  return /* @__PURE__ */ C.createElement(P7, {
    className: t,
    "data-qa": "dashboard-display"
  }, /* @__PURE__ */ C.createElement(L7, null, e, /* @__PURE__ */ C.createElement(V7, null, /* @__PURE__ */ C.createElement(M7, null, "Hi, ", /* @__PURE__ */ C.createElement(R7, null, l)), c(), /* @__PURE__ */ C.createElement(O7, null, u))), /* @__PURE__ */ C.createElement(q7, null, /* @__PURE__ */ C.createElement(xi, {
    state: f
  })), /* @__PURE__ */ C.createElement(I7, null, c()));
};
Ei.displayName = "DashboardDisplay";
const Q7 = /* @__PURE__ */ H("div", {
  target: "eprlsh17"
})("inline-size:fit-content;", Ne, ";"), X7 = /* @__PURE__ */ H(Cn, {
  target: "eprlsh16"
})(Ne, ";"), J7 = /* @__PURE__ */ H(Ei, {
  target: "eprlsh15"
})("block-size:100vh;", F.breakpoints.up("tablet"), "{inline-size:300px;block-size:574px;}"), e8 = /* @__PURE__ */ H(go, {
  target: "eprlsh14"
})("z-index:", h1.Modal, ";"), t8 = /* @__PURE__ */ H("div", {
  target: "eprlsh13"
})("display:flex;justify-content:space-between;align-items:center;", F.breakpoints.up("tablet"), "{display:none;}"), n8 = /* @__PURE__ */ H(ho, {
  target: "eprlsh12"
})("z-index:", h1.Modal, ";", Ne, ";"), r8 = /* @__PURE__ */ H("div", {
  target: "eprlsh11"
})(""), a8 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.81257 8.03137L16 15.1874L15.2503 15.9999L8 8.78108L0.812571 15.9999L0 15.1874L7.18743 8.03137L0 0.81251L0.812571 -6.10352e-05L8 7.2188L15.2503 -6.10352e-05L16 0.81251L8.81257 8.03137Z", fill: "white" }));
function pn() {
  return pn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pn.apply(null, arguments);
}
const i8 = /* @__PURE__ */ H(Cn, {
  target: "e15aj8c1"
})({
  name: "if9fso",
  styles: "flex:none;margin-inline-start:18px;padding:0"
}), o8 = /* @__PURE__ */ H(({
  className: e,
  ...t
}) => /* @__PURE__ */ C.createElement(Co, pn({}, t, {
  classes: {
    popper: e
  }
})), {
  target: "e15aj8c0"
})("& .", Qn.tooltip, "{display:flex;flex-flow:row nowrap;justify-content:end;align-items:flex-start;inline-size:max-content;max-inline-size:325px;padding:16px;color:#ffffff;font-weight:400;font-size:16px;font-family:", X, ";line-height:22px;border-radius:0;background:rgba(0, 18, 70, 0.9);cursor:pointer;user-select:none;}& .", Qn.arrow, "{color:rgba(0, 18, 70, 0.9);font-size:25px;}"), _i = ({
  children: e,
  isDashboardOpen: t,
  isTooltipVisible: n,
  tooltipRenders: r
}) => {
  var a;
  const [i, o] = Ke(async () => {
    if (!r) return null;
    const g = await Promise.allSettled(r.map((p) => p.current));
    for (const p of g)
      if (!(p.status === "rejected" || p.value === null))
        return p.value;
  }), [s, l] = Ce(!1);
  x2(() => {
    s || o.execute();
  }, [r, s]);
  const c = n && !t && !s && i.status === "success" && !!((a = i.result) !== null && a !== void 0 && a.node), u = i.status === "success" ? i.result : void 0, {
    router: f
  } = q();
  return B(() => {
    const g = () => {
      var p;
      !c || !u || (l(!0), u == null || (p = u.onChangeUrl) === null || p === void 0 || p.call(u));
    };
    return f.events.on("routeChangeStart", g), () => {
      f.events.off("routeChangeStart", g);
    };
  }, [u, f, c]), B(() => {
    t && u && l(!0);
  }, [t, c, u]), /* @__PURE__ */ C.createElement(o8, {
    arrow: !0,
    open: c,
    placement: "bottom-end",
    PopperProps: {
      disablePortal: !0,
      modifiers: [{
        name: "offset",
        options: {
          offset: [16, 0]
        }
      }]
    },
    title: /* @__PURE__ */ C.createElement(C.Fragment, null, u == null ? void 0 : u.node, /* @__PURE__ */ C.createElement(i8, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => {
        var g;
        l(!0), u == null || (g = u.onClose) === null || g === void 0 || g.call(u);
      }
    }, /* @__PURE__ */ C.createElement(a8, null))),
    "data-qa": "dashboard-tooltips"
  }, e);
};
_i.displayName = "DashboardTooltips";
function mn() {
  return mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mn.apply(null, arguments);
}
const o9 = ({
  children: e,
  className: t,
  messageRenders: n,
  tooltipRenders: r
}) => {
  const {
    hasAcceptedGDPR: a
  } = q(), {
    config: i,
    handleOpenLoginDialog: o,
    user: s
  } = q();
  b3();
  const l = We(null), [c, u] = ao(!0), [f, g] = Ce(!1), p = Oo(l), v = Ie(F.breakpoints.only("mobile"), !1), m = Ie(F.breakpoints.up("tablet"), !1), h = Ie(F.breakpoints.up("desktop"), !1), b = () => /* @__PURE__ */ C.createElement(J7, {
    beforeHeaderSlot: /* @__PURE__ */ C.createElement(t8, null, /* @__PURE__ */ C.createElement(E3, null), /* @__PURE__ */ C.createElement(X7, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => g(!1)
    }, /* @__PURE__ */ C.createElement(x3, null))),
    messageRenders: n,
    "data-qa": "render-display"
  }), {
    setIsFirstTime: w
  } = ni();
  B(() => {
    !f || !a || w(!1);
  }, [a, f, w]), B(() => {
    u(p == null ? void 0 : p.isIntersecting);
  }, [p == null ? void 0 : p.isIntersecting, u]);
  const E = ce(() => [{
    name: "offset",
    options: {
      // This is for handling tablet placement of the popper
      offset: [h ? 0 : 42, 10]
    }
  }], [h]), y = () => g(!1);
  return B(() => {
    if (f && h)
      window.addEventListener("scroll", y);
    else
      return () => {
        window.removeEventListener("scroll", y);
      };
    return () => {
      window.removeEventListener("scroll", y);
    };
  }, [h, f]), /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(_i, {
    isDashboardOpen: f,
    isTooltipVisible: c,
    tooltipRenders: r
  }, /* @__PURE__ */ C.createElement(Q7, {
    className: t,
    onClick: () => {
      setTimeout(() => {
        m ? g(!0) : s ? window.location.href = i.accounts.host : o({
          destination: globalThis.location.href,
          ga4CustomParameter: {
            trigger_point: "header"
          }
        });
      }, 0);
    },
    ref: l
  }, e)), /* @__PURE__ */ C.createElement(e8, {
    anchor: "bottom",
    hideBackdrop: !0,
    onClose: () => g(!1),
    open: v && f,
    SlideProps: {
      easing: {
        enter: "ease"
      },
      timeout: {
        enter: 500,
        exit: 0
      }
    }
  }, b()), /* @__PURE__ */ C.createElement(n8, {
    anchorEl: l.current,
    modifiers: E,
    open: !v && f,
    placement: "bottom-end",
    transition: !0
  }, ({
    TransitionProps: k
  }) => /* @__PURE__ */ C.createElement(vo, {
    onClickAway: () => g(!1)
  }, /* @__PURE__ */ C.createElement(yo, mn({}, k, {
    timeout: {
      enter: 500,
      exit: 0
    }
  }), /* @__PURE__ */ C.createElement(r8, null, b())))));
}, Hi = /* @__PURE__ */ function() {
  var e = [{
    kind: "Literal",
    name: "filter",
    value: {
      entityId: "acquisition"
    }
  }], t = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          t
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [t, {
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "id",
          storageKey: null
        }],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }]
    },
    params: {
      cacheID: "f8a59a268fef536b2b8a27cbc8bf3147",
      id: null,
      metadata: {},
      name: "hooksUseGroupSubscriptionDataQuery",
      operationKind: "query",
      text: `query hooksUseGroupSubscriptionDataQuery {
  appConfig(filter: {entityId: "acquisition"}) {
    json
    id
  }
}
`
    }
  };
}();
Hi.hash = "10b91bd845ddc4c70e045441fbd4454d";
var rn, i2;
function s8() {
  if (i2) return rn;
  i2 = 1;
  var e = W2(), t = j2(), n = v1(), r = J(), a = xn(), i = Hn(), o = Z2(), s = Sn(), l = "[object Map]", c = "[object Set]", u = Object.prototype, f = u.hasOwnProperty;
  function g(p) {
    if (p == null)
      return !0;
    if (a(p) && (r(p) || typeof p == "string" || typeof p.splice == "function" || i(p) || s(p) || n(p)))
      return !p.length;
    var v = t(p);
    if (v == l || v == c)
      return !p.size;
    if (o(p))
      return !e(p).length;
    for (var m in p)
      if (f.call(p, m))
        return !1;
    return !0;
  }
  return rn = g, rn;
}
var l8 = s8();
const o2 = /* @__PURE__ */ f1(l8), c8 = async (e, t) => (await e.post("/tier", {
  email: t,
  withCredentials: !0
})).data || "", u8 = /* @__PURE__ */ H("div", {
  target: "e1dy73d80"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), Si = ({
  message: e,
  onImpression: t
}) => (Te(() => {
  t();
}), /* @__PURE__ */ C.createElement(u8, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "group-subscriber-tooltip"
}));
Si.displayName = "GroupSubscriberTooltip";
const s9 = () => {
  const {
    user: e
  } = q(), {
    remove: t,
    set: n,
    value: r
  } = ie("groupSubscriberTooltipData"), a = d8(), i = f8(), o = w2(r), {
    promise: s,
    reject: l,
    resolve: c
  } = g1();
  return B(() => {
    var u, f;
    if (s2(a) || s2(i)) return;
    if (!e || l2(a) || l2(i)) return l.current();
    const g = a.result, p = i.result;
    if (!g || !p) return l.current();
    (o == null || (u = o.current) === null || u === void 0 ? void 0 : u.version) !== g.tooltip.version && t();
    const v = (f = o.current) !== null && f !== void 0 ? f : {
      intervalData: [{
        intervalTime: 0,
        shown: !1
      }, {
        intervalTime: 604800,
        shown: !1
      }, {
        intervalTime: 1209600,
        shown: !1
      }, {
        intervalTime: 1814400,
        shown: !1
      }, {
        intervalTime: 2419200,
        shown: !1
      }],
      lastShownTimeStamp: an(Date.now()),
      version: g.tooltip.version
    }, m = an(Date.now()) - v.lastShownTimeStamp;
    if (!v.intervalData) return l.current();
    for (const [h] of v.intervalData.entries()) {
      const b = v.intervalData, w = () => {
        n(() => {
          var E;
          const y = [...b];
          return y[h] = {
            intervalTime: b[h].intervalTime,
            shown: !0
          }, {
            intervalData: y,
            lastShownTimeStamp: v.lastShownTimeStamp,
            version: (E = v.version) !== null && E !== void 0 ? E : ""
          };
        });
      };
      if (m >= v.intervalData[h].intervalTime && !v.intervalData[h].shown)
        return c.current({
          node: /* @__PURE__ */ C.createElement(Si, {
            message: `${g.tooltip.message}`,
            onImpression: () => {
              w();
            }
          }),
          onChangeUrl: () => {
            w();
          }
        });
    }
    return l.current();
  }, [a, i, l, t, c, n, o, e, s]), {
    groupSubscriberTooltipRender: s
  };
}, s2 = (e) => !e || e.status === "loading" || e.status === "not-executed", l2 = (e) => e.status === "error", d8 = () => {
  const e = v2(), {
    config: t
  } = q(), [n, r] = Ke(async () => {
    var a, i;
    const o = await y2(e, Hi, {}).toPromise();
    if (o != null && (a = o.appConfig) !== null && a !== void 0 && a.json) return (o == null || (i = o.appConfig) === null || i === void 0 ? void 0 : i.json)[t.environment];
  });
  return Te(() => {
    r.execute();
  }), n;
}, f8 = () => {
  const {
    config: e,
    user: t
  } = q(), {
    remove: n,
    set: r,
    value: a
  } = ie("corp_subscriber_tier"), i = ce(() => vn.create({
    baseURL: e.corporateSubscriber.host,
    headers: {
      apikey: e.graphql.apiKey
    }
  }), [e]), [o, s] = Ke(async () => {
    var l, c;
    const u = /* @__PURE__ */ new Set(["C-suite", "T2", "T3", "T4"]);
    if (!(t != null && t.useremail)) return !1;
    if (a && (a == null ? void 0 : a["Users Email Address"]) !== (t == null ? void 0 : t.useremail) && n(), !o2(a)) return u.has((l = a == null ? void 0 : a.Tier) !== null && l !== void 0 ? l : "");
    const f = await c8(i, t == null ? void 0 : t.useremail);
    return o2(a) && f && r(f), u.has((c = f == null ? void 0 : f.Tier) !== null && c !== void 0 ? c : "");
  });
  return Te(() => void s.execute()), o;
}, p8 = /* @__PURE__ */ H("div", {
  target: "e6yd7ba0"
})("display:flex;flex:none;justify-content:center;align-items:center;padding-block:1px;padding-inline:5px;color:#ffffff;font-weight:700;font-size:14px;font-family:", ue, ";line-height:18px;text-transform:uppercase;border-radius:4px;background:#eb4254;"), l9 = () => {
  const {
    hasAcceptedGDPR: e
  } = q(), {
    isFirstTime: t,
    setIsFirstTime: n
  } = ni(), {
    promise: r,
    reject: a,
    resolve: i
  } = g1();
  return B(() => e && t ? i.current({
    node: /* @__PURE__ */ C.createElement(C.Fragment, null, "Find your recently read stories and latest notifications here.", /* @__PURE__ */ C.createElement(p8, null, "New")),
    onChangeUrl: () => {
      n(!1);
    },
    onClose: () => {
      n(!1);
    }
  }) : a.current(), [i, a, t, r, n, e]), {
    hintTooltipRender: r
  };
}, m8 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.414 19.6869L21.437 10.6639L19.141 8.36694L12.414 15.0389L8.914 11.4839L6.562 13.8349L12.414 19.6869ZM23.898 23.8979C21.164 26.6319 17.864 27.9999 14 27.9999C10.135 27.9999 6.836 26.6319 4.101 23.8979C1.367 21.1639 0 17.8649 0 13.9999C0 10.1349 1.367 6.83494 4.101 4.10094C6.836 1.36694 10.135 -6.10352e-05 14 -6.10352e-05C17.864 -6.10352e-05 21.164 1.36694 23.898 4.10094C26.633 6.83494 28 10.1349 28 13.9999C28 17.8649 26.633 21.1639 23.898 23.8979Z", fill: "white" })), g8 = /* @__PURE__ */ H("div", {
  target: "e1yc3qie1"
})({
  name: "zjik7",
  styles: "display:flex"
}), h8 = /* @__PURE__ */ H(m8, {
  target: "e1yc3qie0"
})({
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px"
}), Ti = ({
  onImpression: e
}) => (Te(() => {
  e();
}), /* @__PURE__ */ C.createElement(g8, {
  "data-qa": "login-reminder-tooltip"
}, /* @__PURE__ */ C.createElement(h8, null), "Log in again for better content recommendations."));
Ti.displayName = "LoginReminderTooltip";
const c9 = () => {
  const {
    hasAcceptedGDPR: e,
    user: t
  } = q(), [n] = qo("last_logout_timestamp"), {
    remove: r,
    set: a,
    value: i
  } = ie("loginReminderData"), o = w2(i);
  B(() => {
    t && r();
  }, [r, t]);
  const {
    promise: s,
    reject: l,
    resolve: c
  } = g1();
  return B(() => {
    var u;
    if (!e || n === null || t) return l.current();
    const f = (u = o.current) !== null && u !== void 0 ? u : [{
      // 30 minutes
      intervalTime: 1800,
      shown: !1
    }, {
      // 1 day
      intervalTime: 86400,
      shown: !1
    }, {
      // 30 days
      intervalTime: 172800,
      shown: !1
    }], g = an(/* @__PURE__ */ new Date()), p = Number.parseInt(n ?? "0");
    for (const [v, m] of f.entries())
      if (g - p >= m.intervalTime && !m.shown) {
        const h = () => {
          a(() => (f[v].shown = !0, f));
        };
        return c.current({
          node: /* @__PURE__ */ C.createElement(Ti, {
            onImpression: () => {
              h();
            }
          }),
          onChangeUrl: () => {
            h();
          }
        });
      }
    return l.current();
  }, [n, l, c, a, o, e, t]), {
    loginReminderTooltipRender: s
  };
}, C8 = /* @__PURE__ */ H("div", {
  target: "e1nmhixk0"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), Ai = ({
  message: e
}) => /* @__PURE__ */ C.createElement(C8, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "piano-tooltip-display"
});
Ai.displayName = "PianoTooltipDisplay";
const u9 = () => {
  var e;
  const {
    rosettaInstance: t
  } = q(), {
    set: n,
    value: r
  } = ie("pianoTooltipHistory", {
    defaultValue: []
  }), {
    message: a,
    shortKey: i,
    version: o
  } = (e = t == null ? void 0 : t.rulesEngine.getOutcome("ui.tooltip.messageObject")) !== null && e !== void 0 ? e : {}, s = i && o && `${i}_${o.toString()}`, [l, c] = Ce(), {
    promise: u,
    reject: f,
    resolve: g
  } = g1();
  return B(() => {
    if (t) {
      if (s && r) {
        c(!r.includes(s));
        return;
      }
    } else return;
    c(!1);
  }, [r, t, s, o]), B(() => {
    if (!(!t || l === void 0))
      return l && a && s ? g.current({
        node: /* @__PURE__ */ C.createElement(Ai, {
          message: a
        }),
        onChangeUrl: () => {
          n((p) => Xn(p ?? [], [s])), c(!1);
        },
        onClose: () => {
          n((p) => Xn(p ?? [], [s])), c(!1);
        }
      }) : f.current();
  }, [l, a, f, g, t, n, s]), {
    pianoTooltipRender: u
  };
}, v8 = /* @__PURE__ */ H("div", {
  target: "e1que4v90"
})({
  name: "u25i9k",
  styles: "display:flex;flex-flow:column;justify-content:flex-start;align-items:center;inline-size:600px;min-block-size:252px;margin:auto;padding-block:40px;padding-inline:0;border-radius:8px;background-color:#ffffff;outline:none"
}), Pi = ({
  children: e,
  isShow: t,
  onClose: n
}) => /* @__PURE__ */ C.createElement(Lo, {
  onClose: n,
  open: t,
  "data-qa": "popup"
}, /* @__PURE__ */ C.createElement(v8, null, e));
Pi.displayName = "Popup";
const y8 = /* @__PURE__ */ H(io, {
  target: "e1qc5gx50"
})(oo, "{margin-block-start:0;}", so, "{font-size:21px;line-height:27px;}", lo, "{font-size:16px;}", co, "{font-size:14px;}"), b8 = ({
  isShow: e,
  onClose: t
}) => /* @__PURE__ */ C.createElement(Pi, {
  isShow: e,
  onClose: t,
  "data-qa": "sign-up-popup"
}, /* @__PURE__ */ C.createElement(bo, {
  theme: {
    signUpSuccess: {
      hasCheckEmail: !0
    }
  }
}, /* @__PURE__ */ C.createElement(y8, null)));
b8.displayName = "SignUpPopup";
async function w8(e) {
  const t = await vn.post("/piano/renew", {
    subscriptionId: e
  }), {
    code: n,
    data: r
  } = t.data;
  return n === 0 && r === !0;
}
const Q = /* @__PURE__ */ H("button", {
  target: "e1uch9rj1"
})("padding-block:8px;padding-inline:12px;color:#001246;font-size:14px;font-family:", ue, ";line-height:16px;white-space:nowrap;text-align:start;text-transform:uppercase;border-radius:2px;background:#ffca05;cursor:pointer;", F.breakpoints.up("tablet"), "{padding-block:6px;padding-inline:10px;}"), k8 = /* @__PURE__ */ H("span", {
  target: "e1uch9rj0"
})((e) => {
  switch (e.$variant) {
    case "dark":
      return /* @__PURE__ */ De(Q, "{color:#ffffff;background:#222222;}", "");
    case "dark-blue":
      return /* @__PURE__ */ De(Q, "{color:#ffffff;font-weight:700;background:#001246;}", "");
    case "light-blue":
      return /* @__PURE__ */ De(Q, "{padding-block:7px;padding-inline:8px;color:#ffffff;background:#4585ff;}", "");
    default:
      return null;
  }
}, ";"), Li = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: n
  } = q(), {
    computeGA4CommonParameters: r
  } = ye(), [a, i] = Ce(!1);
  B(() => {
    n != null && n.rulesEngine.getOutcome("user.autoRenewEnabled") || i(!0);
  }, [n == null ? void 0 : n.rulesEngine]);
  const {
    captureTrackImpressionEventTargetElement: o
  } = je({
    ga4Event: $(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "enable auto-renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [r])
  });
  return a ? /* @__PURE__ */ C.createElement(Q, {
    className: e,
    onClick: () => {
      (async () => {
        const l = n == null ? void 0 : n.rulesEngine.getOutcome("user.autoRenewSubscriptionId");
        t({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...r(),
            call_to_action: "enable auto-renew",
            trigger_point: "masthead enable auto-renew button"
          },
          subcategory: "entry_point"
        }), !(!l || !await w8(l)) && (window.postMessage({
          type: "PIANO_AUTORENEW_CONFIRMATION"
        }, "*"), n == null || n.rulesEngine.addRule(new n.Rule("user.autoRenewEnabled").priority(10).when(() => !0).then(!0)), await (n == null ? void 0 : n.rulesEngine.run()), i(!1));
      })();
    },
    ref: o,
    "data-qa": "auto-renew-button"
  }, "Enable Auto‑renew") : null;
};
Li.displayName = "AutoRenewButton";
const Vi = /* @__PURE__ */ function() {
  var e = {
    kind: "Literal",
    name: "first",
    value: 1
  }, t = [{
    kind: "Literal",
    name: "filter",
    value: {
      typeIds: ["517498"]
    }
  }, e, {
    kind: "Literal",
    name: "orderBy",
    value: [{
      direction: "DESC",
      field: "PUBLISHED_DATE"
    }]
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "publishedDate",
    storageKey: null
  }, r = [
    n
    /*: any*/
  ], a = [{
    kind: "Literal",
    name: "filter",
    value: {
      name: "scmp_plus_featured_opinion"
    }
  }], i = [
    e
    /*: any*/
  ], o = {
    kind: "InlineFragment",
    selections: r,
    type: "Content",
    abstractKey: "__isContent"
  }, s = [{
    alias: null,
    args: i,
    concreteType: "QueueItemConnection",
    kind: "LinkedField",
    name: "items",
    plural: !1,
    selections: [{
      alias: null,
      args: null,
      concreteType: "QueueItemsEdge",
      kind: "LinkedField",
      name: "edges",
      plural: !0,
      selections: [{
        alias: null,
        args: null,
        concreteType: null,
        kind: "LinkedField",
        name: "node",
        plural: !1,
        selections: [
          o
          /*: any*/
        ],
        storageKey: null
      }],
      storageKey: null
    }],
    storageKey: "items(first:1)"
  }], l = [{
    kind: "Literal",
    name: "filter",
    value: {
      name: "scmp_plus_home_news"
    }
  }], c = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  }, u = [
    {
      alias: null,
      args: i,
      concreteType: "QueueItemConnection",
      kind: "LinkedField",
      name: "items",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        concreteType: "QueueItemsEdge",
        kind: "LinkedField",
        name: "edges",
        plural: !0,
        selections: [{
          alias: null,
          args: null,
          concreteType: null,
          kind: "LinkedField",
          name: "node",
          plural: !1,
          selections: [{
            alias: null,
            args: null,
            kind: "ScalarField",
            name: "__typename",
            storageKey: null
          }, o, {
            kind: "InlineFragment",
            selections: [
              c
              /*: any*/
            ],
            type: "Node",
            abstractKey: "__isNode"
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: "items(first:1)"
    },
    c
    /*: any*/
  ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "hooksUsePlusHomePageUpdateIndicatorQuery",
      selections: [{
        alias: "dailyPulse",
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: r,
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: 'articles(filter:{"typeIds":["517498"]},first:1,orderBy:[{"direction":"DESC","field":"PUBLISHED_DATE"}])'
      }, {
        alias: "opinionQueue",
        args: a,
        concreteType: "Queue",
        kind: "LinkedField",
        name: "queue",
        plural: !1,
        selections: s,
        storageKey: 'queue(filter:{"name":"scmp_plus_featured_opinion"})'
      }, {
        alias: "highlightQueue",
        args: l,
        concreteType: "Queue",
        kind: "LinkedField",
        name: "queue",
        plural: !1,
        selections: s,
        storageKey: 'queue(filter:{"name":"scmp_plus_home_news"})'
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "hooksUsePlusHomePageUpdateIndicatorQuery",
      selections: [{
        alias: "dailyPulse",
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              c
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: 'articles(filter:{"typeIds":["517498"]},first:1,orderBy:[{"direction":"DESC","field":"PUBLISHED_DATE"}])'
      }, {
        alias: "opinionQueue",
        args: a,
        concreteType: "Queue",
        kind: "LinkedField",
        name: "queue",
        plural: !1,
        selections: u,
        storageKey: 'queue(filter:{"name":"scmp_plus_featured_opinion"})'
      }, {
        alias: "highlightQueue",
        args: l,
        concreteType: "Queue",
        kind: "LinkedField",
        name: "queue",
        plural: !1,
        selections: u,
        storageKey: 'queue(filter:{"name":"scmp_plus_home_news"})'
      }]
    },
    params: {
      cacheID: "d66640a8416e2917733ab760e121ab25",
      id: null,
      metadata: {},
      name: "hooksUsePlusHomePageUpdateIndicatorQuery",
      operationKind: "query",
      text: `query hooksUsePlusHomePageUpdateIndicatorQuery {
  dailyPulse: articles(filter: {typeIds: ["517498"]}, first: 1, orderBy: [{field: PUBLISHED_DATE, direction: DESC}]) {
    edges {
      node {
        publishedDate
        id
      }
    }
  }
  opinionQueue: queue(filter: {name: "scmp_plus_featured_opinion"}) {
    items(first: 1) {
      edges {
        node {
          __typename
          ... on Content {
            __isContent: __typename
            publishedDate
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
      }
    }
    id
  }
  highlightQueue: queue(filter: {name: "scmp_plus_home_news"}) {
    items(first: 1) {
      edges {
        node {
          __typename
          ... on Content {
            __isContent: __typename
            publishedDate
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
      }
    }
    id
  }
}
`
    }
  };
}();
Vi.hash = "2384aaa4160635801770e058a9951351";
const x8 = () => {
  const {
    set: e,
    value: t
  } = ie("plusHomePageLastVisitDate");
  return {
    track: $((r) => {
      r.hasScmpPlusAccessRight && e(Date.now());
    }, [e]),
    value: t
  };
};
function E8() {
  var e, t, n, r, a;
  const {
    value: i
  } = x8(), o = Vo(Vi, {}), s = Math.max(...[...(e = o.dailyPulse.edges) !== null && e !== void 0 ? e : [], ...(t = (n = o.opinionQueue) === null || n === void 0 || (n = n.items) === null || n === void 0 ? void 0 : n.edges) !== null && t !== void 0 ? t : [], ...(r = (a = o.highlightQueue) === null || a === void 0 || (a = a.items) === null || a === void 0 ? void 0 : a.edges) !== null && r !== void 0 ? r : []].map((c) => c.node.publishedDate).filter((c) => c != null));
  return {
    hasUnreadPlusHomePageUpdate: ce(() => s > (i ?? 0), [i, s])
  };
}
const _8 = /* @__PURE__ */ H("div", {
  target: "e1famvsr0"
})({
  name: "m1kxi3",
  styles: "display:inline-block;inline-size:6px;block-size:6px;margin-inline-start:3px;vertical-align:top;border-radius:50%;background:#eb4254;aspect-ratio:1/1"
});
function gn() {
  return gn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gn.apply(null, arguments);
}
const Mi = ({
  className: e,
  withImpressionTracking: t,
  withUpdateIndicator: n
}) => /* @__PURE__ */ C.createElement(C.Fragment, null, n ? /* @__PURE__ */ C.createElement(Gi, null, /* @__PURE__ */ C.createElement(H8, {
  className: e,
  withImpressionTracking: t
})) : /* @__PURE__ */ C.createElement(Ri, {
  className: e,
  withImpressionTracking: t
})), Ri = ({
  className: e,
  hasUnreadPlusHomePageUpdate: t,
  withImpressionTracking: n,
  withUpdateIndicator: r
}) => {
  const {
    handleTrackGA4: a
  } = q(), i = n ? {
    notification: t ? "active" : "inactive"
  } : void 0, o = () => {
    a({
      action: "click",
      category: "plus",
      customized_parameters: i,
      subcategory: "masthead"
    });
    const l = new URL("/plus", location.origin);
    l.search = new URL(location.href).searchParams.toString(), globalThis.location.href = l.toString();
  }, {
    captureTrackImpressionEventTargetElement: s
  } = Io({
    ga4TrackingHandler: a,
    getGa4Event: () => ({
      action: "imp",
      category: "plus",
      customized_parameters: i,
      subcategory: "masthead"
    }),
    options: {
      isSendGA4Tracking: n,
      shouldSendOnce: !0,
      shouldThrottle: !0
    }
  });
  return /* @__PURE__ */ C.createElement(Q, {
    className: e,
    onClick: o,
    ref: n ? s : null,
    "data-qa": "base"
  }, "SCMP ", /* @__PURE__ */ C.createElement("i", null, "Plus"), r && /* @__PURE__ */ C.createElement(_8, null));
}, H8 = (e) => {
  const {
    hasUnreadPlusHomePageUpdate: t
  } = E8();
  return /* @__PURE__ */ C.createElement(Ri, gn({}, e, {
    hasUnreadPlusHomePageUpdate: t,
    withUpdateIndicator: t,
    "data-qa": "with-update-indicator"
  }));
};
Mi.displayName = "ScmpPlusButton";
const Oi = ({
  className: e
}) => {
  const {
    handleTrackGA4: t
  } = q(), {
    computeGA4CommonParameters: n
  } = ye();
  return /* @__PURE__ */ C.createElement(Q, {
    className: e,
    onClick: () => {
      t({
        action: "click",
        category: "epaper",
        customized_parameters: {
          call_to_action: "read epaper",
          ...n(),
          trigger_point: "masthead"
        },
        subcategory: ""
      }), globalThis.location.href = "/epaper";
    },
    "data-qa": "epaper-button"
  }, "Read ePaper");
};
Oi.displayName = "EpaperButton";
const S8 = ({
  className: e,
  location: t = "masthead",
  variant: n
}) => {
  const {
    rosettaInstance: r
  } = q(), a = Ie(F.breakpoints.only("mobile"), !1), i = r == null ? void 0 : r.rulesEngine.getOutcome("ui.masthead.button"), o = ce(() => i == null ? void 0 : i.getDisplayVariant({
    shouldIncludeEpaper: !0,
    shouldIncludeScmpPlus: !a
  }), [a, i]), s = ce(() => o === "SCMPPLUS" ? "dark-blue" : n, [o, n]), l = () => {
    switch (o) {
      case "AUTORENEW":
        return /* @__PURE__ */ C.createElement(Li, {
          className: e
        });
      case "EPAPER":
        return /* @__PURE__ */ C.createElement(Oi, {
          className: e
        });
      case "GRACEPERIOD":
        return /* @__PURE__ */ C.createElement(qi, {
          className: e
        });
      case "REACTIVATE":
        return /* @__PURE__ */ C.createElement(Ii, {
          className: e,
          location: t
        });
      case "RENEW":
        return /* @__PURE__ */ C.createElement(Di, {
          className: e
        });
      case "SCMPPLUS": {
        const c = t === "masthead";
        return /* @__PURE__ */ C.createElement(Mi, {
          className: e,
          withImpressionTracking: c,
          withUpdateIndicator: c
        });
      }
      case "SUBSCRIBE":
        return /* @__PURE__ */ C.createElement(Bi, {
          className: e,
          location: t
        });
      case "UPGRADE":
        return /* @__PURE__ */ C.createElement(Fi, {
          className: e
        });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ C.createElement(k8, {
    $variant: s,
    "data-qa": "subscription-button"
  }, l());
};
S8.displayName = "SubscriptionButton";
const T8 = (e) => /* @__PURE__ */ d.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M12 16.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z", fill: "#EB4254", stroke: "#EB4254", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 13.5V5.25", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Z", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ d.createElement("circle", { cx: 12, cy: 17, r: 1, fill: "#EB4254" })), A8 = /* @__PURE__ */ H(Q, {
  target: "e7roqsw1"
})("display:flex;color:#eb4254;border:1px solid #eb4254;background:#fff6f7;", F.breakpoints.up("tablet"), "{border-radius:2px;}"), P8 = /* @__PURE__ */ H(T8, {
  target: "e7roqsw0"
})("inline-size:17.5px;margin-inline-end:5px;", F.breakpoints.up("tablet"), "{margin-inline-end:9px;}"), qi = ({
  className: e
}) => {
  const {
    config: t,
    handleTrackGA4: n
  } = q(), {
    computeGA4CommonParameters: r
  } = ye(), {
    captureTrackImpressionEventTargetElement: a
  } = je({
    ga4Event: $(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "update payment",
        trigger_point: "masthead grace period renewal failure banner"
      },
      subcategory: "entry_point"
    }), [r])
  });
  return /* @__PURE__ */ C.createElement(A8, {
    className: e,
    onClick: () => {
      n({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...r(),
          call_to_action: "update payment",
          trigger_point: "masthead grace period renewal failure banner"
        },
        subcategory: "entry_point"
      }), globalThis.location.href = `${t.accounts.host}/settings`;
    },
    ref: a,
    "data-qa": "grace-period-button"
  }, /* @__PURE__ */ C.createElement(P8, null), "Renewal Failed");
};
qi.displayName = "GracePeriodButton";
const Ii = ({
  className: e,
  location: t
}) => {
  const {
    config: n,
    currentPageType: r,
    handleTrackGA4: a
  } = q(), {
    computeGA4CommonParameters: i
  } = ye(), {
    captureTrackImpressionEventTargetElement: o
  } = je({
    ga4Event: $(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...i(),
        call_to_action: "reactivation",
        trigger_point: "masthead reactivation button"
      },
      subcategory: "entry_point"
    }), [i])
  });
  return /* @__PURE__ */ C.createElement(Q, {
    className: e,
    onClick: () => {
      const s = (() => {
        if (t === "masthead")
          return "masthead reactivation button";
        switch (r) {
          case ae.Article:
            return "article footer";
          case ae.Homepage:
            return "homepage footer";
          case ae.Section:
            return "section footer";
          default:
            return "footer";
        }
      })();
      a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...i(),
          call_to_action: "reactivation",
          trigger_point: s
        },
        subcategory: "entry_point"
      }), globalThis.location.href = `${n.subscribe.host}/?product=winback`;
    },
    ref: o,
    "data-qa": "reactivate-button"
  }, "Reactivate Access");
};
Ii.displayName = "ReactivateButton";
const Di = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: n
  } = q(), {
    computeGA4CommonParameters: r
  } = ye(), {
    captureTrackImpressionEventTargetElement: a,
    intersection: i
  } = je({
    ga4Event: $(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [r])
  });
  return /* @__PURE__ */ C.createElement(Q, {
    className: e,
    onClick: () => {
      var o, s;
      t({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...r(),
          call_to_action: "renew",
          trigger_point: "masthead renewal button"
        },
        subcategory: "entry_point"
      });
      const l = n == null || (o = n.rulesEngine.getOutcome("user")) === null || o === void 0 ? void 0 : o.expiryReminder, {
        bottom: c,
        left: u,
        right: f,
        top: g
      } = (s = i == null ? void 0 : i.boundingClientRect) !== null && s !== void 0 ? s : {};
      window.postMessage({
        bottom: c,
        expiryReminder: l,
        left: u,
        right: f,
        top: g,
        type: "PIANO_RENEW_POPUP"
      }, "*");
    },
    ref: a,
    "data-qa": "renew-button"
  }, "Renew & Save");
};
Di.displayName = "RenewButton";
const Bi = ({
  className: e,
  location: t
}) => {
  const {
    config: n,
    currentPageType: r,
    handleTrackGA4: a
  } = q(), {
    computeGA4CommonParameters: i
  } = ye();
  return /* @__PURE__ */ C.createElement(Q, {
    className: e,
    onClick: () => {
      a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...i(),
          call_to_action: "subscribe",
          trigger_point: (() => {
            switch (t) {
              case "footer":
                switch (r) {
                  case ae.Article:
                    return "article footer";
                  case ae.Homepage:
                    return "homepage footer";
                  case ae.Section:
                    return "section footer";
                  default:
                    return "footer";
                }
              case "masthead":
                return r === ae.Article ? "article masthead" : "masthead";
              case "print-button":
                return "print article";
            }
          })()
        },
        subcategory: "entry_point"
      }), globalThis.location.href = n.subscribe.host;
    },
    "data-qa": "subscribe-button"
  }, "Subscribe");
};
Bi.displayName = "SubscribeButton";
const Fi = ({
  className: e
}) => {
  const {
    config: t,
    currentPageType: n,
    handleTrackGA4: r
  } = q(), {
    computeGA4CommonParameters: a
  } = ye(), {
    captureTrackImpressionEventTargetElement: i
  } = je({
    ga4Event: $(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...a(),
        call_to_action: "upgrade",
        trigger_point: n === ae.Article ? "article masthead upgrade button" : "masthead"
      },
      subcategory: "entry_point"
    }), [a, n])
  });
  return /* @__PURE__ */ C.createElement(Q, {
    className: e,
    onClick: () => {
      r({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...a(),
          call_to_action: "upgrade",
          trigger_point: n === ae.Article ? "article masthead upgrade button" : "masthead"
        },
        subcategory: "entry_point"
      }), globalThis.location.href = `${t.accounts.host}/manage/subscription?upgrade=true`, window.postMessage({
        type: "PIANO_UPGRADE_POPUP"
      }, "*");
    },
    ref: i,
    "data-qa": "upgrade-button"
  }, "Upgrade & Save");
};
Fi.displayName = "UpgradeButton";
function L8(e) {
  const {
    checked: t,
    defaultChecked: n,
    disabled: r,
    onBlur: a,
    onChange: i,
    onFocus: o,
    onFocusVisible: s,
    readOnly: l,
    required: c
  } = e, [u, f] = Ss({
    controlled: t,
    default: !!n,
    name: "Switch",
    state: "checked"
  }), g = (y) => (k) => {
    var x;
    k.nativeEvent.defaultPrevented || (f(k.target.checked), i == null || i(k), (x = y.onChange) == null || x.call(y, k));
  }, [p, v] = d.useState(!1);
  r && p && v(!1);
  const m = d.useRef(null), h = (y) => (k) => {
    var x;
    m.current || (m.current = k.currentTarget), cr(k.target) && (v(!0), s == null || s(k)), o == null || o(k), (x = y.onFocus) == null || x.call(y, k);
  }, b = (y) => (k) => {
    var x;
    cr(k.target) || v(!1), a == null || a(k), (x = y.onBlur) == null || x.call(y, k);
  }, w = $e(m);
  return {
    checked: u,
    disabled: !!r,
    focusVisible: p,
    getInputProps: (y = {}) => ({
      checked: t,
      defaultChecked: n,
      disabled: r,
      readOnly: l,
      ref: w,
      required: c,
      type: "checkbox",
      role: "switch",
      "aria-checked": t,
      ...y,
      onChange: g(y),
      onFocus: h(y),
      onBlur: b(y)
    }),
    inputRef: w,
    readOnly: !!l
  };
}
const $i = "Switch";
function V8(e) {
  return Fn($i, e);
}
const re = hi($i, ["root", "input", "track", "thumb", "checked", "disabled", "focusVisible", "readOnly"]), M8 = (e) => {
  const {
    checked: t,
    disabled: n,
    focusVisible: r,
    readOnly: a
  } = e;
  return En({
    root: ["root", t && "checked", n && "disabled", r && "focusVisible", a && "readOnly"],
    thumb: ["thumb"],
    input: ["input"],
    track: ["track"]
  }, vi(V8));
}, R8 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    checked: r,
    defaultChecked: a,
    disabled: i,
    onBlur: o,
    onChange: s,
    onFocus: l,
    onFocusVisible: c,
    readOnly: u,
    required: f,
    slotProps: g = {},
    slots: p = {},
    ...v
  } = t, {
    getInputProps: m,
    checked: h,
    disabled: b,
    focusVisible: w,
    readOnly: E
  } = L8(t), y = {
    ...t,
    checked: h,
    disabled: b,
    focusVisible: w,
    readOnly: E
  }, k = M8(y), x = p.root ?? "span", _ = Re({
    elementType: x,
    externalSlotProps: g.root,
    externalForwardedProps: v,
    additionalProps: {
      ref: n
    },
    ownerState: y,
    className: k.root
  }), P = p.thumb ?? "span", A = Re({
    elementType: P,
    externalSlotProps: g.thumb,
    ownerState: y,
    className: k.thumb
  }), L = p.input ?? "input", S = Re({
    elementType: L,
    getSlotProps: m,
    externalSlotProps: g.input,
    ownerState: y,
    className: k.input
  }), V = p.track === null ? () => null : p.track ?? "span", T = Re({
    elementType: V,
    externalSlotProps: g.track,
    ownerState: y,
    className: k.track
  });
  return /* @__PURE__ */ Y.jsxs(x, {
    ..._,
    children: [/* @__PURE__ */ Y.jsx(V, {
      ...T
    }), /* @__PURE__ */ Y.jsx(P, {
      ...A
    }), /* @__PURE__ */ Y.jsx(L, {
      ...S
    })]
  });
}), O8 = /* @__PURE__ */ H("span", {
  target: "e167yolf1"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
}), c2 = /* @__PURE__ */ H(R8, {
  target: "e167yolf0"
})("position:relative;display:inline-block;&.", re.root, "{inline-size:37px;block-size:24px;}& .", re.input, "{position:absolute;inset-block-start:0;inset-inline-start:0;z-index:1;inline-size:100%;block-size:100%;margin:0;cursor:pointer;opacity:0;}& .", re.track, "{position:absolute;display:block;inline-size:100%;block-size:100%;border-radius:12px;background-color:#cccccc;}& .", re.thumb, "{position:absolute;inset-block-start:2px;inset-inline-start:2px;display:block;inline-size:20px;block-size:20px;border-radius:10px;background-color:#ffffff;transition:all 0.2s ease;}&.", re.checked, "{.", re.track, "{background-color:#4585ff;}.", re.thumb, "{inset-block-start:2px;inset-inline-start:15px;}}&.", re.disabled, "{opacity:0.4;.", re.input, "{cursor:not-allowed;}}"), q8 = ({
  label: e,
  ...t
}) => e ? /* @__PURE__ */ C.createElement(O8, null, /* @__PURE__ */ C.createElement(c2, t), e) : /* @__PURE__ */ C.createElement(c2, t);
q8.displayName = "Switch";
export {
  Fs as A,
  I2 as B,
  o9 as D,
  qi as G,
  Pi as P,
  Ii as R,
  b8 as S,
  Fi as U,
  l9 as a,
  c9 as b,
  u9 as c,
  zs as d,
  Js as e,
  r0 as f,
  u0 as g,
  wi as h,
  q8 as i,
  fr as j,
  Li as k,
  S8 as l,
  Di as m,
  Mi as n,
  x8 as o,
  Bi as p,
  s9 as u
};
//# sourceMappingURL=index-W7S9Kwji.mjs.map
